export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AnnualPno12: { input: any; output: any; }
  BaseOffer: { input: any; output: any; }
  CarKey: { input: any; output: any; }
  ConfigurationState: { input: any; output: any; }
  ContentKey: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  GoxCarKey: { input: any; output: any; }
  InferenceOutputValue: { input: any; output: any; }
  InferenceParameterValue: { input: any; output: any; }
  InferencePropertyValue: { input: any; output: any; }
  JSON: { input: any; output: any; }
  OfferConfigurationState: { input: any; output: any; }
  OfferKey: { input: any; output: any; }
  StrOrFloat: { input: any; output: any; }
};

export type AccessoryContent = ProductContent & {
  categoryPlacement?: Maybe<CategoryPlacement>;
  description?: Maybe<StringProperty>;
  disclaimer?: Maybe<StringProperty>;
  displayName?: Maybe<StringProperty>;
  group?: Maybe<GroupProperty>;
  /** @deprecated Replaced by 'images' */
  image?: Maybe<ImageProperty>;
  /** Contains a collection of images. Replaces 'image' */
  images: Array<ImageProperty>;
  shortDescription?: Maybe<StringProperty>;
  thumbnail?: Maybe<ImageProperty>;
  /** @deprecated Replaced by 'videos' */
  video?: Maybe<VideoProperty>;
  /** Contains a collection of videos. Replaces 'video' */
  videos: Array<VideoProperty>;
};

export enum Action {
  ADD = 'ADD',
  NONE = 'NONE',
  REMOVE = 'REMOVE'
}

export type AdjustedPrice = {
  adjustedDisplayPrice?: Maybe<Scalars['String']['output']>;
  adjustedPrice?: Maybe<Scalars['Float']['output']>;
  adjustments: Array<PriceAdjustment>;
};

export type Aggregations = {
  /** Aggregates totals of prices and payments */
  total?: Maybe<TotalAggregation>;
};

export type AnalyticsData = {
  likenessLevel: LikenessLevel;
  likenessMatch: Scalars['String']['output'];
  valueUnit: Scalars['String']['output'];
  windowedDataset: AnalyticsWindowedDataset;
};

export type AnalyticsDatapoint = {
  label: Scalars['String']['output'];
  memberCount: Scalars['Int']['output'];
  value: Scalars['Float']['output'];
  warning: AnalyticsDatapointWarning;
};

export enum AnalyticsDatapointWarning {
  INSUFFICIENT_DATA = 'INSUFFICIENT_DATA',
  NONE = 'NONE'
}

export enum AnalyticsLinearQueryType {
  CLASSIFIED_PRICE_PER_ODOMETER_STATUS_KM = 'CLASSIFIED_PRICE_PER_ODOMETER_STATUS_KM',
  UNKNOWN = 'UNKNOWN'
}

export enum AnalyticsLinearWindowGravity {
  HIGHEST = 'HIGHEST',
  LOWEST = 'LOWEST',
  UNKNOWN = 'UNKNOWN'
}

export type AnalyticsResult = {
  content?: Maybe<AnalyticsData>;
  delegationLog: Array<DelegationLogItem>;
  exception?: Maybe<DelegationException>;
  status: DelegationStatus;
};

export enum AnalyticsTemporalQueryType {
  CLASSIFIED_PRICE_PER_SALES_QUARTER = 'CLASSIFIED_PRICE_PER_SALES_QUARTER',
  TURNOVER_RATE_PER_SALES_MONTH = 'TURNOVER_RATE_PER_SALES_MONTH',
  UNKNOWN = 'UNKNOWN'
}

export enum AnalyticsTemporalWindowGravity {
  EARLIEST = 'EARLIEST',
  LATEST = 'LATEST',
  UNKNOWN = 'UNKNOWN'
}

export type AnalyticsWindowedDataset = {
  coverage: Coverage;
  datapoints: Array<AnalyticsDatapoint>;
};

export enum BaseColour {
  BLACK = 'BLACK',
  BLUE = 'BLUE',
  BROWN = 'BROWN',
  GRAY = 'GRAY',
  GREEN = 'GREEN',
  ORANGE = 'ORANGE',
  RED = 'RED',
  SILVER = 'SILVER',
  VIOLET = 'VIOLET',
  WHITE = 'WHITE',
  YELLOW = 'YELLOW'
}

/** Base Color Property */
export type BaseColourProperty = {
  enumDescription?: Maybe<Scalars['String']['output']>;
  formatted?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<BaseColour>;
  valueDescription?: Maybe<Scalars['String']['output']>;
};

export type Bias = {
  contexts: Array<ContextStrawberryType>;
  value: Scalars['Float']['input'];
};

export type Body = {
  alternativeCodes?: Maybe<Array<Scalars['String']['output']>>;
  carKey: Scalars['CarKey']['output'];
  co2Effect?: Maybe<Scalars['Boolean']['output']>;
  /** The unique (in this type) code for this component. */
  code: Scalars['String']['output'];
  componentBehavior?: Maybe<ComponentBehavior>;
  configurationStates?: Maybe<Array<Scalars['ConfigurationState']['output']>>;
  /** Content carries localized information about the component. */
  content?: Maybe<CarComponentContent>;
  features: Array<Feature>;
  globalName?: Maybe<Scalars['String']['output']>;
  localName?: Maybe<Scalars['String']['output']>;
  previousCarKey?: Maybe<Scalars['CarKey']['output']>;
  rootState?: Maybe<Scalars['ConfigurationState']['output']>;
  state?: Maybe<Scalars['ConfigurationState']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type: CarComponentType;
  visible?: Maybe<Scalars['Boolean']['output']>;
};


export type BodycontentArgs = {
  locale: Scalars['String']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The different feature types according to CAS */
export enum CASFeatureType {
  ASHTRAY_LID = 'ASHTRAY_LID',
  BACKGROUND = 'BACKGROUND',
  BODY = 'BODY',
  BODYKIT = 'BODYKIT',
  BUMPER = 'BUMPER',
  CARPET_KIT = 'CARPET_KIT',
  CEILING = 'CEILING',
  CEILING_MIRROR = 'CEILING_MIRROR',
  CENTER_DISPLAY = 'CENTER_DISPLAY',
  CENTER_TUNNEL_CONSOLE = 'CENTER_TUNNEL_CONSOLE',
  COLOR = 'COLOR',
  COMBI_INSTRUMENT = 'COMBI_INSTRUMENT',
  CONNECTIVITY_PANEL = 'CONNECTIVITY_PANEL',
  COUNTRY_CODE = 'COUNTRY_CODE',
  DASHBOARD = 'DASHBOARD',
  DECOR = 'DECOR',
  DECOR_SIDE_WINDOW = 'DECOR_SIDE_WINDOW',
  DOORMOULDING = 'DOORMOULDING',
  DRIVELINE = 'DRIVELINE',
  DRIVE_MODE = 'DRIVE_MODE',
  ENGINE = 'ENGINE',
  ENGINE_EMBLEM = 'ENGINE_EMBLEM',
  ENGINE_TYPE = 'ENGINE_TYPE',
  EXHAUST = 'EXHAUST',
  EXTERIOR_OPTIONS = 'EXTERIOR_OPTIONS',
  EXTERIOR_STYLING_OPTIONS = 'EXTERIOR_STYLING_OPTIONS',
  FILTER_MODEL_YEAR = 'FILTER_MODEL_YEAR',
  FOGLIGHT = 'FOGLIGHT',
  FORCE_SALES_VERSION_IN_URL = 'FORCE_SALES_VERSION_IN_URL',
  FOREGROUND = 'FOREGROUND',
  FRONT_MUD_FLAP = 'FRONT_MUD_FLAP',
  FRONT_STORAGE = 'FRONT_STORAGE',
  FUEL_PORT_CHARGING_PORT = 'FUEL_PORT_CHARGING_PORT',
  FUEL_TYPE = 'FUEL_TYPE',
  GCC_OPTIONS = 'GCC_OPTIONS',
  GEARBOX = 'GEARBOX',
  GEARLEVER = 'GEARLEVER',
  GRILLE = 'GRILLE',
  HANDLES = 'HANDLES',
  HEADLIGHTS = 'HEADLIGHTS',
  HEADLIGHT_CLEANER = 'HEADLIGHT_CLEANER',
  HEADLINING = 'HEADLINING',
  HEATED_STEERINGWHEEL = 'HEATED_STEERINGWHEEL',
  INTERIOR_ILLUMINATION = 'INTERIOR_ILLUMINATION',
  INTERIOR_STYLING_OPTIONS = 'INTERIOR_STYLING_OPTIONS',
  MARKET_CODE = 'MARKET_CODE',
  MIRROR = 'MIRROR',
  MISC = 'MISC',
  MODEL = 'MODEL',
  MODEL_YEAR = 'MODEL_YEAR',
  OPTIONS = 'OPTIONS',
  PACKAGES = 'PACKAGES',
  PADDLE = 'PADDLE',
  PNO12 = 'PNO12',
  PNO34 = 'PNO34',
  POLESTAR_ENGINEERED = 'POLESTAR_ENGINEERED',
  POWERSOCKET = 'POWERSOCKET',
  POWER_MEMORY_SEAT = 'POWER_MEMORY_SEAT',
  POWER_MEMORY_SEAT_EXTENDED = 'POWER_MEMORY_SEAT_EXTENDED',
  PRE_CONFIGURED = 'PRE_CONFIGURED',
  RAILS = 'RAILS',
  REAR_ARMREST = 'REAR_ARMREST',
  REAR_HEADREST = 'REAR_HEADREST',
  REAR_MUD_FLAP = 'REAR_MUD_FLAP',
  RIMS = 'RIMS',
  ROOF = 'ROOF',
  RUNNINGBOARD = 'RUNNINGBOARD',
  SALES_VERSION = 'SALES_VERSION',
  SEAT_ADJUSTMENT = 'SEAT_ADJUSTMENT',
  SEAT_COUNT = 'SEAT_COUNT',
  SEAT_CUSHION_EXTENSION = 'SEAT_CUSHION_EXTENSION',
  SEAT_LUMBAR_SUPPORT = 'SEAT_LUMBAR_SUPPORT',
  SENSORS = 'SENSORS',
  SKIDPLATE = 'SKIDPLATE',
  SKIDPLATE_ACCESSORY = 'SKIDPLATE_ACCESSORY',
  SOUNDSYSTEM = 'SOUNDSYSTEM',
  SPOILER = 'SPOILER',
  STANDARD_FEATURES = 'STANDARD_FEATURES',
  STARTING_POINT = 'STARTING_POINT',
  STEERINGWHEEL = 'STEERINGWHEEL',
  STEERING_TYPE = 'STEERING_TYPE',
  STRUCTURE_WEEK = 'STRUCTURE_WEEK',
  STYLE_CONFIGURATIONS = 'STYLE_CONFIGURATIONS',
  SUNROOF = 'SUNROOF',
  TOTAL_AND_DEFAULTS = 'TOTAL_AND_DEFAULTS',
  TOWBAR = 'TOWBAR',
  TRANSMISSION = 'TRANSMISSION',
  TREADPLATE = 'TREADPLATE',
  TRIMLEVEL = 'TRIMLEVEL',
  UNKNOWN = 'UNKNOWN',
  UPHOLSTERY = 'UPHOLSTERY',
  VERSION = 'VERSION',
  WASTEBIN = 'WASTEBIN',
  WHEEL_ARCHES = 'WHEEL_ARCHES',
  WINDOWS = 'WINDOWS'
}

export enum CamshaftType {
  DOHC = 'DOHC',
  SOHC = 'SOHC'
}

/** Camshaft Type Property */
export type CamshaftTypeProperty = {
  enumDescription?: Maybe<Scalars['String']['output']>;
  formatted?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<CamshaftType>;
  valueDescription?: Maybe<Scalars['String']['output']>;
};

export type Car = {
  body?: Maybe<Body>;
  btoDeliveryLeadTimeToMarket?: Maybe<DeliveryLeadTimeToMarket>;
  /** The field contains a car key which describes a current car configuration. */
  carKey: Scalars['CarKey']['output'];
  carKeyExpanded: CarKeyExpanded;
  carType?: Maybe<CarType>;
  carsByPolicy?: Maybe<CarList>;
  color?: Maybe<Colour>;
  /** @deprecated Use `color` instead */
  colour?: Maybe<Colour>;
  commercialModelYear?: Maybe<CommercialModelYear>;
  /**
   * This field is used to determine if the car is compliant with the provided company car policy
   *       (either explicitly as an argument or implicitly through the VCC Session).
   *       In order for the field to be resolved the request must be made with a session set
   *       for a user which has permission to view the company car policy.
   *       If a session is not set, or invalid, the field will be null.
   */
  companyCarPolicy?: Maybe<CompanyCarPolicy>;
  /** Configuration should be used when you want to initiate configuration on a car. However, if you already have a token, you should probably user the configurationByToken field instead. */
  configuration?: Maybe<CarConfiguration>;
  /** Initiate a configuration for this car by making it valid in this policy. */
  configurationByPolicy?: Maybe<CarConfiguration>;
  /** If you don't have a token, you should probably use configurationByPolicy instead, or just configuration (depends on your context). */
  configurationByToken: CarConfiguration;
  /** Get available direct offers for the car */
  directOfferList?: Maybe<OfferList>;
  displayName?: Maybe<Scalars['String']['output']>;
  driveline?: Maybe<Driveline>;
  edition?: Maybe<SalesLevelContent>;
  efficiencyClassification?: Maybe<EfficiencyClassification>;
  engine?: Maybe<Engine>;
  environmentalData: EnvironmentalData;
  features?: Maybe<Array<Feature>>;
  filteredFeatures: Array<Feature>;
  futureCommercialModelYears?: Maybe<Array<CommercialModelYear>>;
  gearbox?: Maybe<Gearbox>;
  globalFeatures: Array<GlobalFeature>;
  highlightedFeatures?: Maybe<Array<Feature>>;
  marketingCode: MarketingCode;
  model?: Maybe<SalesLevelContent>;
  modelFamily?: Maybe<SalesLevelContent>;
  /** MSRP price summary of the car object. Use this if you are interested in the MSRP price of the car regardless of the actual sales model. */
  msrpPriceSummary?: Maybe<MsrpPriceSummary>;
  /**
   * Get wholesale offer with default configuration for the car (pno12 and model year).
   * @deprecated Will be removed in the future. Please use 'wholesaleOfferList' instead
   */
  newWholesaleOffer?: Maybe<Offer>;
  offer?: Maybe<Offer>;
  /**
   * Get available offers for the car. This will be either direct or wholesale offers depending on the market.
   * @deprecated Will be removed in the future. Please use 'directOfferList' or 'wholesaleOfferList' instead
   */
  offerList?: Maybe<OfferList>;
  options?: Maybe<Array<Option>>;
  packages?: Maybe<Array<Package>>;
  pno?: Maybe<Pno>;
  policy?: Maybe<Scalars['String']['output']>;
  /**
   * For Vista use only! If preConfiguredCarsByPolicy is used this will return the name of the preconfigured car set in CCE Admin UI.
   * @deprecated Vista specific field, improved solution will be implemented in future releases
   */
  preConfiguredCarName?: Maybe<Scalars['String']['output']>;
  priceListDisplayName?: Maybe<Scalars['String']['output']>;
  /** Price list prices of items related to a car. Note that prices here are not final, and might be different from actual price when items is added to car configuration. */
  priceListSummary?: Maybe<CarPriceListSummary>;
  /** Price summary of the car object. This field is legacy, using OfferPriceSummary on offer object instead is preferred. */
  priceSummary?: Maybe<CarPriceSummary>;
  /** @deprecated Product lines are no longer used */
  productLine?: Maybe<SalesLevelContent>;
  sMessage?: Maybe<SMessage>;
  safetyRating?: Maybe<SafetyRating>;
  salesVersion?: Maybe<SalesVersion>;
  state?: Maybe<Scalars['ConfigurationState']['output']>;
  steering?: Maybe<Steering>;
  technicalData?: Maybe<TechnicalData>;
  theme?: Maybe<SalesLevelContent>;
  /** Transfer price summary of the car object. These prices require a valid AzureAD token with correct role to be send in auth header. */
  transferPriceSummary?: Maybe<TransferPriceSummary>;
  trim?: Maybe<SalesLevelContent>;
  trimFamily?: Maybe<SalesLevelContent>;
  /** Contains all tyre energy efficiency labels for this car */
  tyreLabels?: Maybe<Array<TyreLabel>>;
  upholstery?: Maybe<Upholstery>;
  vehicle?: Maybe<Vehicle>;
  vin: Scalars['String']['output'];
  /** The different visualization sets available. If the set of features/options passed in would produce multiple visualization sets, they are all returned. The first object in the list is usually the one you want to use. */
  visualizations?: Maybe<Array<Visualization>>;
  /** Get available wholesale offers for the car */
  wholesaleOfferList?: Maybe<OfferList>;
  /** Wholesale price summary of the car object. These prices require a valid AzureAD token with correct role to be send in auth header. */
  wholesalePriceSummary?: Maybe<WholesalePriceSummary>;
};


export type CarbtoDeliveryLeadTimeToMarketArgs = {
  locale: Scalars['String']['input'];
};


export type CarcompanyCarPolicyArgs = {
  companyCarPolicyId?: InputMaybe<Scalars['String']['input']>;
  selectedPaymentOption?: InputMaybe<SelectedPaymentOption>;
};


export type CarconfigurationArgs = {
  configurationWindow?: InputMaybe<ConfigurationWindow>;
};


export type CarconfigurationByPolicyArgs = {
  policy: Scalars['String']['input'];
};


export type CarconfigurationByTokenArgs = {
  configurationWindow?: InputMaybe<ConfigurationWindow>;
  structureWeek?: InputMaybe<Scalars['Int']['input']>;
  structureWeekStrategy?: TokenStructureWeekStrategy;
  token: Scalars['String']['input'];
};


export type CardirectOfferListArgs = {
  clientType?: Scalars['String']['input'];
  market: Scalars['String']['input'];
};


export type CardisplayNameArgs = {
  locale: Scalars['String']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CareditionArgs = {
  locale: Scalars['String']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CarfilteredFeaturesArgs = {
  includeCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type CarglobalFeaturesArgs = {
  includeAccessories?: InputMaybe<Scalars['Boolean']['input']>;
  specMarket?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type CarhighlightedFeaturesArgs = {
  locale: Scalars['String']['input'];
};


export type CarmodelArgs = {
  locale: Scalars['String']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CarmodelFamilyArgs = {
  locale: Scalars['String']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CarmsrpPriceSummaryArgs = {
  priceConfigInput?: InputMaybe<MsrpPriceConfigurationInput>;
};


export type CarnewWholesaleOfferArgs = {
  clientType?: Scalars['String']['input'];
  market: Scalars['String']['input'];
};


export type CarofferListArgs = {
  clientType?: Scalars['String']['input'];
  market: Scalars['String']['input'];
};


export type CaroptionsArgs = {
  componentBehavior?: InputMaybe<ComponentBehavior>;
  optionType?: InputMaybe<OptionType>;
};


export type CarpriceListDisplayNameArgs = {
  locale: Scalars['String']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CarpriceListSummaryArgs = {
  priceListConfigInput?: InputMaybe<PriceListConfigurationInput>;
};


export type CarpriceSummaryArgs = {
  priceConfigInput?: InputMaybe<PriceConfigurationInput>;
};


export type CarproductLineArgs = {
  locale: Scalars['String']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CarsafetyRatingArgs = {
  locale: Scalars['String']['input'];
  published?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CartechnicalDataArgs = {
  locale: Scalars['String']['input'];
};


export type CarthemeArgs = {
  locale: Scalars['String']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CartransferPriceSummaryArgs = {
  priceConfigInput?: InputMaybe<MsrpPriceConfigurationInput>;
};


export type CartrimArgs = {
  locale: Scalars['String']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CartrimFamilyArgs = {
  locale: Scalars['String']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CartyreLabelsArgs = {
  locale: Scalars['String']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  showTyreLabels?: InputMaybe<Scalars['Boolean']['input']>;
  showWinterTyreLabels?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CarvisualizationsArgs = {
  marketOrLocale: Scalars['String']['input'];
};


export type CarwholesaleOfferListArgs = {
  clientType?: Scalars['String']['input'];
  market: Scalars['String']['input'];
};


export type CarwholesalePriceSummaryArgs = {
  priceConfigInput?: InputMaybe<MsrpPriceConfigurationInput>;
};

export type CarComponent = {
  alternativeCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** The field contains a car key which describes a current car configuration. */
  carKey: Scalars['CarKey']['output'];
  co2Effect?: Maybe<Scalars['Boolean']['output']>;
  /** The unique (in this type) code for this component. */
  code: Scalars['String']['output'];
  componentBehavior?: Maybe<ComponentBehavior>;
  configurationStates?: Maybe<Array<Scalars['ConfigurationState']['output']>>;
  configurationWindow?: Maybe<ConfigurationWindow>;
  configurations?: Maybe<Array<CarConfiguration>>;
  /** Content carries localized information about the component. */
  content?: Maybe<CarComponentContent>;
  features: Array<Feature>;
  globalName?: Maybe<Scalars['String']['output']>;
  /** The different image sizes available for each icon. */
  icon?: Maybe<IconSizes>;
  /** Fields about how this component is selected on the car. E.g. if it is included as default or actively selected */
  inConfiguration?: Maybe<CarComponentConfiguration>;
  localName?: Maybe<Scalars['String']['output']>;
  partOf?: Maybe<Array<CarComponent>>;
  previousCarKey?: Maybe<Scalars['CarKey']['output']>;
  requires?: Maybe<Array<CarComponent>>;
  requiresExclusively?: Maybe<Array<Array<CarComponent>>>;
  rootState?: Maybe<Scalars['ConfigurationState']['output']>;
  /** When this component is selected, selectedVariant will show the components that uniquely identify the variant of this CarComponent that is selected. */
  selectedVariant?: Maybe<Array<CarComponent>>;
  /** The current selection state of this component */
  selectionState: CarComponentSelectionState;
  /** When this component is selected, selections will include the current selection of components that are required exclusively. E.g. what version of a package upgrade was selected */
  selections?: Maybe<Array<CarComponent>>;
  state?: Maybe<Scalars['ConfigurationState']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  /** The type of the component. */
  type: CarComponentType;
  visible?: Maybe<Scalars['Boolean']['output']>;
  /** CarComponentType is visualized. Returns null if it cannot be established that the type could be visualized or not. */
  visualized?: Maybe<Scalars['Boolean']['output']>;
};


export type CarComponentconfigurationsArgs = {
  configurationWindow?: InputMaybe<ConfigurationWindow>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type CarComponentcontentArgs = {
  locale: Scalars['String']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CarComponentvisualizedArgs = {
  marketOrLocale: Scalars['String']['input'];
};

export type CarComponentConfiguration = {
  /** Is this component in the current configuration */
  active: Scalars['Boolean']['output'];
  /** Is this component included on the starting configuration */
  included: Scalars['Boolean']['output'];
  /** Is this component actively selected by a user */
  selected: Scalars['Boolean']['output'];
};

export type CarComponentContent = {
  description?: Maybe<StringProperty>;
  displayName?: Maybe<StringProperty>;
  /** @deprecated Replaced by 'images' */
  image?: Maybe<ImageProperty>;
  /** Contains a collection of images. Replaces 'image' */
  images: Array<ImageProperty>;
  shortDescription?: Maybe<StringProperty>;
  /** @deprecated Replaced by 'videos' */
  video?: Maybe<VideoProperty>;
  /** Contains a collection of videos. Replaces 'video' */
  videos: Array<VideoProperty>;
};

export type CarComponentSelectionState = {
  /** The action that will affect the component from current state, ADD, REMOVE or NONE */
  action: Action;
  /** Is this component in the current configuration */
  selected: Scalars['Boolean']['output'];
  /** Is this component actively selected by a user */
  userSelected: Scalars['Boolean']['output'];
};

export enum CarComponentType {
  BODY = 'BODY',
  COLOR = 'COLOR',
  DRIVELINE = 'DRIVELINE',
  ENGINE = 'ENGINE',
  FEATURE = 'FEATURE',
  GEARBOX = 'GEARBOX',
  MARKETING_CODE = 'MARKETING_CODE',
  MODEL_YEAR = 'MODEL_YEAR',
  /** @deprecated Offer configuration on car not supported */
  OFFER = 'OFFER',
  OPTION = 'OPTION',
  PACKAGE = 'PACKAGE',
  PNO3 = 'PNO3',
  SALES_VERSION = 'SALES_VERSION',
  SPEC_MARKET = 'SPEC_MARKET',
  STEERING = 'STEERING',
  STRUCTURE_WEEK = 'STRUCTURE_WEEK',
  S_MESSAGE = 'S_MESSAGE',
  UPHOLSTERY = 'UPHOLSTERY'
}

export type CarConfiguration = {
  /** Does the current configuration include components that this configuration selects. If true, selection this configuration will remove those components. */
  active: Scalars['Boolean']['output'];
  appliedChange?: Maybe<RequiredChange>;
  car?: Maybe<Car>;
  carKey?: Maybe<Scalars['CarKey']['output']>;
  changePno12: CarProductChange;
  changePolicy: CarProductChange;
  changeWeek: CarProductChange;
  components: Array<CarComponent>;
  defaultCar?: Maybe<Car>;
  /** @deprecated Use bubbleUpErrors argument to let errors bubble up to the root instead. */
  errors?: Maybe<Array<ConfigurationError>>;
  offerKey?: Maybe<Scalars['OfferKey']['output']>;
  rootState?: Maybe<Scalars['ConfigurationState']['output']>;
  state?: Maybe<Scalars['ConfigurationState']['output']>;
  token?: Maybe<ConfigurationToken>;
};


export type CarConfigurationchangePno12Args = {
  modelYear: Scalars['Int']['input'];
  pno12: Scalars['String']['input'];
};


export type CarConfigurationchangePolicyArgs = {
  policy: Scalars['String']['input'];
};


export type CarConfigurationchangeWeekArgs = {
  structureWeek: Scalars['Int']['input'];
};


export type CarConfigurationcomponentsArgs = {
  componentBehavior?: InputMaybe<ComponentBehavior>;
  sorted?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<ComponentTag>>;
  type?: InputMaybe<CarComponentType>;
  types?: InputMaybe<Array<CarComponentType>>;
};

export type CarKeyEnhancedDataSet = {
  data: Dataset;
  filterValues: Array<FilterValues>;
  similarTo: Array<CarKeySimilarityMeasurements>;
};


export type CarKeyEnhancedDataSetfilterValuesArgs = {
  filterNames: Array<FilterName>;
};


export type CarKeyEnhancedDataSetsimilarToArgs = {
  biases?: InputMaybe<Array<Bias>>;
  carKeys: Array<CarKeyInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Expanded carKey */
export type CarKeyExpanded = {
  body: Scalars['String']['output'];
  carType: Scalars['String']['output'];
  color?: Maybe<Scalars['String']['output']>;
  engine: Scalars['String']['output'];
  gearbox: Scalars['String']['output'];
  marketingCode: Scalars['String']['output'];
  modelYear: Scalars['Int']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
  packages?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use carType instead of pno3. */
  pno3: Scalars['String']['output'];
  sMessage?: Maybe<Scalars['String']['output']>;
  salesVersion: Scalars['String']['output'];
  specMarket: Scalars['String']['output'];
  steering: Scalars['String']['output'];
  structureWeek: Scalars['Int']['output'];
  upholstery?: Maybe<Scalars['String']['output']>;
};

export type CarKeyInput = {
  body: Scalars['String']['input'];
  carType?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  engine: Scalars['String']['input'];
  gearbox: Scalars['String']['input'];
  marketingCode: Scalars['String']['input'];
  modelYear: Scalars['Float']['input'];
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  packages?: InputMaybe<Array<Scalars['String']['input']>>;
  sMessage?: InputMaybe<Scalars['String']['input']>;
  salesVersion: Scalars['String']['input'];
  specMarket: Scalars['String']['input'];
  steering: Scalars['String']['input'];
  structureWeek: Scalars['Float']['input'];
  upholstery?: InputMaybe<Scalars['String']['input']>;
};

export type CarKeySimilarityMeasurements = {
  inputCar: MarsCarKey;
  measurements: Array<Measurements>;
};

export type CarKeySummaryParams = {
  identifyAs?: InputMaybe<Scalars['String']['input']>;
};

export type CarList = {
  cars: Array<Car>;
  first?: Maybe<Car>;
  groupBy: Array<GroupedCarList>;
  selected?: Maybe<Car>;
  sortedOnPrice: CarList;
};


export type CarListgroupByArgs = {
  disableSorting?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterOnSelected?: InputMaybe<Scalars['Boolean']['input']>;
  groupType?: InputMaybe<CarListGroupingType>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type CarListsortedOnPriceArgs = {
  priceConfigInput?: InputMaybe<PriceConfigurationInput>;
  sortMissingPriceAs: NullSortingStrategy;
};

export enum CarListGroupingType {
  BODY = 'BODY',
  CAR_TYPE = 'CAR_TYPE',
  COLOR = 'COLOR',
  COMMERCIAL_MODEL_YEAR = 'COMMERCIAL_MODEL_YEAR',
  DRIVE_TRAIN = 'DRIVE_TRAIN',
  DRIVE_TYPE = 'DRIVE_TYPE',
  EDITION = 'EDITION',
  ENGINE = 'ENGINE',
  ENGINE_TYPE = 'ENGINE_TYPE',
  FUEL_TYPE = 'FUEL_TYPE',
  GEARBOX = 'GEARBOX',
  MARKETING_CODE = 'MARKETING_CODE',
  MODEL = 'MODEL',
  MODEL_CATEGORY = 'MODEL_CATEGORY',
  MODEL_FAMILY = 'MODEL_FAMILY',
  MODEL_YEAR = 'MODEL_YEAR',
  NUMBER_OF_SEATS = 'NUMBER_OF_SEATS',
  /** @deprecated Use CAR_TYPE instead */
  PNO3 = 'PNO3',
  /** PNO12 */
  PRODUCT_CODE = 'PRODUCT_CODE',
  PRODUCT_LINE = 'PRODUCT_LINE',
  SALES_VERSION = 'SALES_VERSION',
  SPEC_MARKET = 'SPEC_MARKET',
  STEERING = 'STEERING',
  STRUCTURE_WEEK = 'STRUCTURE_WEEK',
  S_MESSAGE = 'S_MESSAGE',
  THEME = 'THEME',
  TRANSMISSION_TYPE = 'TRANSMISSION_TYPE',
  TRIM = 'TRIM',
  TRIM_FAMILY = 'TRIM_FAMILY',
  UPHOLSTERY = 'UPHOLSTERY'
}

export type CarMileagePrice = {
  active: Scalars['Boolean']['output'];
  default: Scalars['Boolean']['output'];
  /** maximum allowed driving distance for subscription. * Expressed in Kilometers (Km) or Miles depending on the market */
  mileage?: Maybe<PriceMileageUnit>;
  /** maximum allowed driving distance for subscription per month. * Expressed in Kilometers (Km) or Miles depending on the market */
  mileagePerMonth?: Maybe<PriceMileageUnit>;
  price?: Maybe<PriceAmount>;
  /** Price relative the default mileage */
  relativeDefaultPrice?: Maybe<PriceAmount>;
  /** Price relative the currently selected mileage */
  relativePrice?: Maybe<PriceAmount>;
};

/** Price breakdown for a given car by component types. */
export type CarPriceBreakdown = {
  all?: Maybe<Array<ComponentPriceSummary>>;
  baseCar?: Maybe<ComponentPriceSummary>;
  /** @deprecated Will not be available soon, use price on CarPriceSummary instead */
  car?: Maybe<CarPriceBreakdownSummary>;
  color?: Maybe<ComponentPriceSummary>;
  options?: Maybe<Array<ComponentPriceSummary>>;
  packages?: Maybe<Array<ComponentPriceSummary>>;
  upholstery?: Maybe<ComponentPriceSummary>;
};

export type CarPriceBreakdownSummary = {
  afterCheckout?: Maybe<PriceAmount>;
  afterCheckoutVatAmount?: Maybe<PriceAmount>;
  afterCheckoutWithoutTax?: Maybe<PriceAmount>;
};

export type CarPriceContractDetails = {
  /** Length for the subscription period. Expressed in Months.* (Installments per year is 12 as default) */
  contractLength?: Maybe<Scalars['Float']['output']>;
  /** Actual downpayment input value that was used in calculation */
  downpayment?: Maybe<Scalars['Float']['output']>;
  /** maximum allowed driving distance for subscription. * Expressed in Kilometers (Km) or Miles depending on the market */
  mileage?: Maybe<PriceMileageUnit>;
  /** maximum allowed driving distance for subscription per month. * Expressed in Kilometers (Km) or Miles depending on the market */
  mileagePerMonth?: Maybe<PriceMileageUnit>;
};

export type CarPriceFields = {
  dueTodayInclTax?: Maybe<PriceAmount>;
  dueTodayInclTaxExclVat?: Maybe<PriceAmount>;
  dueTodayVatAmount?: Maybe<PriceAmount>;
  /** @deprecated Use 'priceExclTax' instead with input sales model 'wholesale' */
  msrpPriceExclTax?: Maybe<PriceAmount>;
  /** @deprecated Use 'priceExclTaxInclVat' instead with input sales model 'wholesale' */
  msrpPriceExclTaxInclVat?: Maybe<PriceAmount>;
  /** @deprecated Use 'priceInclTax' instead with input sales model 'wholesale' */
  msrpPriceInclTax?: Maybe<PriceAmount>;
  /** Price of the car excluding all taxes */
  priceExclTax?: Maybe<PriceAmount>;
  /** Price of the car including only VAT tax */
  priceExclTaxInclVat?: Maybe<PriceAmount>;
  /** Price of the car including all taxes */
  priceInclTax?: Maybe<PriceAmount>;
  /** Price of the car including taxes except VAT */
  priceInclTaxExclVat?: Maybe<PriceAmount>;
  /** Group relative price the car. That is the relative price in relation to other cars in the same group. Null if group is unspecified. */
  relativeGroup?: Maybe<PriceAmount>;
  relativeGroupPriceExclTax?: Maybe<PriceAmount>;
  relativeGroupPriceExclTaxInclVat?: Maybe<PriceAmount>;
  relativeGroupPriceInclTax?: Maybe<PriceAmount>;
  relativeGroupPriceInclTaxExclVat?: Maybe<PriceAmount>;
  /** @deprecated Use 'priceInclTax' instead */
  standardTransactionPriceInclTax?: Maybe<PriceAmount>;
  /** @deprecated Use 'priceInclTaxExclVat' instead */
  standardTransactionPriceInclTaxExclVat?: Maybe<PriceAmount>;
  /** @deprecated Use 'priceInclTax' instead */
  subscriptionPriceInclTax?: Maybe<PriceAmount>;
  /** @deprecated Use 'priceInclTaxExclVat' instead */
  subscriptionPriceInclTaxExclVat?: Maybe<PriceAmount>;
  /** @deprecated Use 'vatAmount' instead */
  subscriptionVatAmount?: Maybe<PriceAmount>;
  /** Vat amount of the car */
  vatAmount?: Maybe<PriceAmount>;
};

export type CarPriceListMileagePrice = {
  /** Length for the subscription period. Expressed in Months.* (Installments per year is 12 as default) */
  contractLength?: Maybe<Scalars['Float']['output']>;
  /** Maximum allowed driving distance for subscription. * Expressed in Kilometers (Km) or Miles depending on the market */
  mileage?: Maybe<Scalars['Float']['output']>;
  /** Mileage price list price */
  price?: Maybe<PricePoint>;
};

export type CarPriceListSummary = {
  /** Mileage price list prices of the car */
  mileagePrices?: Maybe<Array<CarPriceListMileagePrice>>;
};

export type CarPriceSummary = {
  /** All prices of the car */
  all?: Maybe<CarPriceFields>;
  availableDownpayments?: Maybe<Array<PriceAmount>>;
  /** Price breakdown of the car, to get the pricing for the individual components of it. */
  breakDown?: Maybe<CarPriceBreakdown>;
  /** Price of the car, temporary field, prices should be taken from the offer when possible. */
  carPrice?: Maybe<OfferCarPrice>;
  /** Contract details such as contract length and mileage, applicable for monthly sales models */
  contractDetails?: Maybe<CarPriceContractDetails>;
  /** The total discount of the purchase */
  discounts?: Maybe<Discounts>;
  /** How much the price have been adjusted due to downpayment */
  downpaymentAdjustment?: Maybe<PriceAmount>;
  /** Due today amount */
  dueToday?: Maybe<PriceAmount>;
  /** Due today amount without vat, nil if same as dueToday */
  dueTodayWithoutVat?: Maybe<PriceAmount>;
  /** Non car products of the car. */
  nonCarProducts?: Maybe<Array<TransactionPriceTax>>;
  /** Totalprice of the purchase */
  price?: Maybe<PriceAmount>;
  /** Totalprice of the purchase without tax, nil if same as price */
  priceWithoutTax?: Maybe<PriceAmount>;
  /** @deprecated Use corresponding fields from 'Offer' object instead */
  salesModelMetadata?: Maybe<CarSalesModelMetadata>;
  /** The subscription alternatives available */
  subscriptionPrices?: Maybe<Array<CarSubscriptionPrice>>;
  /** All taxes that applies to the car. */
  taxes?: Maybe<CarPriceTaxes>;
  /** Total price of the car */
  totalPrice?: Maybe<PriceAmount>;
  /** Total price of the car without tax, nil if same as total price */
  totalPriceWithoutTax?: Maybe<PriceAmount>;
  /** Transaction base taxes */
  transactionBaseTaxes?: Maybe<Array<TransactionPriceTax>>;
};

export type CarPriceSummaryResult = {
  content?: Maybe<CarPriceSummary>;
  delegationLog: Array<DelegationLogItem>;
  exception?: Maybe<DelegationException>;
  status: DelegationStatus;
};

export type CarPriceTax = {
  frequency?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<PriceAmount>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  taxId?: Maybe<Scalars['Float']['output']>;
  taxType?: Maybe<Scalars['String']['output']>;
  taxVersionId?: Maybe<Scalars['Float']['output']>;
  vatPosition?: Maybe<Scalars['String']['output']>;
  vatRate?: Maybe<Scalars['Float']['output']>;
};

export type CarPriceTaxes = {
  acquisition?: Maybe<Array<CarPriceTax>>;
  all?: Maybe<Array<CarPriceTax>>;
  informational?: Maybe<Array<CarPriceTax>>;
  ownership?: Maybe<Array<CarPriceTax>>;
};

export type CarPriceVisibility = {
  carPriced: Scalars['Boolean']['output'];
  componentPriced: Scalars['Boolean']['output'];
  visible: Scalars['Boolean']['output'];
};

export type CarProductChange = {
  appliedChange?: Maybe<RequiredChange>;
  token?: Maybe<ConfigurationToken>;
};

export type CarSalesModelMetadata = {
  /** @deprecated Use Offer.salesModel.content.shortDescription instead */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The localized full description of the sales model.
   * @deprecated Use Offer.salesModel.content.description instead
   */
  fullDescription?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use Offer.salesModel.content.displayName instead */
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use Offer.products.services and Offer.products.packages instead */
  offers?: Maybe<Array<CarSalesModelMetadataOffer>>;
};

export type CarSalesModelMetadataOffer = {
  /**
   * The localized short description of the offer.
   * @deprecated Use Product.content.shortDescription instead
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The localized full description of the offer.
   * @deprecated Use Product.content.description instead
   */
  fullDescription?: Maybe<Scalars['String']['output']>;
  /**
   * The identifier of the offer. Example: "Insurance"
   * @deprecated Use Product.id instead
   */
  id?: Maybe<Scalars['String']['output']>;
  /**
   * The image url of the offer.
   * @deprecated Use Product.content.images or Product.content.thumbnail instead
   */
  image?: Maybe<Scalars['String']['output']>;
  /**
   * The localized name of the offer.
   * @deprecated Use Product.content.displayName instead
   */
  name?: Maybe<Scalars['String']['output']>;
};

export type CarSubscriptionPrice = {
  active: Scalars['Boolean']['output'];
  /** Length for the subscription period. Expressed in Months.* (Installments per year is 12 as default) */
  contractLength?: Maybe<Scalars['Float']['output']>;
  default: Scalars['Boolean']['output'];
  /** The driving mileages available given the contract length */
  mileages?: Maybe<Array<CarMileagePrice>>;
  price?: Maybe<PriceAmount>;
  /** Relative price for the contract length */
  relativePrice?: Maybe<PriceAmount>;
};

export type CarType = {
  alternativeCodes?: Maybe<Array<Scalars['String']['output']>>;
  carKey: Scalars['CarKey']['output'];
  co2Effect?: Maybe<Scalars['Boolean']['output']>;
  /** The unique (in this type) code for this component. */
  code: Scalars['String']['output'];
  componentBehavior?: Maybe<ComponentBehavior>;
  configurationStates?: Maybe<Array<Scalars['ConfigurationState']['output']>>;
  content?: Maybe<CarTypeContent>;
  features: Array<Feature>;
  globalName?: Maybe<Scalars['String']['output']>;
  localName?: Maybe<Scalars['String']['output']>;
  previousCarKey?: Maybe<Scalars['CarKey']['output']>;
  rootState?: Maybe<Scalars['ConfigurationState']['output']>;
  state?: Maybe<Scalars['ConfigurationState']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type: CarComponentType;
  visible?: Maybe<Scalars['Boolean']['output']>;
};


export type CarTypecontentArgs = {
  locale: Scalars['String']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CarTypeCategory {
  CROSSOVER = 'CROSSOVER',
  ESTATE = 'ESTATE',
  MPV = 'MPV',
  SEDAN = 'SEDAN',
  SUV = 'SUV'
}

/** Car Category Property */
export type CarTypeCategoryProperty = {
  enumDescription?: Maybe<Scalars['String']['output']>;
  formatted?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<CarTypeCategory>;
  valueDescription?: Maybe<Scalars['String']['output']>;
};

export type CarTypeContent = {
  carTypeCategory?: Maybe<CarTypeCategoryProperty>;
  description?: Maybe<StringProperty>;
  displayName?: Maybe<StringProperty>;
  entityType?: Maybe<UpstreamEntityTypeProperty>;
  /** @deprecated Replaced by 'images' */
  image?: Maybe<ImageProperty>;
  /** Contains a collection of images. Replaces 'image' */
  images: Array<ImageProperty>;
  meta?: Maybe<SystemMeta>;
  modelCode: Scalars['String']['output'];
  seatCapacity?: Maybe<IntProperty>;
  shortDescription?: Maybe<StringProperty>;
  shortName?: Maybe<StringProperty>;
  /** @deprecated Replaced by 'videos' */
  video?: Maybe<VideoProperty>;
  /** Contains a collection of videos. Replaces 'video' */
  videos: Array<VideoProperty>;
};

export type CarTypeResult = {
  content?: Maybe<CarTypeContent>;
  delegationLog: Array<DelegationLogItem>;
  exception?: Maybe<DelegationException>;
  status: DelegationStatus;
};

export type CarVisibility = {
  baseCarKey: Scalars['CarKey']['output'];
  carKey: Scalars['CarKey']['output'];
  price: CarPriceVisibility;
};


export type CarVisibilitypriceArgs = {
  priceConfigurationInput?: InputMaybe<PriceConfigurationInput>;
};

export type CategoryContent = {
  description?: Maybe<StringProperty>;
  displayName?: Maybe<StringProperty>;
  entityType?: Maybe<UpstreamEntityTypeProperty>;
  /** @deprecated Replaced by 'images' */
  image?: Maybe<ImageProperty>;
  /** Contains a collection of images. Replaces 'image' */
  images: Array<ImageProperty>;
  key: Scalars['String']['output'];
  shortDescription?: Maybe<StringProperty>;
  sortOrder?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Replaced by 'videos' */
  video?: Maybe<VideoProperty>;
  /** Contains a collection of videos. Replaces 'video' */
  videos: Array<VideoProperty>;
};

export type CategoryPlacement = {
  path?: Maybe<Array<CategoryContent>>;
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

export type CocCertificate = {
  addressType?: Maybe<Scalars['String']['output']>;
  allowedEuropeanMarketIndicator?: Maybe<Scalars['String']['output']>;
  approvalMarkCouplingDevice?: Maybe<Scalars['String']['output']>;
  approvalTypeCode?: Maybe<Scalars['String']['output']>;
  arrangementOfCylinders?: Maybe<Scalars['String']['output']>;
  atctFamilyIdentifier?: Maybe<Scalars['String']['output']>;
  axleSpacing12?: Maybe<Scalars['Int']['output']>;
  axleTrackFront?: Maybe<Scalars['Int']['output']>;
  axleTrackRear?: Maybe<Scalars['Int']['output']>;
  cappedSpeed?: Maybe<Scalars['String']['output']>;
  carOnLineDate?: Maybe<Scalars['Int']['output']>;
  classOfHybridElectricVehicle?: Maybe<Scalars['String']['output']>;
  clutchType?: Maybe<Scalars['String']['output']>;
  co2Combined?: Maybe<Scalars['String']['output']>;
  co2DeterminationTyreIndicatorFront?: Maybe<Scalars['String']['output']>;
  co2DeterminationTyreIndicatorRear?: Maybe<Scalars['String']['output']>;
  co2EmissionCombinedFuel1?: Maybe<Scalars['Int']['output']>;
  co2EmissionCombinedFuel2?: Maybe<Scalars['Int']['output']>;
  co2EmissionExUrbanFuel1?: Maybe<Scalars['Int']['output']>;
  co2EmissionExUrbanFuel2?: Maybe<Scalars['Int']['output']>;
  co2EmissionUrbanFuel1?: Maybe<Scalars['Int']['output']>;
  co2EmissionUrbanFuel2?: Maybe<Scalars['Int']['output']>;
  co2EmissionWeightedCombinedFuel1?: Maybe<Scalars['Int']['output']>;
  co2EmissionWeightedCombinedFuel2?: Maybe<Scalars['Int']['output']>;
  co2ExUrban?: Maybe<Scalars['String']['output']>;
  co2Urban?: Maybe<Scalars['String']['output']>;
  colourOfVehicle?: Maybe<Scalars['String']['output']>;
  combinedCo2Emissions?: Maybe<Scalars['Int']['output']>;
  combinedFuelConsumption?: Maybe<Scalars['Float']['output']>;
  completeRealDrivingEmissionsTripNox?: Maybe<Scalars['Float']['output']>;
  completeRealDrivingEmissionsTripParticles?: Maybe<Scalars['Float']['output']>;
  completeRealDrivingEmissionsTripParticlesExponent?: Maybe<Scalars['String']['output']>;
  configurationOfDoors?: Maybe<Scalars['String']['output']>;
  continuouslyVariableTransmission?: Maybe<Scalars['String']['output']>;
  descriptionOfBreakingDevice?: Maybe<Scalars['String']['output']>;
  deviationFactor?: Maybe<Scalars['String']['output']>;
  diffLock?: Maybe<Scalars['String']['output']>;
  directInjection?: Maybe<Scalars['String']['output']>;
  distributionAxleFront?: Maybe<Scalars['Int']['output']>;
  distributionAxleRear?: Maybe<Scalars['Int']['output']>;
  downscalingFactor?: Maybe<Scalars['String']['output']>;
  drivingCycleClass?: Maybe<Scalars['String']['output']>;
  duplicateCode?: Maybe<Scalars['String']['output']>;
  electricEnergyConsumption?: Maybe<Scalars['Int']['output']>;
  electricEnergyConsumptionEcacWeighted?: Maybe<Scalars['Int']['output']>;
  electricEnergyConsumptionWltp?: Maybe<Scalars['Int']['output']>;
  electricRange?: Maybe<Scalars['Int']['output']>;
  electricRangeCity?: Maybe<Scalars['Int']['output']>;
  electricRangeCityEaer?: Maybe<Scalars['Int']['output']>;
  electricRangeEaer?: Maybe<Scalars['Int']['output']>;
  electricRangeWltp?: Maybe<Scalars['Int']['output']>;
  emissionConsumptionApproval?: Maybe<Scalars['String']['output']>;
  endOfSeriesDate?: Maybe<Scalars['Int']['output']>;
  engineCapacity?: Maybe<Scalars['Int']['output']>;
  engineCode?: Maybe<Scalars['String']['output']>;
  engineManufacturer?: Maybe<Scalars['String']['output']>;
  evaporativeTestFamilyIdentifier?: Maybe<Scalars['String']['output']>;
  exemptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exhaustEmission?: Maybe<Scalars['String']['output']>;
  exhaustEmissionCo?: Maybe<Scalars['Float']['output']>;
  exhaustEmissionCo2?: Maybe<Scalars['Float']['output']>;
  exhaustEmissionCo2HcNo?: Maybe<Scalars['Float']['output']>;
  exhaustEmissionHc?: Maybe<Scalars['Float']['output']>;
  exhaustEmissionLevel?: Maybe<Scalars['String']['output']>;
  exhaustEmissionNox?: Maybe<Scalars['Float']['output']>;
  exhaustEmissionParticulates?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionCoFuel1?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionCoFuel2?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionNmhcFuel1?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionNmhcFuel2?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionNoxFuel1?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionNoxFuel2?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionParticlesExponentFuel1?: Maybe<Scalars['String']['output']>;
  exhaustFuelEmissionParticlesExponentFuel2?: Maybe<Scalars['String']['output']>;
  exhaustFuelEmissionParticlesFuel1?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionParticlesFuel2?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionParticulatesMgFuel1?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionParticulatesMgFuel2?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionThcFuel1?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionThcFuel2?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionThcNoxFuel1?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionThcNoxFuel2?: Maybe<Scalars['Float']['output']>;
  extraHighCo2Emissions?: Maybe<Scalars['Int']['output']>;
  extraHighFuelConsumption?: Maybe<Scalars['Float']['output']>;
  finalDriveRatio?: Maybe<Scalars['Float']['output']>;
  finalDriveRatioContinued?: Maybe<Scalars['String']['output']>;
  finalDriveRatios?: Maybe<Scalars['String']['output']>;
  frontalArea?: Maybe<Scalars['Float']['output']>;
  fuel1?: Maybe<Scalars['String']['output']>;
  fuel2?: Maybe<Scalars['String']['output']>;
  fuelCode?: Maybe<Scalars['Int']['output']>;
  fuelConsumptionCombined?: Maybe<Scalars['Float']['output']>;
  fuelConsumptionCombinedFuel1?: Maybe<Scalars['Float']['output']>;
  fuelConsumptionCombinedFuel2?: Maybe<Scalars['Float']['output']>;
  fuelConsumptionExUrban?: Maybe<Scalars['Float']['output']>;
  fuelConsumptionExUrbanFuel1?: Maybe<Scalars['Float']['output']>;
  fuelConsumptionExUrbanFuel2?: Maybe<Scalars['Float']['output']>;
  fuelConsumptionUrban?: Maybe<Scalars['Float']['output']>;
  fuelConsumptionUrbanFuel1?: Maybe<Scalars['Float']['output']>;
  fuelConsumptionUrbanFuel2?: Maybe<Scalars['Float']['output']>;
  fuelConsumptionWeightedCombinedFuel1?: Maybe<Scalars['Float']['output']>;
  fuelConsumptionWeightedCombinedFuel2?: Maybe<Scalars['Float']['output']>;
  fuelPrinciple?: Maybe<Scalars['String']['output']>;
  fuelType?: Maybe<Scalars['String']['output']>;
  fyon?: Maybe<Scalars['Int']['output']>;
  gasCh4?: Maybe<Scalars['String']['output']>;
  gasCo?: Maybe<Scalars['String']['output']>;
  gasCo2Combined?: Maybe<Scalars['String']['output']>;
  gasCo2ExUrban?: Maybe<Scalars['String']['output']>;
  gasCo2Urban?: Maybe<Scalars['String']['output']>;
  gasFuelConsumptionCombined?: Maybe<Scalars['String']['output']>;
  gasFuelConsumptionExUrban?: Maybe<Scalars['String']['output']>;
  gasFuelConsumptionUrban?: Maybe<Scalars['String']['output']>;
  gasNmhc?: Maybe<Scalars['String']['output']>;
  gasNox?: Maybe<Scalars['String']['output']>;
  gasThc?: Maybe<Scalars['String']['output']>;
  gearRatio1?: Maybe<Scalars['Float']['output']>;
  gearRatio2?: Maybe<Scalars['Float']['output']>;
  gearRatio3?: Maybe<Scalars['Float']['output']>;
  gearRatio4?: Maybe<Scalars['Float']['output']>;
  gearRatio5?: Maybe<Scalars['Float']['output']>;
  gearRatio6?: Maybe<Scalars['Float']['output']>;
  gearRatio7?: Maybe<Scalars['Float']['output']>;
  gearRatio8?: Maybe<Scalars['Float']['output']>;
  gearRatioReverse?: Maybe<Scalars['Float']['output']>;
  gearboxType?: Maybe<Scalars['String']['output']>;
  gearboxTypeCode?: Maybe<Scalars['String']['output']>;
  gearboxesType?: Maybe<Scalars['String']['output']>;
  generalCodeOfEcoInnovations?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  highCo2Emissions?: Maybe<Scalars['Int']['output']>;
  highFuelConsumption?: Maybe<Scalars['Float']['output']>;
  hybridVehicle?: Maybe<Scalars['String']['output']>;
  informationStatus?: Maybe<Scalars['String']['output']>;
  initialCountryOfRegistration?: Maybe<Scalars['String']['output']>;
  interpolationFamilyIdentifier?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  leftRightTraffic?: Maybe<Scalars['Int']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  loadOnCouplingPoint?: Maybe<Scalars['Int']['output']>;
  locationOfPlates?: Maybe<Scalars['String']['output']>;
  locationOfStatutoryPlates?: Maybe<Scalars['String']['output']>;
  locationOfTheVinCode?: Maybe<Scalars['String']['output']>;
  locationVehicleId?: Maybe<Scalars['String']['output']>;
  lowCo2Emissions?: Maybe<Scalars['Int']['output']>;
  lowFuelConsumption?: Maybe<Scalars['Float']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  massAxleFront?: Maybe<Scalars['Int']['output']>;
  massAxleRear?: Maybe<Scalars['Int']['output']>;
  massInRunningOrder?: Maybe<Scalars['Int']['output']>;
  massOfBrakedTrailer?: Maybe<Scalars['Int']['output']>;
  massOfCombination?: Maybe<Scalars['Int']['output']>;
  massOfUnbrakedTrailer?: Maybe<Scalars['Int']['output']>;
  massOfVehicle?: Maybe<Scalars['Int']['output']>;
  massOfVehicleRunningOrder?: Maybe<Scalars['Int']['output']>;
  max30MinutesPower?: Maybe<Scalars['Int']['output']>;
  max30MinutesPower2?: Maybe<Scalars['Int']['output']>;
  maxContinuedRatedPower?: Maybe<Scalars['Int']['output']>;
  maxContinuedRatedPower2?: Maybe<Scalars['Int']['output']>;
  maxHourlyOutput?: Maybe<Scalars['Int']['output']>;
  maxHourlyOutput2?: Maybe<Scalars['Int']['output']>;
  maxLadenMass?: Maybe<Scalars['Int']['output']>;
  maxMassBrakedCenterAxleTrailer?: Maybe<Scalars['Int']['output']>;
  maxMassBrakedDrawbarTrailer?: Maybe<Scalars['Int']['output']>;
  maxNetPower?: Maybe<Scalars['String']['output']>;
  maxNetPowerRpm?: Maybe<Scalars['Int']['output']>;
  maxSpeed?: Maybe<Scalars['Int']['output']>;
  maximum30MinutesPowerIsg?: Maybe<Scalars['Int']['output']>;
  maximumHourlyOutputIsg?: Maybe<Scalars['Int']['output']>;
  maximumNetPowerIsg?: Maybe<Scalars['Int']['output']>;
  mediumCo2Emissions?: Maybe<Scalars['Int']['output']>;
  mediumFuelConsumption?: Maybe<Scalars['Float']['output']>;
  metricImperialSpeedometer?: Maybe<Scalars['String']['output']>;
  nameAndAddressManufacturing1?: Maybe<Scalars['String']['output']>;
  nameAndAddressManufacturing2?: Maybe<Scalars['String']['output']>;
  nameAndAddressManufacturing3?: Maybe<Scalars['String']['output']>;
  nameAndAddressManufacturing4?: Maybe<Scalars['String']['output']>;
  nedcSavingsGramsPerKm?: Maybe<Scalars['Float']['output']>;
  numberAndArrangementOfCylinders?: Maybe<Scalars['String']['output']>;
  numberAndConfigurationOfDoors?: Maybe<Scalars['String']['output']>;
  numberAndPositionOfSeats?: Maybe<Scalars['String']['output']>;
  numberOfAxles?: Maybe<Scalars['Int']['output']>;
  numberOfPrintouts?: Maybe<Scalars['Int']['output']>;
  numberOfSeats?: Maybe<Scalars['String']['output']>;
  numberOfSmallSeriesCars?: Maybe<Scalars['Int']['output']>;
  numberOfWheels?: Maybe<Scalars['Int']['output']>;
  pemsFamilyIdentifier?: Maybe<Scalars['String']['output']>;
  periodicRegenerationFamilyIdentifier?: Maybe<Scalars['String']['output']>;
  poweredAxles?: Maybe<Scalars['Int']['output']>;
  poweredAxlesInterconnection?: Maybe<Scalars['String']['output']>;
  poweredAxlesPosition?: Maybe<Scalars['String']['output']>;
  primaryColourCode?: Maybe<Scalars['Int']['output']>;
  pureElectric?: Maybe<Scalars['String']['output']>;
  rearOverhang?: Maybe<Scalars['Int']['output']>;
  remarks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  remarks2?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  revsSoundLevelStationary?: Maybe<Scalars['Int']['output']>;
  rightLeftHandTrafficCode?: Maybe<Scalars['String']['output']>;
  roadLoadCoefficients?: Maybe<Scalars['Float']['output']>;
  roadLoadCoefficients2?: Maybe<Scalars['Float']['output']>;
  roadLoadCoefficients3?: Maybe<Scalars['Float']['output']>;
  roadloadsFamilyIdentifier?: Maybe<Scalars['String']['output']>;
  rollingResistance?: Maybe<Scalars['String']['output']>;
  rollingResistanceRear?: Maybe<Scalars['String']['output']>;
  roofLoad?: Maybe<Scalars['Int']['output']>;
  smallSeriesCarYear?: Maybe<Scalars['String']['output']>;
  smoke?: Maybe<Scalars['String']['output']>;
  smokeCorrectedAbsorptionCoefficient?: Maybe<Scalars['Float']['output']>;
  soundLevelApproval?: Maybe<Scalars['String']['output']>;
  soundLevelDriveby?: Maybe<Scalars['Int']['output']>;
  soundLevelStationary?: Maybe<Scalars['Int']['output']>;
  specialPurposeVehicle?: Maybe<Scalars['String']['output']>;
  stageOfCompletionCode?: Maybe<Scalars['String']['output']>;
  steering?: Maybe<Scalars['String']['output']>;
  testMass?: Maybe<Scalars['Int']['output']>;
  trailerBrakeConnections?: Maybe<Scalars['String']['output']>;
  trailerBrakeConnectionsCode?: Maybe<Scalars['String']['output']>;
  typeApprovalDate?: Maybe<Scalars['Int']['output']>;
  typeApprovalNumber?: Maybe<Scalars['String']['output']>;
  typeOfBody?: Maybe<Scalars['String']['output']>;
  typeOfCommonDescription?: Maybe<Scalars['String']['output']>;
  tyreCategoryFront?: Maybe<Scalars['String']['output']>;
  tyreCategoryRear?: Maybe<Scalars['String']['output']>;
  tyresAndWheels?: Maybe<Scalars['String']['output']>;
  tyresAndWheels2?: Maybe<Scalars['String']['output']>;
  tyresAndWheelsRear?: Maybe<Scalars['String']['output']>;
  urbanRealDrivingEmissionsTripNox?: Maybe<Scalars['Float']['output']>;
  urbanRealDrivingEmissionsTripParticles?: Maybe<Scalars['Float']['output']>;
  urbanRealDrivingEmissionsTripParticlesExponent?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
  vehicleCategory?: Maybe<Scalars['String']['output']>;
  vehicleFittedWithEcoInnovationIndication?: Maybe<Scalars['String']['output']>;
  verificationFactor?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  versionWeek?: Maybe<Scalars['Int']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
  weightedCombinedCo2Emissions?: Maybe<Scalars['Int']['output']>;
  weightedCombinedFuelConsumption?: Maybe<Scalars['Float']['output']>;
  wheelBase?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
  wltpSavingsGramsPerKm?: Maybe<Scalars['Float']['output']>;
  workingPrinciple?: Maybe<Scalars['String']['output']>;
  workingPrincipleCode?: Maybe<Scalars['String']['output']>;
};

export type CocCertificateContent = {
  certificate?: Maybe<CocCertificate>;
  createdOn?: Maybe<Scalars['String']['output']>;
  fyon?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedOn?: Maybe<Scalars['String']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
};

export type CocCertificateResult = {
  content?: Maybe<Array<CocCertificateContent>>;
  delegationLog: Array<DelegationLogItem>;
  exception?: Maybe<DelegationException>;
  status: DelegationStatus;
};

export type Colour = {
  alternativeCodes?: Maybe<Array<Scalars['String']['output']>>;
  carKey: Scalars['CarKey']['output'];
  co2Effect?: Maybe<Scalars['Boolean']['output']>;
  /** The unique (in this type) code for this component. */
  code: Scalars['String']['output'];
  componentBehavior?: Maybe<ComponentBehavior>;
  configurationStates?: Maybe<Array<Scalars['ConfigurationState']['output']>>;
  content?: Maybe<ColourContent>;
  features: Array<Feature>;
  globalName?: Maybe<Scalars['String']['output']>;
  localName?: Maybe<Scalars['String']['output']>;
  packages: Array<Package>;
  previousCarKey?: Maybe<Scalars['CarKey']['output']>;
  rootState?: Maybe<Scalars['ConfigurationState']['output']>;
  state?: Maybe<Scalars['ConfigurationState']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type: CarComponentType;
  visible?: Maybe<Scalars['Boolean']['output']>;
};


export type ColourcontentArgs = {
  locale: Scalars['String']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ColourContent = CarComponentContent & {
  baseColor?: Maybe<BaseColourProperty>;
  /** @deprecated Use `baseColor` instead */
  baseColour?: Maybe<BaseColourProperty>;
  colorCode: Scalars['String']['output'];
  colorType?: Maybe<ColourTypeProperty>;
  /** @deprecated Use `colorCode` instead */
  colourCode: Scalars['String']['output'];
  /** @deprecated Use `colorType` instead */
  colourType?: Maybe<ColourTypeProperty>;
  description?: Maybe<StringProperty>;
  displayName?: Maybe<StringProperty>;
  entityType?: Maybe<UpstreamEntityTypeProperty>;
  group?: Maybe<GroupProperty>;
  hex?: Maybe<StringProperty>;
  /** @deprecated Replaced by 'images' */
  image?: Maybe<ImageProperty>;
  /** Contains a collection of images. Replaces 'image' */
  images: Array<ImageProperty>;
  matchingCode?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<SystemMeta>;
  shortDescription?: Maybe<StringProperty>;
  swatchImage?: Maybe<ImageProperty>;
  /** @deprecated Replaced by 'videos' */
  video?: Maybe<VideoProperty>;
  /** Contains a collection of videos. Replaces 'video' */
  videos: Array<VideoProperty>;
};

export type ColourResult = {
  content?: Maybe<ColourContent>;
  delegationLog: Array<DelegationLogItem>;
  exception?: Maybe<DelegationException>;
  status: DelegationStatus;
};

export enum ColourType {
  EXCLUSIVE = 'EXCLUSIVE',
  MATTE = 'MATTE',
  METALLIC = 'METALLIC',
  SOLID = 'SOLID'
}

/** Color Type Property */
export type ColourTypeProperty = {
  enumDescription?: Maybe<Scalars['String']['output']>;
  formatted?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<ColourType>;
  valueDescription?: Maybe<Scalars['String']['output']>;
};

export type CommercialModelYear = {
  name: Scalars['String']['output'];
  structureWeekFrom: Scalars['Int']['output'];
};

/** This type holds the result of evaluating the company car policy against a given car. */
export type CompanyCarPolicy = {
  /** This field is used to determine if the car is compliant with the provided company car policy */
  isCompliant?: Maybe<Scalars['Boolean']['output']>;
};

export type ComparedToResult = {
  content: Array<GenerateTextComparison>;
  delegationLog: Array<DelegationLogItem>;
  exception?: Maybe<DelegationException>;
  status: DelegationStatus;
};

export enum ComponentBehavior {
  HIDE_INCLUDED = 'HIDE_INCLUDED',
  HIDE_IN_PACKAGE = 'HIDE_IN_PACKAGE',
  SHOW_ALL = 'SHOW_ALL',
  /** @deprecated Replaced with HIDE_IN_PACKAGE */
  hideInPackage = 'hideInPackage',
  /** @deprecated Replaced with HIDE_INCLUDED */
  hideIncluded = 'hideIncluded',
  /** @deprecated Replaced with SHOW_ALL */
  showAll = 'showAll'
}

export type ComponentPriceBreakdownSummary = ComponentPriceSummary & {
  all?: Maybe<ComponentPriceFields>;
  code: Scalars['String']['output'];
  items?: Maybe<Array<ComponentPriceSummary>>;
  price?: Maybe<PriceAmount>;
  type: Scalars['String']['output'];
};

export type ComponentPriceFields = {
  discountPercentage?: Maybe<Scalars['Float']['output']>;
  dueTodayInclTax?: Maybe<PriceAmount>;
  dueTodayInclTaxExclVat?: Maybe<PriceAmount>;
  dueTodayVatAmount?: Maybe<PriceAmount>;
  /** @deprecated Use 'priceExclTax' instead with input sales model 'wholesale' */
  msrpPriceExclTax?: Maybe<PriceAmount>;
  /** @deprecated Use 'priceExclTaxInclVat' instead with input sales model 'wholesale' */
  msrpPriceExclTaxInclVat?: Maybe<PriceAmount>;
  /** @deprecated Use 'priceInclTax' instead with input sales model 'wholesale' */
  msrpPriceInclTax?: Maybe<PriceAmount>;
  priceBreakdownExclTax?: Maybe<PriceAmount>;
  /** @deprecated Use priceBreakdownExclTax instead */
  priceBreakdownMsrpExclTax?: Maybe<PriceAmount>;
  priceBreakdownPriceExclTaxInclVat?: Maybe<PriceAmount>;
  priceBreakdownPriceInclTax?: Maybe<PriceAmount>;
  priceBreakdownPriceInclTaxExclVat?: Maybe<PriceAmount>;
  /** Price of the car excluding all taxes */
  priceExclTax?: Maybe<PriceAmount>;
  /** Price of the car including only VAT tax */
  priceExclTaxInclVat?: Maybe<PriceAmount>;
  /** Price of the car including all taxes */
  priceInclTax?: Maybe<PriceAmount>;
  /** Price of the car including taxes except VAT */
  priceInclTaxExclVat?: Maybe<PriceAmount>;
  relativeBasePriceExclTax?: Maybe<PriceAmount>;
  relativeBasePriceExclTaxInclVat?: Maybe<PriceAmount>;
  relativeBasePriceInclTax?: Maybe<PriceAmount>;
  relativeBasePriceInclTaxExclVat?: Maybe<PriceAmount>;
  relativeBaseSplitTax?: Maybe<PriceAmount>;
  /** Group relative price the car. That is the relative price in relation to other cars in the same group. Null if group is unspecified. */
  relativeGroup?: Maybe<PriceAmount>;
  relativeGroupPriceExclTax?: Maybe<PriceAmount>;
  relativeGroupPriceExclTaxInclVat?: Maybe<PriceAmount>;
  relativeGroupPriceInclTax?: Maybe<PriceAmount>;
  relativeGroupPriceInclTaxExclVat?: Maybe<PriceAmount>;
  relativePriceExclTax?: Maybe<PriceAmount>;
  relativePriceExclTaxInclVat?: Maybe<PriceAmount>;
  relativePriceInclTax?: Maybe<PriceAmount>;
  relativePriceInclTaxExclVat?: Maybe<PriceAmount>;
  relativePriceSplitTax?: Maybe<PriceAmount>;
  /** @deprecated Use 'priceInclTax' instead */
  standardTransactionPriceInclTax?: Maybe<PriceAmount>;
  /** @deprecated Use 'priceInclTaxExclVat' instead */
  standardTransactionPriceInclTaxExclVat?: Maybe<PriceAmount>;
  /** @deprecated Use 'priceInclTax' instead */
  subscriptionPriceInclTax?: Maybe<PriceAmount>;
  /** @deprecated Use 'priceInclTaxExclVat' instead */
  subscriptionPriceInclTaxExclVat?: Maybe<PriceAmount>;
  /** @deprecated Use 'vatAmount' instead */
  subscriptionVatAmount?: Maybe<PriceAmount>;
  /** Vat amount of the car */
  vatAmount?: Maybe<PriceAmount>;
};

export type ComponentPriceSummary = {
  all?: Maybe<ComponentPriceFields>;
  code: Scalars['String']['output'];
  price?: Maybe<PriceAmount>;
  type: Scalars['String']['output'];
};

/** Tags for car components */
export enum ComponentTag {
  ACCESSORY = 'ACCESSORY',
  DEFAULT = 'DEFAULT',
  HUNDRED_PERCENT = 'HUNDRED_PERCENT',
  LOCAL_OPTION = 'LOCAL_OPTION',
  NO_CO2AFFECT = 'NO_CO2AFFECT',
  PACKAGE_ONLY = 'PACKAGE_ONLY',
  SPECIAL_VEHICLE_ONLY = 'SPECIAL_VEHICLE_ONLY',
  STANDARD_FEATURE_WHEEL = 'STANDARD_FEATURE_WHEEL',
  STRUCTURE_WEEK_DIFF = 'STRUCTURE_WEEK_DIFF'
}

export type ConfigurationError = {
  message?: Maybe<Scalars['String']['output']>;
};

export enum ConfigurationSelectionStrategy {
  AllSelected = 'AllSelected',
  FullPackageContent = 'FullPackageContent',
  KeepAll = 'KeepAll',
  NoPackageContent = 'NoPackageContent'
}

/** A configuration token is a unique identifier for a configuration. */
export type ConfigurationToken = {
  carKey?: Maybe<Scalars['CarKey']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  short?: Maybe<Scalars['String']['output']>;
  userFriendly?: Maybe<Scalars['String']['output']>;
};

/** ConfigurationWindow represents the different time windows for which configuration can take place. */
export enum ConfigurationWindow {
  All = 'All',
  Current = 'Current',
  Future = 'Future',
  Past = 'Past'
}

export enum ContextStrawberryType {
  ENGINE = 'ENGINE',
  EXTERIOR_COLOURS = 'EXTERIOR_COLOURS',
  FUEL_TYPE = 'FUEL_TYPE',
  MODEL = 'MODEL'
}

export type ContractLength = {
  content?: Maybe<IntProperty>;
  id?: Maybe<Scalars['String']['output']>;
};


export type ContractLengthcontentArgs = {
  locale: Scalars['String']['input'];
};

export enum Coverage {
  COMPLETE = 'COMPLETE',
  EMPTY = 'EMPTY',
  INCOMPLETE = 'INCOMPLETE',
  UNKNOWN = 'UNKNOWN'
}

export enum CoverageStrategy {
  PERMISSIVE = 'PERMISSIVE',
  RESTRICTIVE = 'RESTRICTIVE',
  UNKNOWN = 'UNKNOWN'
}

export type CustomerType = {
  content?: Maybe<CustomerTypeContent>;
  id: Scalars['String']['output'];
};


export type CustomerTypecontentArgs = {
  locale: Scalars['String']['input'];
};

export type CustomerTypeContent = {
  displayName?: Maybe<StringProperty>;
};

export enum Dataset {
  PANDO = 'PANDO',
  STOCK = 'STOCK'
}

export type DelegationException = {
  gatewayErrorMessage?: Maybe<Scalars['String']['output']>;
  missingDependencyKey?: Maybe<Scalars['String']['output']>;
};

export type DelegationLogItem = {
  jsonAdditionalDependencies?: Maybe<Scalars['String']['output']>;
  jsonData?: Maybe<Scalars['String']['output']>;
  jsonKey?: Maybe<Scalars['String']['output']>;
  keyType: Scalars['String']['output'];
  meta: DelegationMeta;
  queryId: Scalars['String']['output'];
  serviceUrn: Scalars['String']['output'];
  status: DelegationStatus;
  timestampReq: Scalars['String']['output'];
  timestampRes: Scalars['String']['output'];
};

export type DelegationMeta = {
  argName: Scalars['String']['output'];
  batch: Scalars['Boolean']['output'];
  fieldName: Scalars['String']['output'];
  keyType: Scalars['String']['output'];
  serviceUrn: Scalars['String']['output'];
};

export enum DelegationStatus {
  FOUND = 'FOUND',
  GATEWAY_ERROR = 'GATEWAY_ERROR',
  MISSING_DEPENDENCY = 'MISSING_DEPENDENCY',
  NOT_FOUND = 'NOT_FOUND',
  SERVICE_ERROR = 'SERVICE_ERROR'
}

export enum DelegationStrategy {
  ACCEPT_NULL_VALUES = 'ACCEPT_NULL_VALUES',
  MERGE_SOURCES = 'MERGE_SOURCES'
}

/** From/To/Unit for estimated delivery date for this car */
export type DeliveryLeadTimeEstimatedDeliveryDate = {
  /** From value for estimated delivery date for this car */
  from?: Maybe<Scalars['Int']['output']>;
  /** To value for estimated delivery date for this car */
  to?: Maybe<Scalars['Int']['output']>;
  /** Unit for estimated delivery date for this car */
  unit?: Maybe<Scalars['String']['output']>;
};

/** Delivery lead time to market for this car */
export type DeliveryLeadTimeToMarket = {
  /** Estimated delivery date for this car */
  estimatedDeliveryDate: DeliveryLeadTimeEstimatedDeliveryDate;
  /** Human readable representation of the lead times, i.e. '8-10 Months' */
  formatted: Scalars['String']['output'];
};

export type DeliveryMetadataContent = {
  deliveryDate?: Maybe<Scalars['String']['output']>;
  destinationCountry?: Maybe<Scalars['String']['output']>;
  factoryCode?: Maybe<Scalars['Int']['output']>;
  fyon?: Maybe<Scalars['Int']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  licensePlateVdw?: Maybe<Scalars['String']['output']>;
  market?: Maybe<Scalars['String']['output']>;
  marketingCode?: Maybe<Scalars['Int']['output']>;
  marketingDescription?: Maybe<Scalars['String']['output']>;
  projectCode?: Maybe<Scalars['String']['output']>;
  registrationDate?: Maybe<Scalars['String']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
  vinPricelist?: Maybe<Scalars['String']['output']>;
  vinRetailPrice?: Maybe<Scalars['Float']['output']>;
  warranty?: Maybe<Scalars['String']['output']>;
  warrantyCloseDate?: Maybe<Scalars['String']['output']>;
  warrantyReopenDate?: Maybe<Scalars['String']['output']>;
};

export type DeliveryMetadataResult = {
  content?: Maybe<DeliveryMetadataContent>;
  delegationLog: Array<DelegationLogItem>;
  exception?: Maybe<DelegationException>;
  status: DelegationStatus;
};

export type Discounts = {
  discountAmount?: Maybe<PricePoint>;
  /** The discount rate */
  nominalDiscountRate?: Maybe<PercentageRate>;
  priceBeforeDiscount?: Maybe<PricePoint>;
};

export enum DriveType {
  AWD = 'AWD',
  E_AWD = 'E_AWD',
  FWD = 'FWD',
  RWD = 'RWD',
  UNKOWN_SINGLE_AXLE = 'UNKOWN_SINGLE_AXLE'
}

/** Drive Type Property */
export type DriveTypeProperty = {
  enumDescription?: Maybe<Scalars['String']['output']>;
  formatted?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<DriveType>;
  valueDescription?: Maybe<Scalars['String']['output']>;
};

export type Driveline = {
  alternativeCodes?: Maybe<Array<Scalars['String']['output']>>;
  carKey: Scalars['CarKey']['output'];
  co2Effect?: Maybe<Scalars['Boolean']['output']>;
  /** The unique (in this type) code for this component. */
  code: Scalars['String']['output'];
  componentBehavior?: Maybe<ComponentBehavior>;
  configurationStates?: Maybe<Array<Scalars['ConfigurationState']['output']>>;
  content?: Maybe<DrivelineContent>;
  features: Array<Feature>;
  /** @deprecated Does actually not exist */
  globalName?: Maybe<Scalars['String']['output']>;
  previousCarKey?: Maybe<Scalars['CarKey']['output']>;
  rootState?: Maybe<Scalars['ConfigurationState']['output']>;
  state?: Maybe<Scalars['ConfigurationState']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type: CarComponentType;
  visible?: Maybe<Scalars['Boolean']['output']>;
};


export type DrivelinecontentArgs = {
  locale: Scalars['String']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DrivelineContent = {
  description?: Maybe<StringProperty>;
  displayName?: Maybe<StringProperty>;
  driveType?: Maybe<DriveTypeProperty>;
  engineCode: Scalars['String']['output'];
  entityType?: Maybe<UpstreamEntityTypeProperty>;
  gearboxCode: Scalars['String']['output'];
  gearboxFullName?: Maybe<StringProperty>;
  /** @deprecated Replaced by 'images' */
  image?: Maybe<ImageProperty>;
  /** Contains a collection of images. Replaces 'image' */
  images: Array<ImageProperty>;
  meta?: Maybe<SystemMeta>;
  modelCode: Scalars['String']['output'];
  shortDescription?: Maybe<StringProperty>;
  /**
   * Value indicating relative position of
   * this item in the sorted list of items of the same type.
   * Zero-based and may not be set.
   * For Driveline content it ignores the locale and always returns
   * the global sort order if present.
   */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  transmissionType?: Maybe<TransmissionTypeProperty>;
  /** @deprecated Replaced by 'videos' */
  video?: Maybe<VideoProperty>;
  /** Contains a collection of videos. Replaces 'video' */
  videos: Array<VideoProperty>;
};

export type DrivelineResult = {
  content?: Maybe<DrivelineContent>;
  delegationLog: Array<DelegationLogItem>;
  exception?: Maybe<DelegationException>;
  status: DelegationStatus;
};

/** Currently, only for WLTP PHEVs */
export type EfficiencyClassContainer = {
  chargeSustainEfficiencyClass?: Maybe<EfficiencyClassData>;
  efficiencyClass?: Maybe<EfficiencyClassData>;
};

export type EfficiencyClassData = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type EfficiencyClassification = {
  chargeSustainEfficiencyClass?: Maybe<Scalars['String']['output']>;
  co2EmissionDetails?: Maybe<Scalars['Float']['output']>;
  efficiencyClass?: Maybe<Scalars['String']['output']>;
  efficiencyClassBest?: Maybe<Scalars['String']['output']>;
  efficiencyClassWorst?: Maybe<Scalars['String']['output']>;
  efficiencyClasses?: Maybe<EfficiencyClassContainer>;
  efficiencyRanges?: Maybe<Array<Scalars['String']['output']>>;
  errorMessage?: Maybe<errorMessage>;
  id?: Maybe<Scalars['String']['output']>;
  modelYear?: Maybe<Scalars['Int']['output']>;
  petrolEquivalentValue?: Maybe<Scalars['Float']['output']>;
  pno12?: Maybe<Scalars['String']['output']>;
  specificationMarket?: Maybe<Scalars['String']['output']>;
};


export type EfficiencyClassificationefficiencyClassesArgs = {
  locale: Scalars['String']['input'];
};

export enum ElectricRangeType {
  EXTENDED_RANGE = 'EXTENDED_RANGE',
  PERFORMANCE = 'PERFORMANCE',
  STANDARD_RANGE = 'STANDARD_RANGE'
}

/** Electric Range Type Property */
export type ElectricRangeTypeProperty = {
  enumDescription?: Maybe<Scalars['String']['output']>;
  formatted?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<ElectricRangeType>;
  valueDescription?: Maybe<Scalars['String']['output']>;
};

export type Engine = {
  alternativeCodes?: Maybe<Array<Scalars['String']['output']>>;
  carKey: Scalars['CarKey']['output'];
  co2Effect?: Maybe<Scalars['Boolean']['output']>;
  /** The unique (in this type) code for this component. */
  code: Scalars['String']['output'];
  componentBehavior?: Maybe<ComponentBehavior>;
  configurationStates?: Maybe<Array<Scalars['ConfigurationState']['output']>>;
  content?: Maybe<EngineContent>;
  features: Array<Feature>;
  globalName?: Maybe<Scalars['String']['output']>;
  localName?: Maybe<Scalars['String']['output']>;
  previousCarKey?: Maybe<Scalars['CarKey']['output']>;
  rootState?: Maybe<Scalars['ConfigurationState']['output']>;
  state?: Maybe<Scalars['ConfigurationState']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type: CarComponentType;
  visible?: Maybe<Scalars['Boolean']['output']>;
};


export type EnginecontentArgs = {
  locale: Scalars['String']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EngineContent = {
  camshaftType?: Maybe<CamshaftTypeProperty>;
  description?: Maybe<StringProperty>;
  displayName?: Maybe<StringProperty>;
  electricRangeType?: Maybe<ElectricRangeTypeProperty>;
  engineCode: Scalars['String']['output'];
  engineType?: Maybe<EngineTypeProperty>;
  entityType?: Maybe<UpstreamEntityTypeProperty>;
  fuelType?: Maybe<FuelTypeProperty>;
  fullName?: Maybe<StringProperty>;
  /** @deprecated Replaced by 'images' */
  image?: Maybe<ImageProperty>;
  /** Contains a collection of images. Replaces 'image' */
  images: Array<ImageProperty>;
  meta?: Maybe<SystemMeta>;
  shortDescription?: Maybe<StringProperty>;
  shortName?: Maybe<StringProperty>;
  /**
   * Value indicating relative position of
   * this item in the sorted list of items of the same type.
   * Zero-based and may not be set.
   * For Engine content it ignores the locale and always returns
   * the global sort order if present.
   */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Replaced by 'videos' */
  video?: Maybe<VideoProperty>;
  /** Contains a collection of videos. Replaces 'video' */
  videos: Array<VideoProperty>;
};

export type EngineResult = {
  content?: Maybe<EngineContent>;
  delegationLog: Array<DelegationLogItem>;
  exception?: Maybe<DelegationException>;
  status: DelegationStatus;
};

export enum EngineType {
  BEV = 'BEV',
  HEV = 'HEV',
  /** All non-KERS combustion engines are remapped to ICE (internal combustion engine) in VSpec for legacy compatibility */
  ICE = 'ICE',
  PHEV = 'PHEV'
}

/** Engine Type Property */
export type EngineTypeProperty = {
  enumDescription?: Maybe<Scalars['String']['output']>;
  formatted?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<EngineType>;
  valueDescription?: Maybe<Scalars['String']['output']>;
};

export type EnvironmentalData = {
  carKey: Scalars['CarKey']['output'];
  individualValues?: Maybe<Scalars['JSON']['output']>;
};

/** The views featuring the car's exterior in an outside location environment */
export type ExteriorLocationViewGroup = {
  /** A view of the front of the car */
  front?: Maybe<ImageGroup>;
  /**
   * All the exterior views
   * @deprecated Use the named images instead e.g. front, threeQuartersFrontLeft, rear, left etc.
   */
  images?: Maybe<Array<ImageSizes>>;
  /** A view of the left side of the car */
  left?: Maybe<ImageGroup>;
  /** A view of the rear of the car */
  rear?: Maybe<ImageGroup>;
  /** A view from the rear and left of the car */
  rearLeft?: Maybe<ImageGroup>;
  /** A view of the right side of the car */
  right?: Maybe<ImageGroup>;
  /** A three quarter's view of the front and left of the car */
  threeQuartersFrontLeft?: Maybe<ImageGroup>;
  /** A three quarter's view of the front and right of the car */
  threeQuartersFrontRight?: Maybe<ImageGroup>;
  /** A three quarter's view of the rear and left of the car */
  threeQuartersRearLeft?: Maybe<ImageGroup>;
  /** A three quarter's view of the rear and right of the car */
  threeQuartersRearRight?: Maybe<ImageGroup>;
  /** A three quarter's view from top of the front and left of the car */
  topThreeQuartersFrontLeft?: Maybe<ImageGroup>;
  /** A three quarter's view from top of the front and right of the car */
  topThreeQuartersFrontRight?: Maybe<ImageGroup>;
  /** A three quarter's view from top of the rear and left of the car */
  topThreeQuartersRearLeft?: Maybe<ImageGroup>;
};

/** The exterior detail images of a car */
export type ExteriorStudioDetailsViewGroup = {
  /** A view of the car's grille */
  grille?: Maybe<ImageGroup>;
  /** A view of the car's headlights */
  headlight?: Maybe<ImageGroup>;
  /** A view of the car's rear window trim */
  rearWindowTrim?: Maybe<ImageGroup>;
  /** A view of the car's taillights */
  taillight?: Maybe<ImageGroup>;
  /** A view of the car's wheel */
  wheel?: Maybe<ImageGroup>;
};

/** The views featuring the car's exterior in a studio environment */
export type ExteriorStudioViewGroup = {
  /** A view of the front of the car */
  front?: Maybe<ImageGroup>;
  /** A view of the left side of the car */
  left?: Maybe<ImageGroup>;
  /** A view of the rear of the car */
  rear?: Maybe<ImageGroup>;
  /** A view of the right side of the car */
  right?: Maybe<ImageGroup>;
  /** A three quarter's view of the front and left of the car */
  threeQuartersFrontLeft?: Maybe<ImageGroup>;
  /** A three quarter's view of the front and right of the car */
  threeQuartersFrontRight?: Maybe<ImageGroup>;
  /** A three quarter's view of the rear and left of the car */
  threeQuartersRearLeft?: Maybe<ImageGroup>;
  /** A three quarter's view of the rear and right of the car */
  threeQuartersRearRight?: Maybe<ImageGroup>;
};

/** The views featuring the car's exterior */
export type ExteriorViewGroup = {
  /** The banner-view of a car */
  banner?: Maybe<ImageGroup>;
  /** The exterior detail views of a car */
  details?: Maybe<ExteriorStudioDetailsViewGroup>;
  /** The views featuring the car's exterior in an outside location environment */
  location?: Maybe<ExteriorLocationViewGroup>;
  /** The standardized side-view of a car */
  standardizedSideView?: Maybe<ImageGroup>;
  /** The views featuring the car's exterior in a studio environment */
  studio?: Maybe<ExteriorStudioViewGroup>;
  /** The views featuring the car's exterior in a studio environment, proportionally sized relative to other models */
  studioProportional?: Maybe<ExteriorStudioViewGroup>;
  /** The Top views of a car */
  topView?: Maybe<TopViewViewGroup>;
};

export type Feature = {
  alternativeCodes?: Maybe<Array<Scalars['String']['output']>>;
  carKey: Scalars['CarKey']['output'];
  co2Effect?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<FeatureCodeContainer>;
  componentBehavior?: Maybe<ComponentBehavior>;
  configurationStates?: Maybe<Array<Scalars['ConfigurationState']['output']>>;
  content?: Maybe<FeatureContent>;
  endWeek?: Maybe<Scalars['String']['output']>;
  features: Array<Feature>;
  globalName?: Maybe<Scalars['String']['output']>;
  globalShortName?: Maybe<Scalars['String']['output']>;
  /** The different image sizes available for each icon. */
  icon?: Maybe<IconSizes>;
  localName?: Maybe<Scalars['String']['output']>;
  nextWeek?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Scalars['String']['output']>>;
  previousCarKey?: Maybe<Scalars['CarKey']['output']>;
  rootState?: Maybe<Scalars['ConfigurationState']['output']>;
  state?: Maybe<Scalars['ConfigurationState']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type: CarComponentType;
  visible?: Maybe<Scalars['Boolean']['output']>;
  /** Feature is visualized. Returns null if it cannot be established that the feature could be visualized or not. */
  visualized?: Maybe<Scalars['Boolean']['output']>;
};


export type FeaturecontentArgs = {
  locale: Scalars['String']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FeaturevisualizedArgs = {
  marketOrLocale: Scalars['String']['input'];
};

export type FeatureCodeContainer = {
  value?: Maybe<Scalars['String']['output']>;
};

export type FeatureCodeResult = {
  content?: Maybe<Array<FeatureCodeContainer>>;
  delegationLog: Array<DelegationLogItem>;
  exception?: Maybe<DelegationException>;
  status: DelegationStatus;
};

export type FeatureContent = {
  categoryPlacement?: Maybe<CategoryPlacement>;
  description?: Maybe<StringProperty>;
  displayName?: Maybe<StringProperty>;
  entityType?: Maybe<UpstreamEntityTypeProperty>;
  featureCode: Scalars['String']['output'];
  highlightSortOrder?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Replaced by 'images' */
  image?: Maybe<ImageProperty>;
  /** Contains a collection of images. Replaces 'image' */
  images: Array<ImageProperty>;
  includeInHighlight?: Maybe<Scalars['Boolean']['output']>;
  matchingCode: Scalars['String']['output'];
  meta?: Maybe<SystemMeta>;
  shortDescription?: Maybe<StringProperty>;
  /** @deprecated Replaced by 'videos' */
  video?: Maybe<VideoProperty>;
  /** Contains a collection of videos. Replaces 'video' */
  videos: Array<VideoProperty>;
};

export type FeatureResult = {
  content?: Maybe<Array<FeatureContent>>;
  delegationLog: Array<DelegationLogItem>;
  exception?: Maybe<DelegationException>;
  status: DelegationStatus;
};

export type FeatureScore = {
  score?: Maybe<Scalars['Float']['output']>;
};

export type FeatureScores = {
  trim?: Maybe<SalesVersionScore>;
};

export type Fee = {
  amount?: Maybe<PriceAmount>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Filter = {
  subFilters?: InputMaybe<Array<SubFilter>>;
};

export enum FilterName {
  BODY_FILTER = 'BODY_FILTER',
  CAR_TYPE_FILTER = 'CAR_TYPE_FILTER',
  COLOR_FILTER = 'COLOR_FILTER',
  ENGINE_FILTER = 'ENGINE_FILTER',
  GEARBOX_FILTER = 'GEARBOX_FILTER',
  MARKETING_CODE_FILTER = 'MARKETING_CODE_FILTER',
  MODEL_YEAR_FILTER = 'MODEL_YEAR_FILTER',
  OPTIONS_FILTER = 'OPTIONS_FILTER',
  PACKAGES_FILTER = 'PACKAGES_FILTER',
  SALES_VERSION_FILTER = 'SALES_VERSION_FILTER',
  SPEC_MARKET_FILTER = 'SPEC_MARKET_FILTER',
  STEERING_FILTER = 'STEERING_FILTER',
  STRUCTURE_WEEK_FILTER = 'STRUCTURE_WEEK_FILTER',
  S_MESSAGE_FILTER = 'S_MESSAGE_FILTER',
  UPHOLSTERY_FILTER = 'UPHOLSTERY_FILTER'
}

export enum FilterType {
  exclude = 'exclude',
  include = 'include'
}

export type FilterValues = {
  name: FilterName;
  values: Array<ValueAndAmount>;
};

export type FinancingBreakdown = {
  /** The amount before financing, adjusted with any discounts */
  adjustedPreFinancingAmount?: Maybe<PricePoint>;
  /** List the available final payment amounts (AKA balloon payment) */
  availableFinalPayments?: Maybe<Array<PriceAmount>>;
  /** The financed amount: preFinancingPrice - downpayment - manufacturer deposit */
  creditAmount?: Maybe<PriceAmount>;
  /** The total interest amount + total fees */
  creditCostAmount?: Maybe<PriceAmount>;
  /** The customers downpayment */
  downpayment?: Maybe<Payment>;
  /**
   * The customers downpayment
   * @deprecated Use downpayment field
   */
  downpaymentAmount?: Maybe<PriceAmount>;
  excessMileageRate?: Maybe<Scalars['Float']['output']>;
  fees?: Maybe<Array<Fee>>;
  /** The baloon payment */
  finalPaymentAmount?: Maybe<PriceAmount>;
  financeDiscountContribution?: Maybe<PricePoint>;
  /** Amount of Credit with interest, fees and insurances */
  financedAmount?: Maybe<PriceAmount>;
  /** The first month payment amount. */
  firstMonthPayment?: Maybe<PriceAmount>;
  interestAmount?: Maybe<PriceAmount>;
  /** List the available interest rates and the corresponding downpayment-spans */
  interestRateSteps?: Maybe<Array<InterestRateStep>>;
  interestRates?: Maybe<Array<InterestRate>>;
  /**
   * Manufacturer deposit amount that lowers the creditAmount
   * @deprecated manufacturerDepositAmount will be replaced by financeDiscountContribution
   */
  manufacturerDepositAmount?: Maybe<PriceAmount>;
  /** The monthly price */
  perInstallmentPrice?: Maybe<PriceAmount>;
  /** The full price before financing */
  preFinancingPrice?: Maybe<PricePoint>;
  /** The customers prePayment */
  prePayment?: Maybe<Payment>;
  /** The total payment for the customer before starting financing (prePayment + downPayment) */
  totalDeposit?: Maybe<PricePoint>;
  /** preFinancingPrice + interest + fees */
  totalPayableAmount?: Maybe<PriceAmount>;
};

export type FinancingPriceSummary = {
  /** Breakdown of the financing values, this is the prefered field for performance. */
  breakdown?: Maybe<FinancingBreakdown>;
  /** Breakdown of the financing values, this field also got the simulationChecksum required for checkout. Should only be used in the last step before checkout */
  realTimeBreakdown?: Maybe<RealTimeFinancingBreakdown>;
};

export enum FuelType {
  DIESEL = 'DIESEL',
  PETROL = 'PETROL',
  PETROL_ELECTRIC = 'PETROL_ELECTRIC',
  PURE_ELECTRIC = 'PURE_ELECTRIC'
}

/** Fuel Type Property */
export type FuelTypeProperty = {
  enumDescription?: Maybe<Scalars['String']['output']>;
  formatted?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<FuelType>;
  valueDescription?: Maybe<Scalars['String']['output']>;
};

export type GRIP_CocCertificate = {
  addressType?: Maybe<Scalars['String']['output']>;
  allowedEuropeanMarketIndicator?: Maybe<Scalars['String']['output']>;
  approvalMarkCouplingDevice?: Maybe<Scalars['String']['output']>;
  approvalTypeCode?: Maybe<Scalars['String']['output']>;
  arrangementOfCylinders?: Maybe<Scalars['String']['output']>;
  atctFamilyIdentifier?: Maybe<Scalars['String']['output']>;
  axleSpacing12?: Maybe<Scalars['Int']['output']>;
  axleTrackFront?: Maybe<Scalars['Int']['output']>;
  axleTrackRear?: Maybe<Scalars['Int']['output']>;
  cappedSpeed?: Maybe<Scalars['String']['output']>;
  carOnLineDate?: Maybe<Scalars['Int']['output']>;
  classOfHybridElectricVehicle?: Maybe<Scalars['String']['output']>;
  clutchType?: Maybe<Scalars['String']['output']>;
  co2Combined?: Maybe<Scalars['String']['output']>;
  co2DeterminationTyreIndicatorFront?: Maybe<Scalars['String']['output']>;
  co2DeterminationTyreIndicatorRear?: Maybe<Scalars['String']['output']>;
  co2EmissionCombinedFuel1?: Maybe<Scalars['Int']['output']>;
  co2EmissionCombinedFuel2?: Maybe<Scalars['Int']['output']>;
  co2EmissionExUrbanFuel1?: Maybe<Scalars['Int']['output']>;
  co2EmissionExUrbanFuel2?: Maybe<Scalars['Int']['output']>;
  co2EmissionUrbanFuel1?: Maybe<Scalars['Int']['output']>;
  co2EmissionUrbanFuel2?: Maybe<Scalars['Int']['output']>;
  co2EmissionWeightedCombinedFuel1?: Maybe<Scalars['Int']['output']>;
  co2EmissionWeightedCombinedFuel2?: Maybe<Scalars['Int']['output']>;
  co2ExUrban?: Maybe<Scalars['String']['output']>;
  co2Urban?: Maybe<Scalars['String']['output']>;
  colourOfVehicle?: Maybe<Scalars['String']['output']>;
  combinedCo2Emissions?: Maybe<Scalars['Int']['output']>;
  combinedFuelConsumption?: Maybe<Scalars['Float']['output']>;
  completeRealDrivingEmissionsTripNox?: Maybe<Scalars['Float']['output']>;
  completeRealDrivingEmissionsTripParticles?: Maybe<Scalars['Float']['output']>;
  completeRealDrivingEmissionsTripParticlesExponent?: Maybe<Scalars['String']['output']>;
  configurationOfDoors?: Maybe<Scalars['String']['output']>;
  continuouslyVariableTransmission?: Maybe<Scalars['String']['output']>;
  descriptionOfBreakingDevice?: Maybe<Scalars['String']['output']>;
  deviationFactor?: Maybe<Scalars['String']['output']>;
  diffLock?: Maybe<Scalars['String']['output']>;
  directInjection?: Maybe<Scalars['String']['output']>;
  distributionAxleFront?: Maybe<Scalars['Int']['output']>;
  distributionAxleRear?: Maybe<Scalars['Int']['output']>;
  downscalingFactor?: Maybe<Scalars['String']['output']>;
  drivingCycleClass?: Maybe<Scalars['String']['output']>;
  duplicateCode?: Maybe<Scalars['String']['output']>;
  electricEnergyConsumption?: Maybe<Scalars['Int']['output']>;
  electricEnergyConsumptionEcacWeighted?: Maybe<Scalars['Int']['output']>;
  electricEnergyConsumptionWltp?: Maybe<Scalars['Int']['output']>;
  electricRange?: Maybe<Scalars['Int']['output']>;
  electricRangeCity?: Maybe<Scalars['Int']['output']>;
  electricRangeCityEaer?: Maybe<Scalars['Int']['output']>;
  electricRangeEaer?: Maybe<Scalars['Int']['output']>;
  electricRangeWltp?: Maybe<Scalars['Int']['output']>;
  emissionConsumptionApproval?: Maybe<Scalars['String']['output']>;
  endOfSeriesDate?: Maybe<Scalars['Int']['output']>;
  engineCapacity?: Maybe<Scalars['Int']['output']>;
  engineCode?: Maybe<Scalars['String']['output']>;
  engineManufacturer?: Maybe<Scalars['String']['output']>;
  evaporativeTestFamilyIdentifier?: Maybe<Scalars['String']['output']>;
  exemptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exhaustEmission?: Maybe<Scalars['String']['output']>;
  exhaustEmissionCo?: Maybe<Scalars['Float']['output']>;
  exhaustEmissionCo2?: Maybe<Scalars['Float']['output']>;
  exhaustEmissionCo2HcNo?: Maybe<Scalars['Float']['output']>;
  exhaustEmissionHc?: Maybe<Scalars['Float']['output']>;
  exhaustEmissionLevel?: Maybe<Scalars['String']['output']>;
  exhaustEmissionNox?: Maybe<Scalars['Float']['output']>;
  exhaustEmissionParticulates?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionCoFuel1?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionCoFuel2?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionNmhcFuel1?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionNmhcFuel2?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionNoxFuel1?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionNoxFuel2?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionParticlesExponentFuel1?: Maybe<Scalars['String']['output']>;
  exhaustFuelEmissionParticlesExponentFuel2?: Maybe<Scalars['String']['output']>;
  exhaustFuelEmissionParticlesFuel1?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionParticlesFuel2?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionParticulatesMgFuel1?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionParticulatesMgFuel2?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionThcFuel1?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionThcFuel2?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionThcNoxFuel1?: Maybe<Scalars['Float']['output']>;
  exhaustFuelEmissionThcNoxFuel2?: Maybe<Scalars['Float']['output']>;
  extraHighCo2Emissions?: Maybe<Scalars['Int']['output']>;
  extraHighFuelConsumption?: Maybe<Scalars['Float']['output']>;
  finalDriveRatio?: Maybe<Scalars['Float']['output']>;
  finalDriveRatioContinued?: Maybe<Scalars['String']['output']>;
  finalDriveRatios?: Maybe<Scalars['String']['output']>;
  frontalArea?: Maybe<Scalars['Float']['output']>;
  fuel1?: Maybe<Scalars['String']['output']>;
  fuel2?: Maybe<Scalars['String']['output']>;
  fuelCode?: Maybe<Scalars['Int']['output']>;
  fuelConsumptionCombined?: Maybe<Scalars['Float']['output']>;
  fuelConsumptionCombinedFuel1?: Maybe<Scalars['Float']['output']>;
  fuelConsumptionCombinedFuel2?: Maybe<Scalars['Float']['output']>;
  fuelConsumptionExUrban?: Maybe<Scalars['Float']['output']>;
  fuelConsumptionExUrbanFuel1?: Maybe<Scalars['Float']['output']>;
  fuelConsumptionExUrbanFuel2?: Maybe<Scalars['Float']['output']>;
  fuelConsumptionUrban?: Maybe<Scalars['Float']['output']>;
  fuelConsumptionUrbanFuel1?: Maybe<Scalars['Float']['output']>;
  fuelConsumptionUrbanFuel2?: Maybe<Scalars['Float']['output']>;
  fuelConsumptionWeightedCombinedFuel1?: Maybe<Scalars['Float']['output']>;
  fuelConsumptionWeightedCombinedFuel2?: Maybe<Scalars['Float']['output']>;
  fuelPrinciple?: Maybe<Scalars['String']['output']>;
  fuelType?: Maybe<Scalars['String']['output']>;
  fyon?: Maybe<Scalars['Int']['output']>;
  gasCh4?: Maybe<Scalars['String']['output']>;
  gasCo?: Maybe<Scalars['String']['output']>;
  gasCo2Combined?: Maybe<Scalars['String']['output']>;
  gasCo2ExUrban?: Maybe<Scalars['String']['output']>;
  gasCo2Urban?: Maybe<Scalars['String']['output']>;
  gasFuelConsumptionCombined?: Maybe<Scalars['String']['output']>;
  gasFuelConsumptionExUrban?: Maybe<Scalars['String']['output']>;
  gasFuelConsumptionUrban?: Maybe<Scalars['String']['output']>;
  gasNmhc?: Maybe<Scalars['String']['output']>;
  gasNox?: Maybe<Scalars['String']['output']>;
  gasThc?: Maybe<Scalars['String']['output']>;
  gearRatio1?: Maybe<Scalars['Float']['output']>;
  gearRatio2?: Maybe<Scalars['Float']['output']>;
  gearRatio3?: Maybe<Scalars['Float']['output']>;
  gearRatio4?: Maybe<Scalars['Float']['output']>;
  gearRatio5?: Maybe<Scalars['Float']['output']>;
  gearRatio6?: Maybe<Scalars['Float']['output']>;
  gearRatio7?: Maybe<Scalars['Float']['output']>;
  gearRatio8?: Maybe<Scalars['Float']['output']>;
  gearRatioReverse?: Maybe<Scalars['Float']['output']>;
  gearboxType?: Maybe<Scalars['String']['output']>;
  gearboxTypeCode?: Maybe<Scalars['String']['output']>;
  gearboxesType?: Maybe<Scalars['String']['output']>;
  generalCodeOfEcoInnovations?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  highCo2Emissions?: Maybe<Scalars['Int']['output']>;
  highFuelConsumption?: Maybe<Scalars['Float']['output']>;
  hybridVehicle?: Maybe<Scalars['String']['output']>;
  informationStatus?: Maybe<Scalars['String']['output']>;
  initialCountryOfRegistration?: Maybe<Scalars['String']['output']>;
  interpolationFamilyIdentifier?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  leftRightTraffic?: Maybe<Scalars['Int']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  loadOnCouplingPoint?: Maybe<Scalars['Int']['output']>;
  locationOfPlates?: Maybe<Scalars['String']['output']>;
  locationOfStatutoryPlates?: Maybe<Scalars['String']['output']>;
  locationOfTheVinCode?: Maybe<Scalars['String']['output']>;
  locationVehicleId?: Maybe<Scalars['String']['output']>;
  lowCo2Emissions?: Maybe<Scalars['Int']['output']>;
  lowFuelConsumption?: Maybe<Scalars['Float']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  massAxleFront?: Maybe<Scalars['Int']['output']>;
  massAxleRear?: Maybe<Scalars['Int']['output']>;
  massInRunningOrder?: Maybe<Scalars['Int']['output']>;
  massOfBrakedTrailer?: Maybe<Scalars['Int']['output']>;
  massOfCombination?: Maybe<Scalars['Int']['output']>;
  massOfUnbrakedTrailer?: Maybe<Scalars['Int']['output']>;
  massOfVehicle?: Maybe<Scalars['Int']['output']>;
  massOfVehicleRunningOrder?: Maybe<Scalars['Int']['output']>;
  max30MinutesPower?: Maybe<Scalars['Int']['output']>;
  max30MinutesPower2?: Maybe<Scalars['Int']['output']>;
  maxContinuedRatedPower?: Maybe<Scalars['Int']['output']>;
  maxContinuedRatedPower2?: Maybe<Scalars['Int']['output']>;
  maxHourlyOutput?: Maybe<Scalars['Int']['output']>;
  maxHourlyOutput2?: Maybe<Scalars['Int']['output']>;
  maxLadenMass?: Maybe<Scalars['Int']['output']>;
  maxMassBrakedCenterAxleTrailer?: Maybe<Scalars['Int']['output']>;
  maxMassBrakedDrawbarTrailer?: Maybe<Scalars['Int']['output']>;
  maxNetPower?: Maybe<Scalars['String']['output']>;
  maxNetPowerRpm?: Maybe<Scalars['Int']['output']>;
  maxSpeed?: Maybe<Scalars['Int']['output']>;
  maximum30MinutesPowerIsg?: Maybe<Scalars['Int']['output']>;
  maximumHourlyOutputIsg?: Maybe<Scalars['Int']['output']>;
  maximumNetPowerIsg?: Maybe<Scalars['Int']['output']>;
  mediumCo2Emissions?: Maybe<Scalars['Int']['output']>;
  mediumFuelConsumption?: Maybe<Scalars['Float']['output']>;
  metricImperialSpeedometer?: Maybe<Scalars['String']['output']>;
  nameAndAddressManufacturing1?: Maybe<Scalars['String']['output']>;
  nameAndAddressManufacturing2?: Maybe<Scalars['String']['output']>;
  nameAndAddressManufacturing3?: Maybe<Scalars['String']['output']>;
  nameAndAddressManufacturing4?: Maybe<Scalars['String']['output']>;
  nedcSavingsGramsPerKm?: Maybe<Scalars['Float']['output']>;
  numberAndArrangementOfCylinders?: Maybe<Scalars['String']['output']>;
  numberAndConfigurationOfDoors?: Maybe<Scalars['String']['output']>;
  numberAndPositionOfSeats?: Maybe<Scalars['String']['output']>;
  numberOfAxles?: Maybe<Scalars['Int']['output']>;
  numberOfPrintouts?: Maybe<Scalars['Int']['output']>;
  numberOfSeats?: Maybe<Scalars['String']['output']>;
  numberOfSmallSeriesCars?: Maybe<Scalars['Int']['output']>;
  numberOfWheels?: Maybe<Scalars['Int']['output']>;
  pemsFamilyIdentifier?: Maybe<Scalars['String']['output']>;
  periodicRegenerationFamilyIdentifier?: Maybe<Scalars['String']['output']>;
  poweredAxles?: Maybe<Scalars['Int']['output']>;
  poweredAxlesInterconnection?: Maybe<Scalars['String']['output']>;
  poweredAxlesPosition?: Maybe<Scalars['String']['output']>;
  primaryColourCode?: Maybe<Scalars['Int']['output']>;
  pureElectric?: Maybe<Scalars['String']['output']>;
  rearOverhang?: Maybe<Scalars['Int']['output']>;
  remarks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  remarks2?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  revsSoundLevelStationary?: Maybe<Scalars['Int']['output']>;
  rightLeftHandTrafficCode?: Maybe<Scalars['String']['output']>;
  roadLoadCoefficients?: Maybe<Scalars['Float']['output']>;
  roadLoadCoefficients2?: Maybe<Scalars['Float']['output']>;
  roadLoadCoefficients3?: Maybe<Scalars['Float']['output']>;
  roadloadsFamilyIdentifier?: Maybe<Scalars['String']['output']>;
  rollingResistance?: Maybe<Scalars['String']['output']>;
  rollingResistanceRear?: Maybe<Scalars['String']['output']>;
  roofLoad?: Maybe<Scalars['Int']['output']>;
  smallSeriesCarYear?: Maybe<Scalars['String']['output']>;
  smoke?: Maybe<Scalars['String']['output']>;
  smokeCorrectedAbsorptionCoefficient?: Maybe<Scalars['Float']['output']>;
  soundLevelApproval?: Maybe<Scalars['String']['output']>;
  soundLevelDriveby?: Maybe<Scalars['Int']['output']>;
  soundLevelStationary?: Maybe<Scalars['Int']['output']>;
  specialPurposeVehicle?: Maybe<Scalars['String']['output']>;
  stageOfCompletionCode?: Maybe<Scalars['String']['output']>;
  steering?: Maybe<Scalars['String']['output']>;
  testMass?: Maybe<Scalars['Int']['output']>;
  trailerBrakeConnections?: Maybe<Scalars['String']['output']>;
  trailerBrakeConnectionsCode?: Maybe<Scalars['String']['output']>;
  typeApprovalDate?: Maybe<Scalars['Int']['output']>;
  typeApprovalNumber?: Maybe<Scalars['String']['output']>;
  typeOfBody?: Maybe<Scalars['String']['output']>;
  typeOfCommonDescription?: Maybe<Scalars['String']['output']>;
  tyreCategoryFront?: Maybe<Scalars['String']['output']>;
  tyreCategoryRear?: Maybe<Scalars['String']['output']>;
  tyresAndWheels?: Maybe<Scalars['String']['output']>;
  tyresAndWheels2?: Maybe<Scalars['String']['output']>;
  tyresAndWheelsRear?: Maybe<Scalars['String']['output']>;
  urbanRealDrivingEmissionsTripNox?: Maybe<Scalars['Float']['output']>;
  urbanRealDrivingEmissionsTripParticles?: Maybe<Scalars['Float']['output']>;
  urbanRealDrivingEmissionsTripParticlesExponent?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
  vehicleCategory?: Maybe<Scalars['String']['output']>;
  vehicleFittedWithEcoInnovationIndication?: Maybe<Scalars['String']['output']>;
  verificationFactor?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  versionWeek?: Maybe<Scalars['Int']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
  weightedCombinedCo2Emissions?: Maybe<Scalars['Int']['output']>;
  weightedCombinedFuelConsumption?: Maybe<Scalars['Float']['output']>;
  wheelBase?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
  wltpSavingsGramsPerKm?: Maybe<Scalars['Float']['output']>;
  workingPrinciple?: Maybe<Scalars['String']['output']>;
  workingPrincipleCode?: Maybe<Scalars['String']['output']>;
};

export type GRIP_CocCertificateMeta = {
  certificate?: Maybe<GRIP_CocCertificate>;
  createdOn?: Maybe<Scalars['String']['output']>;
  fyon?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedOn?: Maybe<Scalars['String']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
};

export type GRIP_VehicleData = {
  availableLanguages?: Maybe<Array<Scalars['String']['output']>>;
  bodyTypeCode?: Maybe<Scalars['Int']['output']>;
  bodyTypeDescription?: Maybe<Scalars['String']['output']>;
  certificates?: Maybe<Array<Maybe<GRIP_CocCertificateMeta>>>;
  chassisCode?: Maybe<Scalars['String']['output']>;
  chassisNumber?: Maybe<Scalars['String']['output']>;
  co2Combined?: Maybe<Scalars['Float']['output']>;
  co2EmissionCombinedFL1?: Maybe<Scalars['Float']['output']>;
  colourPrice?: Maybe<Scalars['Float']['output']>;
  colourType?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['String']['output']>;
  destinationCountry?: Maybe<Scalars['String']['output']>;
  engineCapacity?: Maybe<Scalars['String']['output']>;
  engineCapacityCoc?: Maybe<Scalars['Float']['output']>;
  engineCode?: Maybe<Scalars['String']['output']>;
  engineDescription?: Maybe<Scalars['String']['output']>;
  enginePartNumber?: Maybe<Scalars['String']['output']>;
  enginePartSerialNumber?: Maybe<Scalars['String']['output']>;
  enginePower?: Maybe<Scalars['String']['output']>;
  enginePowerCoc?: Maybe<Scalars['Float']['output']>;
  enginePrice?: Maybe<Scalars['Float']['output']>;
  engineSerialNumber?: Maybe<Scalars['String']['output']>;
  engineSerialNumberFord?: Maybe<Scalars['String']['output']>;
  engineSerialNumberVolvo?: Maybe<Scalars['String']['output']>;
  exhaustEmissionCO?: Maybe<Scalars['Float']['output']>;
  exhaustEmissionCO2?: Maybe<Scalars['Float']['output']>;
  exhaustEmissionHC?: Maybe<Scalars['Float']['output']>;
  exhaustEmissionHCNO?: Maybe<Scalars['Float']['output']>;
  exhaustEmissionLevel?: Maybe<Scalars['String']['output']>;
  exhaustEmissionNOx?: Maybe<Scalars['Float']['output']>;
  exhaustEmissionParticle?: Maybe<Scalars['Float']['output']>;
  externalColour?: Maybe<Scalars['String']['output']>;
  externalColourCode?: Maybe<Scalars['String']['output']>;
  factoryCode?: Maybe<Scalars['Int']['output']>;
  fuelConsumptionCombined?: Maybe<Scalars['Float']['output']>;
  fuelConsumptionExurban?: Maybe<Scalars['Float']['output']>;
  fuelConsumptionUrban?: Maybe<Scalars['Float']['output']>;
  fuelType?: Maybe<Scalars['String']['output']>;
  fuelTypeCode?: Maybe<Scalars['String']['output']>;
  fyon?: Maybe<Scalars['Int']['output']>;
  gearboxCode?: Maybe<Scalars['String']['output']>;
  gearboxDescription?: Maybe<Scalars['String']['output']>;
  gearboxNumber?: Maybe<Scalars['String']['output']>;
  gearboxPartNumber?: Maybe<Scalars['String']['output']>;
  gearboxPrice?: Maybe<Scalars['Float']['output']>;
  gearboxSerialNumber?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  licensePlateVdw?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  market?: Maybe<Scalars['String']['output']>;
  marketingCode?: Maybe<Scalars['Int']['output']>;
  marketingDescription?: Maybe<Scalars['String']['output']>;
  maxNetPower?: Maybe<Scalars['String']['output']>;
  maximumSpeed?: Maybe<Scalars['Float']['output']>;
  modelCode?: Maybe<Scalars['String']['output']>;
  modelDescription?: Maybe<Scalars['String']['output']>;
  modelYear?: Maybe<Scalars['Int']['output']>;
  numberOfDoors?: Maybe<Scalars['String']['output']>;
  numberofSeats?: Maybe<Scalars['Int']['output']>;
  platformTypeCode?: Maybe<Scalars['Int']['output']>;
  platformTypeDescription?: Maybe<Scalars['String']['output']>;
  pno12?: Maybe<Scalars['String']['output']>;
  pno34Plus?: Maybe<Scalars['String']['output']>;
  projectCode?: Maybe<Scalars['String']['output']>;
  registrationDate?: Maybe<Scalars['String']['output']>;
  salesVersion?: Maybe<Scalars['String']['output']>;
  salesVersionDescription?: Maybe<Scalars['String']['output']>;
  salesVersionPrice?: Maybe<Scalars['Float']['output']>;
  specialVehicleCode?: Maybe<Scalars['String']['output']>;
  specialVehicleDescription?: Maybe<Scalars['String']['output']>;
  speedoUnit?: Maybe<Scalars['String']['output']>;
  steeringCode?: Maybe<Scalars['Int']['output']>;
  steeringDescription?: Maybe<Scalars['String']['output']>;
  steeringGearProdNumber?: Maybe<Scalars['String']['output']>;
  steeringPrice?: Maybe<Scalars['Float']['output']>;
  structureWeek?: Maybe<Scalars['Int']['output']>;
  upholsteryCode?: Maybe<Scalars['String']['output']>;
  upholsteryDescription?: Maybe<Scalars['String']['output']>;
  upholsteryPrice?: Maybe<Scalars['Float']['output']>;
  variantCode?: Maybe<Scalars['String']['output']>;
  variantDescription?: Maybe<Scalars['String']['output']>;
  variantPrice?: Maybe<Scalars['Float']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
  vinOptionPackages?: Maybe<Array<GRIP_VinOptionPackage>>;
  vinOptions?: Maybe<Array<GRIP_VinOption>>;
  vinPricelist?: Maybe<Scalars['String']['output']>;
  vinRetailPrice?: Maybe<Scalars['Float']['output']>;
  vinStandardFeatures?: Maybe<Array<GRIP_VinStandardFeature>>;
  warranty?: Maybe<Scalars['String']['output']>;
  warrantyCloseDate?: Maybe<Scalars['String']['output']>;
  warrantyReopenDate?: Maybe<Scalars['String']['output']>;
  wheelsCode?: Maybe<Scalars['String']['output']>;
  wheelsDescription?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type GRIP_VinOption = {
  vinOption?: Maybe<Scalars['String']['output']>;
  vinOptionCode?: Maybe<Scalars['String']['output']>;
  vinOptionLocal?: Maybe<Scalars['String']['output']>;
};

export type GRIP_VinOptionPackage = {
  vinOptionDescription?: Maybe<Scalars['String']['output']>;
  vinOptionPackage?: Maybe<Scalars['String']['output']>;
  vinOptionPackageCode?: Maybe<Scalars['String']['output']>;
  vinOptionPackagePrice?: Maybe<Scalars['Float']['output']>;
  vinOptionPackageType?: Maybe<Scalars['String']['output']>;
  vinOptions?: Maybe<Array<GRIP_VinOption>>;
};

export type GRIP_VinStandardFeature = {
  vinStandardFeature?: Maybe<Scalars['String']['output']>;
  vinStandardFeatureCode?: Maybe<Scalars['String']['output']>;
};

/** The image galleries available */
export type GalleryGroup = {
  /** The exterior gallery for Big Merge */
  bigMergeExteriorGallery?: Maybe<ImageGallery>;
  /** The hero gallery for Big Merge */
  bigMergeHero?: Maybe<ImageGallery>;
  /** The interior gallery for Big Merge */
  bigMergeInteriorGallery?: Maybe<ImageGallery>;
  custom: ImageGallery;
  /** The default gallery for exterior details images */
  exteriorDetails?: Maybe<ImageGallery>;
  /** The default gallery for exterior location images */
  exteriorLocation?: Maybe<ImageGallery>;
  /** The default gallery for exterior studio images */
  exteriorStudio?: Maybe<ImageGallery>;
  /** The default gallery for exterior studio proportional images */
  exteriorStudioProportional?: Maybe<ImageGallery>;
  /** The default gallery for interiors details images */
  interiorDetails?: Maybe<ImageGallery>;
  /** The default gallery for interiors location images */
  interiorLocation?: Maybe<ImageGallery>;
  /** The default gallery for interiors studio images */
  interiorStudio?: Maybe<ImageGallery>;
  /** The default gallery for interiors studio proportional images */
  interiorStudioProportional?: Maybe<ImageGallery>;
  /** The top view complete images of a car */
  topViewComplete?: Maybe<ImageGallery>;
  /** The top view component layers for the parts of a car */
  topViewComponents?: Maybe<ImageGallery>;
  /** The default gallery for wheel images */
  wheels?: Maybe<ImageGallery>;
};


/** The image galleries available */
export type GalleryGroupcustomArgs = {
  groupKeys: Array<Scalars['String']['input']>;
};

export type Gearbox = {
  code?: Maybe<Scalars['String']['output']>;
  globalName?: Maybe<Scalars['String']['output']>;
  localName?: Maybe<Scalars['String']['output']>;
};

export type GearboxContent = {
  displayName?: Maybe<StringProperty>;
};

export type GearboxResult = {
  content?: Maybe<GearboxContent>;
  delegationLog: Array<DelegationLogItem>;
  exception?: Maybe<DelegationException>;
  status: DelegationStatus;
};

export type GenerateTextComparison = {
  getTitle: Scalars['String']['output'];
  mainText: Scalars['String']['output'];
};

export type GlobalFeature = {
  code: Scalars['String']['output'];
  globalName?: Maybe<Scalars['String']['output']>;
  localName?: Maybe<Scalars['String']['output']>;
};

export enum Group {
  COLOR = 'COLOR',
  EXTERIOR = 'EXTERIOR',
  INTERIOR = 'INTERIOR',
  OPTIONS = 'OPTIONS',
  PACKAGES = 'PACKAGES',
  SUMMER_TYRES = 'SUMMER_TYRES',
  WHEELS = 'WHEELS',
  WINTER_WHEELS = 'WINTER_WHEELS'
}

/** Group */
export type GroupProperty = {
  enumDescription?: Maybe<Scalars['String']['output']>;
  formatted?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Group>;
  valueDescription?: Maybe<Scalars['String']['output']>;
};

export type GroupedCarList = {
  allGroupTypeCars: Array<Car>;
  cars: Array<Car>;
  first?: Maybe<Car>;
  groupBy: Array<GroupedCarList>;
  groupType?: Maybe<CarListGroupingType>;
  isSelected: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  priceSummary?: Maybe<CarPriceSummary>;
  relativeHighlightedFeatures?: Maybe<Array<Feature>>;
  selected?: Maybe<Car>;
  sortedOnPrice: CarList;
};


export type GroupedCarListgroupByArgs = {
  disableSorting?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterOnSelected?: InputMaybe<Scalars['Boolean']['input']>;
  groupType?: InputMaybe<CarListGroupingType>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedCarListpriceSummaryArgs = {
  priceConfigInput?: InputMaybe<PriceConfigurationInput>;
};


export type GroupedCarListrelativeHighlightedFeaturesArgs = {
  locale: Scalars['String']['input'];
};


export type GroupedCarListsortedOnPriceArgs = {
  priceConfigInput?: InputMaybe<PriceConfigurationInput>;
  sortMissingPriceAs: NullSortingStrategy;
};

export type GroupedOfferList = {
  filter: OfferFilter;
  first?: Maybe<Offer>;
  groupBy: Array<GroupedOfferList>;
  groupType: OfferGroupType;
  key: Scalars['String']['output'];
  offers: Array<Offer>;
};


export type GroupedOfferListgroupByArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  groupType: OfferGroupType;
};

export type HowItWorksContent = {
  image?: Maybe<ImageProperty>;
  shortDescription?: Maybe<StringProperty>;
  title?: Maybe<StringProperty>;
  video?: Maybe<VideoProperty>;
};

/** The different sizes available for each icon */
export type IconSizes = {
  /** The feature code being visualized */
  code: Scalars['String']['output'];
  /** The default icon is guaranteed to always exist, and can be used as a fallback if the size requested isn't available for some reason. */
  default: Image;
  /** The icon in a large size. */
  large?: Maybe<Image>;
  /** The icon in the largest possible size. */
  maximum?: Maybe<Image>;
  /** The icon in a medium size. */
  medium?: Maybe<Image>;
  /** The icon in the smallest possible size. */
  minimum?: Maybe<Image>;
  /** The icon in a small size. */
  small?: Maybe<Image>;
};

/** The icons for the different types of visualized features */
export type Icons = {
  /** The icon used for the color */
  color?: Maybe<IconSizes>;
  /** The icon used for the decor */
  decor?: Maybe<IconSizes>;
  /** The icon used for the gear shifter */
  gearShift?: Maybe<IconSizes>;
  /** The icon used for the seats/upholstery */
  seat?: Maybe<IconSizes>;
  /** The icon used for the steering wheel */
  steeringWheel?: Maybe<IconSizes>;
  /** The icon used for the wheel */
  wheel?: Maybe<IconSizes>;
};

/** An image */
export type Image = {
  /** A key for this particular image */
  key: Scalars['String']['output'];
  /** Image meta data */
  meta: ImageMeta;
  /** A url for an image with a transparent background, if available. Please keep in mind that generating transparent images puts more load on the service, so when possible please use the non-transparent URL. */
  transparentUrl?: Maybe<Scalars['String']['output']>;
  /** The url for the image. This url is not available for top-view components, please use transparentUrl */
  url?: Maybe<Scalars['String']['output']>;
};

/** An image gallery */
export type ImageGallery = {
  /** The images included in the gallery */
  images: Array<ImageSizes>;
  /** A key for the image gallery */
  key: Scalars['String']['output'];
};

/** An image, available in different sizes */
export type ImageGroup = {
  /** A key for the image group */
  key: Scalars['String']['output'];
  /** The different sizes available for each image in the group */
  sizes?: Maybe<ImageSizes>;
};

/** Image metadata */
export type ImageMeta = {
  /** The aspect ratio of the image expressed as a floating point number */
  aspectRatio: Scalars['Float']['output'];
  /** The height in pixels of the image */
  height: Scalars['Int']['output'];
  /** The width in pixels of the image */
  width: Scalars['Int']['output'];
};

/** Image Property */
export type ImageProperty = MediaProperty & {
  /** label describing value */
  label?: Maybe<Scalars['String']['output']>;
  mediaKey?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<MediaType>;
  url: Scalars['String']['output'];
};

/** The different sizes available for an image */
export type ImageSizes = {
  /** The default image is guaranteed to always exist, and can be used as a fallback if the size requested isn't available for some reason. */
  default: Image;
  /** The image in a large size */
  large?: Maybe<Image>;
  /** The image in the largest possible size */
  maximum?: Maybe<Image>;
  /** The image in a medium size */
  medium?: Maybe<Image>;
  /** The image in the smallest possible size */
  minimum?: Maybe<Image>;
  /** The image in a small size */
  small?: Maybe<Image>;
};

export type Inference = {
  id?: Maybe<Scalars['String']['output']>;
  inputs: Array<InferenceParameter>;
  model: Scalars['String']['output'];
  modelVersion?: Maybe<Scalars['String']['output']>;
  outputs: Array<InferenceOutput>;
  reliability?: Maybe<InferenceReliabilityResult>;
};

export type InferenceContent = {
  id?: Maybe<Scalars['String']['output']>;
  inputs: Array<InferenceParameter>;
  model: Scalars['String']['output'];
  modelVersion?: Maybe<Scalars['String']['output']>;
  outputs: Array<InferenceOutput>;
  reliability?: Maybe<InferenceReliabilityResult>;
};

export type InferenceContext = {
  modelName?: InputMaybe<Scalars['String']['input']>;
  perKeyProperties?: InputMaybe<Array<Array<InferenceProperty>>>;
};

export type InferenceModelInfo = {
  inputs: Array<InferenceModelInput>;
  name: Scalars['String']['output'];
};

export type InferenceModelInput = {
  name: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  type: InferenceModelInputType;
};

export enum InferenceModelInputType {
  Boolean = 'Boolean',
  Float = 'Float',
  Int = 'Int',
  String = 'String'
}

export type InferenceOutput = {
  name: Scalars['String']['output'];
  value: Scalars['InferenceOutputValue']['output'];
};

export type InferenceParameter = {
  name: Scalars['String']['output'];
  value: Scalars['InferenceParameterValue']['output'];
};

export type InferenceProperty = {
  key: Scalars['String']['input'];
  mergeStrategy?: InputMaybe<InferencePropertyMergeStrategy>;
  value: Scalars['InferencePropertyValue']['input'];
};

export enum InferencePropertyMergeStrategy {
  Add = 'Add',
  Override = 'Override'
}

export type InferenceReliabilityResult = {
  isReliable: Scalars['Boolean']['output'];
  resultBreakdown: Array<InferenceReliabilityResultItem>;
  status: InferenceReliabilityStatus;
};

export type InferenceReliabilityResultItem = {
  name: Scalars['String']['output'];
  status?: Maybe<InferenceReliabilityStatus>;
};

export enum InferenceReliabilityStatus {
  INELIGIBLE = 'INELIGIBLE',
  RELIABLE = 'RELIABLE',
  UNRELIABLE = 'UNRELIABLE'
}

export type InferenceResult = {
  content?: Maybe<InferenceContent>;
  delegationLog: Array<DelegationLogItem>;
  exception?: Maybe<DelegationException>;
  status: DelegationStatus;
};

/** Int Property */
export type IntProperty = {
  /** value formatted for display according to market setting */
  formatted?: Maybe<Scalars['String']['output']>;
  /** label describing value */
  label?: Maybe<Scalars['String']['output']>;
  /** describing which unit the value has */
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type InterestRate = {
  rate: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type InterestRateStep = {
  maximumDownpayment?: Maybe<PriceAmount>;
  maximumDownpaymentRate?: Maybe<PercentageRate>;
  minimumDownpayment?: Maybe<PriceAmount>;
  minimumDownpaymentRate?: Maybe<PercentageRate>;
  rate?: Maybe<PercentageRate>;
  type?: Maybe<Scalars['String']['output']>;
};

/** The views featuring the car's interior */
export type InteriorLocationViewGroup = {
  /** A view of the interior decor */
  decor?: Maybe<ImageGroup>;
  /** A driver's view of the interior of a car */
  driversView?: Maybe<ImageGroup>;
  /** A rear view of the interior of a car */
  rear?: Maybe<ImageGroup>;
  /** A view of the seats */
  seat?: Maybe<ImageGroup>;
  /** A view of the interior from the side */
  side?: Maybe<ImageGroup>;
};

/** The views featuring the car's interior */
export type InteriorStudioViewGroup = {
  /** A view of the interior decor */
  decor?: Maybe<ImageGroup>;
  /** A driver's view of the interior of a car */
  driversView?: Maybe<ImageGroup>;
  /** A view of the gear shifter */
  gearShift?: Maybe<ImageGroup>;
  /** A rear view of the interior of a car */
  rear?: Maybe<ImageGroup>;
  /** A view of the seats */
  seat?: Maybe<ImageGroup>;
  /** A view of the seat configuration */
  seatConfiguration?: Maybe<ImageGroup>;
  /** The views featuring the car's interior in a studio environment, proportionally sized relative to other models */
  seatConfigurationProportional?: Maybe<ImageGroup>;
  /** A view of the seat's fabric/upholstery */
  seatFabric?: Maybe<ImageGroup>;
  /** A view of the interior from the side */
  side?: Maybe<ImageGroup>;
  /** A view of the steering wheel */
  steeringWheel?: Maybe<ImageGroup>;
};

/** The views featuring the car's interior */
export type InteriorViewGroup = {
  /** The location visualizations featuring the car's interior */
  location?: Maybe<InteriorLocationViewGroup>;
  /** The studio visualizations featuring the car's interior */
  studio?: Maybe<InteriorStudioViewGroup>;
};

export type ItemPriceSummary = {
  discounts?: Maybe<Discounts>;
  price?: Maybe<PricePoint>;
};

export enum LikenessLevel {
  PNO3 = 'PNO3',
  PNO3E = 'PNO3E',
  PNO3My = 'PNO3My',
  PNO3MyE = 'PNO3MyE',
  PNO12 = 'PNO12',
  UNKNOWN = 'UNKNOWN'
}

export type MarketingCode = {
  alternativeCodes?: Maybe<Array<Scalars['String']['output']>>;
  carKey: Scalars['CarKey']['output'];
  co2Effect?: Maybe<Scalars['Boolean']['output']>;
  /** The unique (in this type) code for this component. */
  code: Scalars['String']['output'];
  componentBehavior?: Maybe<ComponentBehavior>;
  configurationStates?: Maybe<Array<Scalars['ConfigurationState']['output']>>;
  /** Content carries localized information about the component. */
  content?: Maybe<CarComponentContent>;
  features: Array<Feature>;
  globalName?: Maybe<Scalars['String']['output']>;
  localName?: Maybe<Scalars['String']['output']>;
  previousCarKey?: Maybe<Scalars['CarKey']['output']>;
  rootState?: Maybe<Scalars['ConfigurationState']['output']>;
  state?: Maybe<Scalars['ConfigurationState']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type: CarComponentType;
  visible?: Maybe<Scalars['Boolean']['output']>;
};


export type MarketingCodecontentArgs = {
  locale: Scalars['String']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarsCarKey = {
  body: Scalars['String']['output'];
  carType?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  engine: Scalars['String']['output'];
  gearbox: Scalars['String']['output'];
  marketingCode: Scalars['String']['output'];
  modelYear: Scalars['Float']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
  packages?: Maybe<Array<Scalars['String']['output']>>;
  sMessage?: Maybe<Scalars['String']['output']>;
  salesVersion: Scalars['String']['output'];
  specMarket: Scalars['String']['output'];
  steering: Scalars['String']['output'];
  structureWeek: Scalars['Float']['output'];
  upholstery?: Maybe<Scalars['String']['output']>;
};

export type Measurements = {
  actualCar?: Maybe<VehicleSpecification>;
  outputCar?: Maybe<VehicleSpecification>;
  similarity: SimilarityScores;
};

export type MediaProperty = {
  /** label describing value */
  label?: Maybe<Scalars['String']['output']>;
  mediaKey?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<MediaType>;
  url: Scalars['String']['output'];
};

export type MediaResult = {
  content?: Maybe<Array<Visualization>>;
  delegationLog: Array<DelegationLogItem>;
  exception?: Maybe<DelegationException>;
  status: DelegationStatus;
};

export enum MediaType {
  DOCUMENT = 'DOCUMENT',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO'
}

export enum MergeStrategy {
  LEFT_TO_RIGHT = 'LEFT_TO_RIGHT',
  RIGHT_TO_LEFT = 'RIGHT_TO_LEFT'
}

export type Mileage = {
  content?: Maybe<IntProperty>;
  id?: Maybe<Scalars['String']['output']>;
};


export type MileagecontentArgs = {
  locale: Scalars['String']['input'];
};

export type MsrpCarPrice = {
  /** Price of the complete car configuration */
  price?: Maybe<PricePoint>;
};

export type MsrpPriceConfigurationInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  /** The requested price date, used only to get prices in specific date (future or past) and should'nt be used to get today prices */
  priceDate?: InputMaybe<Scalars['DateTime']['input']>;
  roundingStrategy?: InputMaybe<RoundingStrategy>;
  /** Parameters for taxations passed to URAX */
  taxParameterInput?: InputMaybe<TaxParameterInput>;
};

export type MsrpPriceSummary = {
  /** Price of the car */
  carPrice?: Maybe<MsrpCarPrice>;
  /** Taxes */
  taxes?: Maybe<OfferTaxes>;
};

/** How to sort null values */
export enum NullSortingStrategy {
  PlaceFirst = 'PlaceFirst',
  PlaceLast = 'PlaceLast',
  Remove = 'Remove'
}

export type NumericOfferProperty = {
  formatted?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

/** Offer configuration */
export type Offer = {
  baseOffer: Scalars['BaseOffer']['output'];
  businessModel: OfferBusinessModel;
  carList: CarList;
  configuration: OfferConfiguration;
  contractLength?: Maybe<ContractLength>;
  customerType: CustomerType;
  filter: OfferFilter;
  /** Breakdown of the financing, applicable to Lease and Loan for flipped markets, any use of this field need to be handshaked with the price-engine team */
  financingPriceSummary?: Maybe<FinancingPriceSummary>;
  mileage?: Maybe<Mileage>;
  /** MSRP price summary of only the car object that is part of the offer. Use this if you are interested in the MSRP price of the car regardless of the actual sales model. */
  msrpPriceSummary?: Maybe<MsrpPriceSummary>;
  offerConfigurationState?: Maybe<Scalars['OfferConfigurationState']['output']>;
  offerKey: Scalars['OfferKey']['output'];
  /** Price summary of the offer */
  priceSummary?: Maybe<OfferPriceSummary>;
  /** The "products" field contains the products currently chosen */
  products: Products;
  salesModel: SalesModel;
  /** Transfer price summary of only the car object that is part of the offer. These prices require a valid AzureAD token with correct role to be send in auth header. */
  transferPriceSummary?: Maybe<TransferPriceSummary>;
  /** Wholesale price summary of only the car object that is part of the offer. These prices require a valid AzureAD token with correct role to be send in auth header. */
  wholesalePriceSummary?: Maybe<WholesalePriceSummary>;
};


/** Offer configuration */
export type OfferfinancingPriceSummaryArgs = {
  priceConfigInput?: InputMaybe<PriceConfigurationInputV2>;
};


/** Offer configuration */
export type OffermsrpPriceSummaryArgs = {
  priceConfigInput?: InputMaybe<MsrpPriceConfigurationInput>;
};


/** Offer configuration */
export type OfferpriceSummaryArgs = {
  priceConfigInput?: InputMaybe<PriceConfigurationInputV2>;
};


/** Offer configuration */
export type OffertransferPriceSummaryArgs = {
  priceConfigInput?: InputMaybe<MsrpPriceConfigurationInput>;
};


/** Offer configuration */
export type OfferwholesalePriceSummaryArgs = {
  priceConfigInput?: InputMaybe<MsrpPriceConfigurationInput>;
};

export type OfferBusinessModel = {
  id: Scalars['String']['output'];
};

export type OfferCarBundlePrice = {
  /** Price of the complete car configuration plus all other products that are financed together with the car, i.e. accessories and services */
  price?: Maybe<PricePoint>;
  /** Price of complete car configuration plus all other products that are financed together with the car, before discount was applied. Will be undefined if no discount is active in the offer. */
  priceBeforeDiscount?: Maybe<PricePoint>;
};

export type OfferCarPrice = {
  /** Price breakdown of the complete car configuration */
  breakdown?: Maybe<OfferCarPriceBreakdown>;
  /** Price of the complete car configuration that is part of the offer */
  price?: Maybe<PricePoint>;
  /** Price of complete car configuration that is part of the offer, before discount was applied. Will be undefined if no discount is active in the offer. */
  priceBeforeDiscount?: Maybe<PricePoint>;
};

export type OfferCarPriceBreakdown = {
  /** Price or the baseCar component */
  baseCar?: Maybe<OfferCarPriceBreakdownItem>;
  /** Price of the color */
  color?: Maybe<OfferCarPriceBreakdownItem>;
  /** Prices of the options */
  options?: Maybe<Array<OfferCarPriceBreakdownItem>>;
  /** Prices of the packages */
  packages?: Maybe<Array<OfferCarPriceBreakdownItem>>;
  /** Price of the upholstery */
  upholstery?: Maybe<OfferCarPriceBreakdownItem>;
};

export type OfferCarPriceBreakdownItem = {
  /** Code of the breakdown item, like option code, color code, etc. */
  code?: Maybe<Scalars['String']['output']>;
  /** Price of the breakdown item */
  price?: Maybe<PricePoint>;
};

export type OfferConfiguration = {
  offerKey: Scalars['OfferKey']['output'];
  packageSelections: Array<OfferPackageSelection>;
  selections: Array<OfferSelection>;
  token: OfferConfigurationToken;
};

export type OfferConfigurationChange = {
  selectionsAdded: Array<OfferSelectionChange>;
  selectionsRemoved: Array<OfferSelectionChange>;
  token: OfferConfigurationToken;
};

/** A configuration token is a unique identifier for an offer configuration. */
export type OfferConfigurationToken = {
  long: Scalars['String']['output'];
  short: Scalars['String']['output'];
};

export type OfferFilter = {
  brand: Scalars['String']['output'];
  clientType: Scalars['String']['output'];
  market: Scalars['String']['output'];
};

export enum OfferGroupType {
  CUSTOMER_TYPE = 'CUSTOMER_TYPE',
  SALES_MODEL = 'SALES_MODEL'
}

export type OfferList = {
  /** @deprecated It is not clear what cars to return for a offerList in this API that has a wide range of consumers with different needs. Users should instead query the carList on offers one by one and decide for themselves which cars are relevant for a group of offers. */
  carList: CarList;
  filter: OfferFilter;
  first?: Maybe<Offer>;
  groupBy: Array<GroupedOfferList>;
  offers: Array<Offer>;
};


export type OfferListgroupByArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  groupType: OfferGroupType;
};

/** Package is a representation of a package containing products (items). */
export type OfferPackage = {
  code: Scalars['String']['output'];
  content?: Maybe<PackageContent>;
  /** The id of the package */
  id: Scalars['String']['output'];
  /** The items in the package */
  items: Array<PackageItem>;
  offerConfigurationState?: Maybe<Scalars['OfferConfigurationState']['output']>;
  /** If the package is opt-in */
  optional: Scalars['Boolean']['output'];
  priceSummary?: Maybe<ItemPriceSummary>;
  /** Attributes of the package */
  tags: Array<OfferTag>;
};


/** Package is a representation of a package containing products (items). */
export type OfferPackagecontentArgs = {
  locale: Scalars['String']['input'];
};


/** Package is a representation of a package containing products (items). */
export type OfferPackagepriceSummaryArgs = {
  priceConfigInput?: InputMaybe<PriceConfigurationInputV2>;
};

/** Possible package selections */
export type OfferPackageSelection = {
  action: Scalars['String']['output'];
  appliedChange: OfferConfigurationChange;
  code?: Maybe<Scalars['String']['output']>;
  content?: Maybe<PackageContent>;
  /** The id of the selection */
  id: Scalars['String']['output'];
  items: Array<PackageItem>;
  priceSummary?: Maybe<OfferSelectionPriceSummary>;
  /** Attributes of the package selection */
  tags: Array<OfferTag>;
};


/** Possible package selections */
export type OfferPackageSelectioncontentArgs = {
  locale: Scalars['String']['input'];
};


/** Possible package selections */
export type OfferPackageSelectionpriceSummaryArgs = {
  priceConfigInput?: InputMaybe<PriceConfigurationInputV2>;
};

export type OfferPriceSummary = {
  /** Aggregations of prices and payments */
  aggregations?: Maybe<Aggregations>;
  /** Price of the complete car configuration plus all other products that are financed together with the car, i.e. accessories and services */
  carBundlePrice?: Maybe<OfferCarBundlePrice>;
  /** Price of the complete car configuration that is part this offer */
  carPrice?: Maybe<OfferCarPrice>;
  /** Price for the car, used for compability and will be removed in the future */
  carPriceSummary?: Maybe<CarPriceSummary>;
  /** The total discount of the purchase */
  discounts?: Maybe<Discounts>;
  /** Price of the selected mileage (temporary field that later will be moved to mileage) */
  mileagePrice?: Maybe<PricePoint>;
  /** Payments for the car */
  payments?: Maybe<Array<Payment>>;
  /** Price of the offer */
  price?: Maybe<PricePoint>;
  /** Taxes of the offer */
  taxes?: Maybe<OfferTaxes>;
};

/** Possible offer selections */
export type OfferSelection = {
  action: Scalars['String']['output'];
  appliedChange: OfferConfigurationChange;
  code?: Maybe<Scalars['String']['output']>;
  content?: Maybe<SelectionContent>;
  /** The id of the selection */
  id: Scalars['String']['output'];
  offerKey: Scalars['OfferKey']['output'];
  priceSummary?: Maybe<OfferSelectionPriceSummary>;
  /** Attributes of the selection */
  tags: Array<OfferTag>;
  /** The type of the selection */
  type: Scalars['String']['output'];
};


/** Possible offer selections */
export type OfferSelectioncontentArgs = {
  locale: Scalars['String']['input'];
};


/** Possible offer selections */
export type OfferSelectionpriceSummaryArgs = {
  priceConfigInput?: InputMaybe<PriceConfigurationInputV2>;
};

/** Selections added or removed from configuration */
export type OfferSelectionChange = {
  /**
   * Repressents a car
   * @deprecated Use referenceCar instead
   */
  carKey?: Maybe<Scalars['CarKey']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  content?: Maybe<SelectionContent>;
  /** The ID of the changed selection */
  id: Scalars['String']['output'];
  offerKey: Scalars['OfferKey']['output'];
  /** Reference car used for content */
  referenceCar?: Maybe<Scalars['AnnualPno12']['output']>;
  /** The Type of the changed selection */
  type: Scalars['String']['output'];
};


/** Selections added or removed from configuration */
export type OfferSelectionChangecontentArgs = {
  locale: Scalars['String']['input'];
};

export type OfferSelectionPriceSummary = {
  price?: Maybe<PricePoint>;
};

export enum OfferTag {
  FollowsCar = 'FollowsCar',
  FollowsCustomer = 'FollowsCustomer',
  PlusVSA = 'PlusVSA',
  StandardVSA = 'StandardVSA',
  UltraVSA = 'UltraVSA',
  VSA = 'VSA',
  /** @deprecated will not be supported in upcoming releases */
  VSAFixed = 'VSAFixed',
  VSAFixedTerm = 'VSAFixedTerm',
  /** @deprecated will not be supported in upcoming releases */
  VSAFlexible = 'VSAFlexible',
  VSAFlexibleTerm = 'VSAFlexibleTerm',
  /** @deprecated will not be supported in upcoming releases */
  VSARolling = 'VSARolling',
  VSARollingTerm = 'VSARollingTerm'
}

export type OfferTax = {
  amount?: Maybe<PricePoint>;
  frequency?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  taxId?: Maybe<Scalars['Float']['output']>;
  taxType?: Maybe<Scalars['String']['output']>;
  taxVersionId?: Maybe<Scalars['Float']['output']>;
  vatPosition?: Maybe<Scalars['String']['output']>;
  vatRate?: Maybe<Scalars['Float']['output']>;
};

export type OfferTaxes = {
  acquisition?: Maybe<Array<OfferTax>>;
  all?: Maybe<Array<OfferTax>>;
  informational?: Maybe<Array<OfferTax>>;
  ownership?: Maybe<Array<OfferTax>>;
};

export type Option = {
  alternativeCodes?: Maybe<Array<Scalars['String']['output']>>;
  carKey: Scalars['CarKey']['output'];
  co2Effect?: Maybe<Scalars['Boolean']['output']>;
  /** The unique (in this type) code for this component. */
  code: Scalars['String']['output'];
  componentBehavior?: Maybe<ComponentBehavior>;
  configurationStates?: Maybe<Array<Scalars['ConfigurationState']['output']>>;
  content?: Maybe<OptionContent>;
  features: Array<Feature>;
  globalName?: Maybe<Scalars['String']['output']>;
  /** The different image sizes available for each icon. */
  icon?: Maybe<IconSizes>;
  localName?: Maybe<Scalars['String']['output']>;
  packages: Array<Package>;
  /**
   * For Vista use only! Tells if an option or package is part of the start configuration. This is equivalent to included flag in CCH.
   * @deprecated Temporary solution for Vista
   */
  partOfStartConfiguration: Scalars['Boolean']['output'];
  previousCarKey?: Maybe<Scalars['CarKey']['output']>;
  rootState?: Maybe<Scalars['ConfigurationState']['output']>;
  state?: Maybe<Scalars['ConfigurationState']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type: CarComponentType;
  visible: Scalars['Boolean']['output'];
  /** Option is visualized. Returns null if it cannot be established that the option could be visualized or not. */
  visualized?: Maybe<Scalars['Boolean']['output']>;
};


export type OptioncontentArgs = {
  locale: Scalars['String']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OptionvisualizedArgs = {
  marketOrLocale: Scalars['String']['input'];
};

export type OptionContent = CarComponentContent & {
  categoryPlacement?: Maybe<CategoryPlacement>;
  description?: Maybe<StringProperty>;
  displayName?: Maybe<StringProperty>;
  entityType?: Maybe<UpstreamEntityTypeProperty>;
  group?: Maybe<GroupProperty>;
  /** @deprecated Replaced by 'images' */
  image?: Maybe<ImageProperty>;
  /** Contains a collection of images. Replaces 'image' */
  images: Array<ImageProperty>;
  matchingCode: Scalars['String']['output'];
  meta?: Maybe<SystemMeta>;
  optionCode: Scalars['String']['output'];
  shortDescription?: Maybe<StringProperty>;
  /** @deprecated Replaced by 'videos' */
  video?: Maybe<VideoProperty>;
  /** Contains a collection of videos. Replaces 'video' */
  videos: Array<VideoProperty>;
};

export type OptionResult = {
  content?: Maybe<Array<OptionContent>>;
  delegationLog: Array<DelegationLogItem>;
  exception?: Maybe<DelegationException>;
  status: DelegationStatus;
};

/** The type of option, reflecting where in the pipeline it is added to the car */
export enum OptionType {
  ACCESSORY = 'ACCESSORY',
  LOCAL_OPTION = 'LOCAL_OPTION',
  OPTION = 'OPTION'
}

/** The sales model specified by the user when placing the order. */
export enum OrderTrackingSalesModel {
  CASH = 'CASH',
  SUB = 'SUB',
  SUB_FIXED = 'SUB_FIXED'
}

export type Package = {
  alternativeCodes?: Maybe<Array<Scalars['String']['output']>>;
  carKey: Scalars['CarKey']['output'];
  co2Effect?: Maybe<Scalars['Boolean']['output']>;
  /** The unique (in this type) code for this component. */
  code: Scalars['String']['output'];
  componentBehavior?: Maybe<ComponentBehavior>;
  components: Array<CarComponent>;
  configurationStates?: Maybe<Array<Scalars['ConfigurationState']['output']>>;
  content?: Maybe<PackageContent>;
  features: Array<Feature>;
  globalName?: Maybe<Scalars['String']['output']>;
  /** The different image sizes available for each icon. */
  icon?: Maybe<IconSizes>;
  localName?: Maybe<Scalars['String']['output']>;
  /**
   * For Vista use only! Tells if an option or package is part of the start configuration. This is equivalent to included flag in CCH.
   * @deprecated Temporary solution for Vista
   */
  partOfStartConfiguration: Scalars['Boolean']['output'];
  previousCarKey?: Maybe<Scalars['CarKey']['output']>;
  rootState?: Maybe<Scalars['ConfigurationState']['output']>;
  state?: Maybe<Scalars['ConfigurationState']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type: CarComponentType;
  visible?: Maybe<Scalars['Boolean']['output']>;
  /** Package is visualized. Returns null if it cannot be established that the package could be visualized or not. */
  visualized?: Maybe<Scalars['Boolean']['output']>;
};


export type PackagecontentArgs = {
  locale: Scalars['String']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PackagevisualizedArgs = {
  marketOrLocale: Scalars['String']['input'];
};

export type PackageContent = CarComponentContent & {
  categoryPlacement?: Maybe<CategoryPlacement>;
  description?: Maybe<StringProperty>;
  displayName?: Maybe<StringProperty>;
  entityType?: Maybe<UpstreamEntityTypeProperty>;
  group?: Maybe<GroupProperty>;
  /** @deprecated Replaced by 'images' */
  image?: Maybe<ImageProperty>;
  /** Contains a collection of images. Replaces 'image' */
  images: Array<ImageProperty>;
  matchingCode?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<SystemMeta>;
  packageCode: Scalars['String']['output'];
  shortDescription?: Maybe<StringProperty>;
  thumbnail?: Maybe<ImageProperty>;
  /** @deprecated Replaced by 'videos' */
  video?: Maybe<VideoProperty>;
  /** Contains a collection of videos. Replaces 'video' */
  videos: Array<VideoProperty>;
};

/** Package item is a representation of the items in a package. */
export type PackageItem = {
  /**
   * Repressents a car
   * @deprecated Use referenceCar instead
   */
  carKey?: Maybe<Scalars['CarKey']['output']>;
  content?: Maybe<ProductContent>;
  /** The id of the package item */
  id: Scalars['String']['output'];
  /** Reference car used for content */
  referenceCar?: Maybe<Scalars['AnnualPno12']['output']>;
  /** The type of the product */
  type: Scalars['String']['output'];
};


/** Package item is a representation of the items in a package. */
export type PackageItemcontentArgs = {
  locale: Scalars['String']['input'];
};

export type PackageResult = {
  content?: Maybe<Array<PackageContent>>;
  delegationLog: Array<DelegationLogItem>;
  exception?: Maybe<DelegationException>;
  status: DelegationStatus;
};

export type Payment = {
  amount?: Maybe<PricePoint>;
  paymentPosition?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<Scalars['String']['output']>;
};

export type PaymentPlanAggregation = {
  /** Total amount to pay after checkout */
  afterCheckout?: Maybe<PricePoint>;
  /** Total amount to pay at checkout */
  atCheckout?: Maybe<PricePoint>;
  /** Total amount to pay per month */
  recurring?: Maybe<PricePoint>;
};

export type PercentageRate = {
  /** Rate formatted for display, example 10% */
  display?: Maybe<Scalars['String']['output']>;
  /** Rate in percentage, example 10 */
  percentage?: Maybe<Scalars['Float']['output']>;
  /** Rate in decimal, example 0.1 */
  rate?: Maybe<Scalars['Float']['output']>;
};

export type Pno = {
  pno12: Scalars['String']['output'];
  pno34: Scalars['String']['output'];
  pno34PlusOptions: Scalars['String']['output'];
  pno34PlusOptionsWithoutAccessories: Scalars['String']['output'];
};

export type Pno34AndStructureWeekInput = {
  pno34: Scalars['String']['input'];
  structureWeek: Scalars['Int']['input'];
};

export type PriceAdjustment = {
  central: Scalars['Boolean']['output'];
  draft: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  modelCodes: Array<Scalars['Int']['output']>;
  modified?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  offerId: Scalars['String']['output'];
  published: Scalars['Boolean']['output'];
  tags: Array<Scalars['String']['output']>;
  values?: Maybe<PriceAdjustmentValues>;
};

export type PriceAdjustmentValues = {
  adjustment: Scalars['String']['output'];
};

export type PriceAmount = {
  /** The 'raw' price amount. */
  amount?: Maybe<Scalars['Float']['output']>;
  amountDisplayed?: Maybe<Scalars['Boolean']['output']>;
  /** The currency used to format the price in the "display" field */
  currency?: Maybe<Scalars['String']['output']>;
  /** The display price of the price amount. */
  display?: Maybe<Scalars['String']['output']>;
  includingVat: Scalars['Boolean']['output'];
  selector?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  /** The amount of tax, if available. */
  taxAmount?: Maybe<Scalars['Float']['output']>;
};


export type PriceAmountdisplayArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type PriceConfigurationInput = {
  /** The chosen contract length for monthly SalesModels. */
  contractLength?: InputMaybe<Scalars['Float']['input']>;
  /** The chosen customer type. Defaults to B2C if not specified. */
  customerType?: InputMaybe<Scalars['String']['input']>;
  /** The id of the discount plan to be applied */
  discountPlanId?: InputMaybe<Scalars['String']['input']>;
  /** The chosen downpayment-amount. */
  downpayment?: InputMaybe<Scalars['Float']['input']>;
  locale: Scalars['String']['input'];
  /** The chosen mileage for monthly SalesModels. */
  mileage?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priceComponents?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The requested price date, used only to get prices in specific date (future or past) and should'nt be used to get today prices */
  priceDate?: InputMaybe<Scalars['DateTime']['input']>;
  priceDates?: InputMaybe<Array<TaxationInput>>;
  priceSelectorOverrides?: InputMaybe<PriceSelectorOverrides>;
  roundingStrategy?: InputMaybe<RoundingStrategy>;
  taxation?: InputMaybe<Array<TaxationInput>>;
  /** The requested taxation date */
  taxationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Apply internal automatic downpayment adjustment rules. Set this flag to true and omit the downpayment input value in order to internally use default downpayment configured for a market */
  useAutomaticDownpaymentAdjustment?: InputMaybe<Scalars['Boolean']['input']>;
  variableReferences?: InputMaybe<Array<VariableReference>>;
};

export type PriceConfigurationInputV2 = {
  /** The id of the discount plan to be applied */
  discountPlanId?: InputMaybe<Scalars['String']['input']>;
  /** The chosen downpayment-amount. */
  downpayment?: InputMaybe<Scalars['Float']['input']>;
  /** The chosen final payment amount. */
  finalPayment?: InputMaybe<Scalars['Float']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  /** The requested price date, used only to get prices in specific date (future or past) and should'nt be used to get today prices */
  priceDate?: InputMaybe<Scalars['DateTime']['input']>;
  priceDates?: InputMaybe<Array<TaxationInput>>;
  roundingStrategy?: InputMaybe<RoundingStrategy>;
  /** Parameters for taxations passed to URAX */
  taxParameterInput?: InputMaybe<TaxParameterInput>;
  /** Apply internal automatic downpayment adjustment rules. Set this flag to true and omit the downpayment input value in order to internally use default downpayment configured for a market */
  useAutomaticDownpaymentAdjustment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PriceListConfigurationInput = {
  /** The chosen customer type. Defaults to B2C if not specified. */
  customerType?: InputMaybe<Scalars['String']['input']>;
  /** Locale. Used to determine market internally. Also used for display price formatting. */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** The requested price date, used only to get prices in specific date (future or past) and should'nt be used to get today prices */
  priceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Rounding strategy used for formatting display prices. Note that this only takes effect on display string, prices and calculations themselves are not affected */
  roundingStrategy?: InputMaybe<RoundingStrategy>;
  /** The chosen sales model. */
  salesModel?: InputMaybe<Scalars['String']['input']>;
  /** Parameters for taxations passed to URAX */
  taxParameterInput?: InputMaybe<TaxParameterInput>;
};

export type PriceMileageUnit = {
  display?: Maybe<Scalars['String']['output']>;
  /** The 'raw' unit */
  unit?: Maybe<Scalars['String']['output']>;
  /** The unit of measure */
  uom?: Maybe<Scalars['String']['output']>;
  /** The 'raw' unit value */
  value?: Maybe<Scalars['Float']['output']>;
};

export type PricePoint = {
  /** Price that will show correct incl/excl VAT */
  displayPrice?: Maybe<PriceAmount>;
  /** Price excluding all taxes */
  priceExclTax?: Maybe<PriceAmount>;
  /** Price including all taxes except VAT */
  priceInclNonVatTax?: Maybe<PriceAmount>;
  /** Price including all taxes */
  priceInclTax?: Maybe<PriceAmount>;
  /** Price including VAT, but excluding other taxes */
  priceInclVat?: Maybe<PriceAmount>;
  /** Sum of all taxes */
  taxAmount?: Maybe<PriceAmount>;
  /** VAT */
  vatAmount?: Maybe<PriceAmount>;
};

export type PriceSelectorOverrides = {
  /** Valid values: listPrice, listPretaxPrice, relativeBasePrice, relativeBasePriceSplitTax, requiredChangesPrice, requiredChangesPriceSplitTax, relativePretaxBasePrice, requiredChangesPretaxPrice */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Valid values: price, relativePrice, relativePretaxPrice */
  driveLine?: InputMaybe<Scalars['String']['input']>;
  /** Valid values: listPrice, listPretaxPrice, relativeBasePrice, relativeBasePriceSplitTax, requiredChangesPrice, requiredChangesPriceSplitTax, relativePretaxBasePrice, requiredChangesPretaxPrice */
  option?: InputMaybe<Scalars['String']['input']>;
  /** Valid values: listPrice, listPretaxPrice, relativeBasePrice, relativeBasePriceSplitTax, requiredChangesPrice, requiredChangesPriceSplitTax, relativePretaxBasePrice, requiredChangesPretaxPrice */
  package?: InputMaybe<Scalars['String']['input']>;
  /** Valid values: price, relativePrice, relativePretaxPrice */
  salesVersion?: InputMaybe<Scalars['String']['input']>;
  /** Valid values: price, relativePrice, relativePretaxPrice */
  seats?: InputMaybe<Scalars['String']['input']>;
  /** Valid values: listPrice, listPretaxPrice, relativeBasePrice, relativeBasePriceSplitTax, requiredChangesPrice, requiredChangesPriceSplitTax, relativePretaxBasePrice, requiredChangesPretaxPrice */
  upholstery?: InputMaybe<Scalars['String']['input']>;
};

/** Product is a representation of accessories and services that we sell. */
export type Product = {
  code: Scalars['String']['output'];
  content?: Maybe<ProductContent>;
  /** The id of the product */
  id: Scalars['String']['output'];
  offerConfigurationState?: Maybe<Scalars['OfferConfigurationState']['output']>;
  /** If the product is opt-in */
  optional: Scalars['Boolean']['output'];
  priceSummary?: Maybe<ItemPriceSummary>;
  /** Attributes of the product */
  tags: Array<OfferTag>;
  /** The type of the product */
  type: Scalars['String']['output'];
};


/** Product is a representation of accessories and services that we sell. */
export type ProductcontentArgs = {
  locale: Scalars['String']['input'];
};


/** Product is a representation of accessories and services that we sell. */
export type ProductpriceSummaryArgs = {
  priceConfigInput?: InputMaybe<PriceConfigurationInputV2>;
};

export type ProductContent = {
  description?: Maybe<StringProperty>;
  disclaimer?: Maybe<StringProperty>;
  displayName?: Maybe<StringProperty>;
  /** @deprecated Replaced by 'images' */
  image?: Maybe<ImageProperty>;
  /** Contains a collection of images. Replaces 'image' */
  images: Array<ImageProperty>;
  shortDescription?: Maybe<StringProperty>;
  thumbnail?: Maybe<ImageProperty>;
  /** @deprecated Replaced by 'videos' */
  video?: Maybe<VideoProperty>;
  /** Contains a collection of videos. Replaces 'video' */
  videos: Array<VideoProperty>;
};

/** Products is a collection of products that we sell. Currently car, accessories and services. */
export type Products = {
  /** The selected accessories */
  accessories: Array<Product>;
  /** The selected CarKey */
  car?: Maybe<Scalars['CarKey']['output']>;
  /** If the selected car is a BTO */
  isBto?: Maybe<Scalars['Boolean']['output']>;
  /** The selected packages */
  packages: Array<OfferPackage>;
  /** The selected services */
  services: Array<Product>;
  sortedServices: Array<Product>;
  /** The selected winter wheels */
  winterWheels?: Maybe<Product>;
};


/** Products is a collection of products that we sell. Currently car, accessories and services. */
export type ProductssortedServicesArgs = {
  locale: Scalars['String']['input'];
};

export type Query = {
  _sdl: Scalars['String']['output'];
  compareMeToQuery: Array<Array<GenerateTextComparison>>;
  datasetQuery: CarKeyEnhancedDataSet;
  inferenceModels: Array<InferenceModelInfo>;
  priceAdjustments: Array<PriceAdjustment>;
  specificationByFyon: Array<Maybe<VehicleSpecification>>;
  specificationByLicensePlate: Array<Maybe<VehicleSpecification>>;
  specificationByPno34AndStructureWeek: Array<VehicleSpecification>;
  specificationByToken: Array<VehicleSpecification>;
  specificationByVid: Array<Maybe<VehicleSpecification>>;
  specificationByVin: Array<Maybe<VehicleSpecification>>;
};


export type QuerycompareMeToQueryArgs = {
  carKeys: Array<CarKeyInput>;
  outputCars: Array<CarKeyInput>;
};


export type QuerydatasetQueryArgs = {
  dataset?: InputMaybe<Dataset>;
  fltr?: InputMaybe<Array<Filter>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerypriceAdjustmentsArgs = {
  carType: Scalars['String']['input'];
  retailerBranchcode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryspecificationByFyonArgs = {
  fyon: Array<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type QueryspecificationByLicensePlateArgs = {
  licensePlate: Array<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type QueryspecificationByPno34AndStructureWeekArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  pno34AndStructureWeek: Array<Pno34AndStructureWeekInput>;
};


export type QueryspecificationByTokenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  token: Array<Scalars['String']['input']>;
};


export type QueryspecificationByVidArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  vid: Array<Scalars['String']['input']>;
};


export type QueryspecificationByVinArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  vin: Array<Scalars['String']['input']>;
};

export type RealTimeFinancingBreakdown = {
  /** The amount before financing, adjusted with any discounts */
  adjustedPreFinancingAmount?: Maybe<PricePoint>;
  /** List the available final payment amounts (AKA balloon payment) */
  availableFinalPayments?: Maybe<Array<PriceAmount>>;
  /** The financed amount: preFinancingPrice - downpayment - manufacturer deposit */
  creditAmount?: Maybe<PriceAmount>;
  /** The total interest amount + total fees */
  creditCostAmount?: Maybe<PriceAmount>;
  /** The customers downpayment */
  downpayment?: Maybe<Payment>;
  /**
   * The customers downpayment
   * @deprecated Use downpayment field
   */
  downpaymentAmount?: Maybe<PriceAmount>;
  excessMileageRate?: Maybe<Scalars['Float']['output']>;
  fees?: Maybe<Array<Fee>>;
  /** The baloon payment */
  finalPaymentAmount?: Maybe<PriceAmount>;
  financeDiscountContribution?: Maybe<PricePoint>;
  /** Amount of Credit with interest, fees and insurances */
  financedAmount?: Maybe<PriceAmount>;
  /** The first month payment amount. */
  firstMonthPayment?: Maybe<PriceAmount>;
  interestAmount?: Maybe<PriceAmount>;
  /** List the available interest rates and the corresponding downpayment-spans */
  interestRateSteps?: Maybe<Array<InterestRateStep>>;
  interestRates?: Maybe<Array<InterestRate>>;
  /**
   * Manufacturer deposit amount that lowers the creditAmount
   * @deprecated manufacturerDepositAmount will be replaced by financeDiscountContribution
   */
  manufacturerDepositAmount?: Maybe<PriceAmount>;
  /** The monthly price */
  perInstallmentPrice?: Maybe<PriceAmount>;
  /** The full price before financing */
  preFinancingPrice?: Maybe<PricePoint>;
  /** The customers prePayment */
  prePayment?: Maybe<Payment>;
  /** Identifier for the financial calculation, for PCP/Volvo loan this is the simulationChecksum */
  referenceId?: Maybe<Scalars['String']['output']>;
  /** The total payment for the customer before starting financing (prePayment + downPayment) */
  totalDeposit?: Maybe<PricePoint>;
  /** preFinancingPrice + interest + fees */
  totalPayableAmount?: Maybe<PriceAmount>;
};

/** Represents the required configuration change, in order to transition to this configuration. */
export type RequiredChange = {
  baseCarKey: Scalars['CarKey']['output'];
  carKey: Scalars['CarKey']['output'];
  component: CarComponent;
  componentsAdded?: Maybe<Array<CarComponent>>;
  componentsRemoved?: Maybe<Array<CarComponent>>;
  dataVisibility: CarVisibility;
  offerKey?: Maybe<Scalars['OfferKey']['output']>;
  priceSummary?: Maybe<ComponentPriceSummary>;
  rootBaseCarKey: Scalars['CarKey']['output'];
  rootCarKey: Scalars['CarKey']['output'];
  rootState?: Maybe<Scalars['ConfigurationState']['output']>;
  state?: Maybe<Scalars['ConfigurationState']['output']>;
};


/** Represents the required configuration change, in order to transition to this configuration. */
export type RequiredChangepriceSummaryArgs = {
  priceConfigInput?: InputMaybe<PriceConfigurationInput>;
};

export type RequiredChangeComponentPriceSummary = ComponentPriceSummary & {
  all?: Maybe<ComponentPriceFields>;
  code: Scalars['String']['output'];
  price?: Maybe<PriceAmount>;
  type: Scalars['String']['output'];
};

/** What rounding strategy to use whn rounding prices */
export enum RoundingStrategy {
  alwaysDecimals = 'alwaysDecimals',
  alwaysRound = 'alwaysRound',
  decimalsIfNeeded = 'decimalsIfNeeded',
  noRounding = 'noRounding',
  roundToNearestTen = 'roundToNearestTen'
}

export type SMessage = {
  alternativeCodes?: Maybe<Array<Scalars['String']['output']>>;
  carKey: Scalars['CarKey']['output'];
  co2Effect?: Maybe<Scalars['Boolean']['output']>;
  /** The unique (in this type) code for this component. */
  code: Scalars['String']['output'];
  componentBehavior?: Maybe<ComponentBehavior>;
  configurationStates?: Maybe<Array<Scalars['ConfigurationState']['output']>>;
  /** Content carries localized information about the component. */
  content?: Maybe<CarComponentContent>;
  features: Array<Feature>;
  globalName?: Maybe<Scalars['String']['output']>;
  localName?: Maybe<Scalars['String']['output']>;
  previousCarKey?: Maybe<Scalars['CarKey']['output']>;
  rootState?: Maybe<Scalars['ConfigurationState']['output']>;
  state?: Maybe<Scalars['ConfigurationState']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type: CarComponentType;
  visible?: Maybe<Scalars['Boolean']['output']>;
};


export type SMessagecontentArgs = {
  locale: Scalars['String']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SafetyRating = {
  error?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  modelCode?: Maybe<Scalars['String']['output']>;
  modelYear?: Maybe<Scalars['Int']['output']>;
  pno12?: Maybe<Scalars['String']['output']>;
  responseCode?: Maybe<Scalars['String']['output']>;
  safetyRating?: Maybe<Scalars['String']['output']>;
  safetySystem?: Maybe<Array<SafetySystem>>;
  specificationMarket?: Maybe<Scalars['String']['output']>;
};

export type SafetyRatingResult = {
  content?: Maybe<SafetyRating>;
  delegationLog: Array<DelegationLogItem>;
  exception?: Maybe<DelegationException>;
  status: DelegationStatus;
};

export type SafetySystem = {
  available?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type SalesLevelContent = {
  description?: Maybe<StringProperty>;
  displayName?: Maybe<StringProperty>;
  entityType?: Maybe<UpstreamEntityTypeProperty>;
  formattedRule?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by 'images' */
  image?: Maybe<ImageProperty>;
  /** Contains a collection of images. Replaces 'image' */
  images: Array<ImageProperty>;
  key: Scalars['String']['output'];
  meta?: Maybe<SystemMeta>;
  salesLevelType: Scalars['String']['output'];
  shortDescription?: Maybe<StringProperty>;
  /**
   * Value indicating relative position of
   * this item in the sorted list of items of the same type.
   * Zero-based and may not be set.
   * Implemented for Models, Model families, Trims, Trim families, Product lines, Themes and Editions.
   * For types where it's supported it ignores the locale and always returns
   * the global sort order if present.
   */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Replaced by 'videos' */
  video?: Maybe<VideoProperty>;
  /** Contains a collection of videos. Replaces 'video' */
  videos: Array<VideoProperty>;
};

export type SalesLevelResult = {
  content?: Maybe<SalesLevelContent>;
  delegationLog: Array<DelegationLogItem>;
  exception?: Maybe<DelegationException>;
  status: DelegationStatus;
};

export type SalesModel = {
  content?: Maybe<SalesModelContent>;
  id: Scalars['String']['output'];
};


export type SalesModelcontentArgs = {
  locale: Scalars['String']['input'];
};

export type SalesModelContent = {
  /** Explains the mileage buckets if there’s one */
  annualMileage?: Maybe<StringProperty>;
  /** Explains the contract lengths available */
  contractTerm?: Maybe<StringProperty>;
  description?: Maybe<StringProperty>;
  disclaimer?: Maybe<StringProperty>;
  displayName?: Maybe<StringProperty>;
  /** Explains what happens when the contract is over */
  endOfContract?: Maybe<StringProperty>;
  /** Explains if you can get charged for exceeding agreement (mileage or wear) */
  excessFees?: Maybe<StringProperty>;
  howItWorks?: Maybe<Array<HowItWorksContent>>;
  /** @deprecated Replaced by 'images' */
  image?: Maybe<ImageProperty>;
  /** Contains a collection of images. Replaces 'image' */
  images: Array<ImageProperty>;
  /** Explains how the payments are done (fixed monthly/rolling, etc.) */
  paymentMethod?: Maybe<StringProperty>;
  /** Explains the mandatory payments (such as one month prepaid) before receiving your car */
  prepayment?: Maybe<StringProperty>;
  sellingPoints?: Maybe<Array<StringProperty>>;
  /** Explains whether you can pay the remaining payable fees early or not */
  settlementOption?: Maybe<StringProperty>;
  shortDescription?: Maybe<StringProperty>;
  /**
   * Value indicating relative position of
   * this item in the sorted list of items of the same type.
   * Zero-based and may not be set.
   * For Sales models it returns locale-specific sort order if present, otherwise
   * the global one.
   */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  thumbnail?: Maybe<ImageProperty>;
  /** @deprecated Replaced by 'videos' */
  video?: Maybe<VideoProperty>;
  /** Contains a collection of videos. Replaces 'video' */
  videos: Array<VideoProperty>;
};

export type SalesVersion = {
  code?: Maybe<Scalars['String']['output']>;
  globalName?: Maybe<Scalars['String']['output']>;
  localName?: Maybe<Scalars['String']['output']>;
};

export type SalesVersionScore = FeatureScore & {
  score?: Maybe<Scalars['Float']['output']>;
};

export type SelectedPaymentOption = {
  /** The price amount to be checked against the policy for a chosen sales model at the moment when the customer ordered the car */
  price: Scalars['Float']['input'];
  /** The sales model (cash, subscription, fixed subscription) chosen by the customer when ordering the car */
  salesModel: OrderTrackingSalesModel;
};

export type SelectionContent = AccessoryContent | CustomerTypeContent | NumericOfferProperty | PackageContent | SalesModelContent | ServiceContent;

/** A selling point, may be only title or more detailed */
export type SellingPointContent = {
  /** Description for the selling point, may be empty */
  description?: Maybe<StringProperty>;
  /** Small icon for the selling point, may be empty */
  icon?: Maybe<ImageProperty>;
  /** Media for the selling point, image or video, may be empty */
  media?: Maybe<MediaProperty>;
  /** Title for the selling point */
  title?: Maybe<StringProperty>;
};

export type ServiceContent = ProductContent & {
  description?: Maybe<StringProperty>;
  disclaimer?: Maybe<StringProperty>;
  displayName?: Maybe<StringProperty>;
  /** @deprecated Replaced by 'images' */
  image?: Maybe<ImageProperty>;
  /** Contains a collection of images. Replaces 'image' */
  images: Array<ImageProperty>;
  sellingPoints?: Maybe<Array<Maybe<SellingPointContent>>>;
  shortDescription?: Maybe<StringProperty>;
  /**
   * Value indicating relative position of
   * this item in the sorted list of items of the same type.
   * Zero-based and may not be set.
   * For Services it returns locale-specific sort order if present, otherwise
   * the global one.
   */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  thumbnail?: Maybe<ImageProperty>;
  /** @deprecated Replaced by 'videos' */
  video?: Maybe<VideoProperty>;
  /** Contains a collection of videos. Replaces 'video' */
  videos: Array<VideoProperty>;
};

export type SimQuality = {
  quality: Scalars['Float']['output'];
  similarity: Scalars['Float']['output'];
};

export type SimilarCar = {
  city?: Maybe<Scalars['String']['output']>;
  classifiedPrice: Scalars['Int']['output'];
  classifiedPublishedDate: Scalars['String']['output'];
  county?: Maybe<Scalars['String']['output']>;
  findBySimilarity?: Maybe<Scalars['Float']['output']>;
  meta?: Maybe<SimilarCarMeta>;
  modelYear: Scalars['Int']['output'];
  municipality?: Maybe<Scalars['String']['output']>;
  odometerStatusKm: Scalars['Int']['output'];
  pno12: Scalars['String']['output'];
  retailerName?: Maybe<Scalars['String']['output']>;
  salesInformation?: Maybe<SimilarCarSalesInformation>;
  /** How similar the car is to the original car. Lower score is more similar. */
  score: Scalars['Float']['output'];
  url?: Maybe<Scalars['String']['output']>;
  vatDeductibleStatus?: Maybe<SimilarCarsVatDeductibleStatus>;
  vehicle: SimilarVehicle;
  vid: Scalars['String']['output'];
};

export type SimilarCarMeta = {
  displayName?: Maybe<Scalars['String']['output']>;
  fetchedDate: Scalars['String']['output'];
  thumbnailImage?: Maybe<Scalars['String']['output']>;
};

export type SimilarCarSalesInformation = {
  daysBeforeSale?: Maybe<Scalars['Int']['output']>;
  salesDate: Scalars['String']['output'];
};

export type SimilarCarsData = {
  coverage: Coverage;
  items: Array<SimilarCar>;
  likenessLevel: LikenessLevel;
  likenessMatch: Scalars['String']['output'];
};

export type SimilarCarsResult = {
  content?: Maybe<SimilarCarsData>;
  delegationLog: Array<DelegationLogItem>;
  exception?: Maybe<DelegationException>;
  status: DelegationStatus;
};

export type SimilarCarsVatDeductibleStatus = {
  hasFullHistory: Scalars['Boolean']['output'];
  isDeductible: Scalars['Boolean']['output'];
  numberOfPreviousOwners: Scalars['Int']['output'];
};

export type SimilarVehicle = {
  car: Car;
  id?: Maybe<Scalars['ID']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
};

export type SimilarityResult = {
  content: Array<CarKeySimilarityMeasurements>;
  delegationLog: Array<DelegationLogItem>;
  exception?: Maybe<DelegationException>;
  status: DelegationStatus;
};

export type SimilarityScores = {
  Overall: SimQuality;
  overallScore: Scalars['Float']['output'];
};

export type Steering = {
  alternativeCodes?: Maybe<Array<Scalars['String']['output']>>;
  carKey: Scalars['CarKey']['output'];
  co2Effect?: Maybe<Scalars['Boolean']['output']>;
  /** The unique (in this type) code for this component. */
  code: Scalars['String']['output'];
  componentBehavior?: Maybe<ComponentBehavior>;
  configurationStates?: Maybe<Array<Scalars['ConfigurationState']['output']>>;
  /** Content carries localized information about the component. */
  content?: Maybe<CarComponentContent>;
  features: Array<Feature>;
  globalName?: Maybe<Scalars['String']['output']>;
  localName?: Maybe<Scalars['String']['output']>;
  previousCarKey?: Maybe<Scalars['CarKey']['output']>;
  rootState?: Maybe<Scalars['ConfigurationState']['output']>;
  state?: Maybe<Scalars['ConfigurationState']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type: CarComponentType;
  visible?: Maybe<Scalars['Boolean']['output']>;
};


export type SteeringcontentArgs = {
  locale: Scalars['String']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};

/** String Property */
export type StringProperty = {
  /** label describing value */
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SubFilter = {
  keys: Array<Scalars['StrOrFloat']['input']>;
  lowerBound?: Scalars['Int']['input'];
  name: FilterName;
  type: FilterType;
  upperBound?: Scalars['Int']['input'];
};

export type Subscription = {
  summarizeComparison: Scalars['String']['output'];
};


export type SubscriptionsummarizeComparisonArgs = {
  carKeyLeft: CarKeyInput;
  carKeyLeftSummaryParams?: InputMaybe<CarKeySummaryParams>;
  carKeyRight: CarKeyInput;
  carKeyRightSummaryParams?: InputMaybe<CarKeySummaryParams>;
};

/** Metadata */
export type SystemMeta = {
  entityId?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  systemName?: Maybe<Scalars['String']['output']>;
};

export type TaxParameterInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  companyCarMileage?: InputMaybe<Scalars['Float']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  personalisedNumberPlates?: InputMaybe<Scalars['Boolean']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  salary?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
  taxTerritory?: InputMaybe<Scalars['String']['input']>;
  taxationDate?: InputMaybe<Scalars['DateTime']['input']>;
  taxationDates?: InputMaybe<Array<TaxationInput>>;
};

export type TaxationInput = {
  carType?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['String']['input'];
  engine?: InputMaybe<Scalars['String']['input']>;
  modelYear?: InputMaybe<Scalars['String']['input']>;
};

export type TechnicalData = {
  /** Time for acceleration from 0-100 km/h (0-60 mph) */
  acceleration?: Maybe<TechnicalDataComponentV2>;
  /** List of all technical data fields */
  all?: Maybe<Array<TechnicalDataComponentV2>>;
  /** Charging time in hours when charging from:0% to:100% with 2-phases and 6A (Charging time can vary depending on vehicle climatization and other active electric loads in the vehicle. Charging time as well depends on e.g. ambient temperature) */
  batteryChargingDuration2phase6A?: Maybe<TechnicalDataComponentV2>;
  /** Charging time in hours when charging from:0% to:100% with 2-phases and 10A (Charging time can vary depending on vehicle climatization and other active electric loads in the vehicle. Charging time as well depends on e.g. ambient temperature) */
  batteryChargingDuration2phase10A?: Maybe<TechnicalDataComponentV2>;
  /** Charging time in hours when charging from:0% to:100% with 2-phases and 16A (Charging time can vary depending on vehicle climatization and other active electric loads in the vehicle. Charging time as well depends on e.g. ambient temperature) */
  batteryChargingDuration2phase16A?: Maybe<TechnicalDataComponentV2>;
  /** Charging time in hours when charging from:0% to:100% with 3-phases and 6A (Charging time can vary depending on vehicle climatization and other active electric loads in the vehicle. Charging time as well depends on e.g. ambient temperature) */
  batteryChargingDuration3phase6A?: Maybe<TechnicalDataComponentV2>;
  /**
   * Charging time in hours when charging from:0% to:100% with 3-phases and 8A (Charging time can vary depending on vehicle climatization and other active electric loads in the vehicle. Charging time as well depends on e.g. ambient temperature)
   * @deprecated 8A does no longer exist in the Official data sheets
   */
  batteryChargingDuration3phase8A?: Maybe<TechnicalDataComponentV2>;
  /** Charging time in hours when charging from:0% to:100% with 3-phases and 10A (Charging time can vary depending on vehicle climatization and other active electric loads in the vehicle. Charging time as well depends on e.g. ambient temperature) */
  batteryChargingDuration3phase10A?: Maybe<TechnicalDataComponentV2>;
  /** Charging time in hours when charging from:0% to:100% with 3-phases and 16A (Charging time can vary depending on vehicle climatization and other active electric loads in the vehicle. Charging time as well depends on e.g. ambient temperature) */
  batteryChargingDuration3phase16A?: Maybe<TechnicalDataComponentV2>;
  /**
   * Charging time in hours when charging from:0% to:100% with 3-phases and 32A (Charging time can vary depending on vehicle climatization and other active electric loads in the vehicle. Charging time as well depends on e.g. ambient temperature)
   * @deprecated 32A does no longer exist in the Official data sheets
   */
  batteryChargingDuration3phase32A?: Maybe<TechnicalDataComponentV2>;
  /** Charging time in hours when charging from:0% to:100% with 1-phase and 6A (Charging time can vary depending on vehicle climatization and other active electric loads in the vehicle. Charging time as well depends on e.g. ambient temperature) */
  batteryChargingDuration6A?: Maybe<TechnicalDataComponentV2>;
  /**
   * Charging time in hours when charging from:0% to:100% with 1-phase and 8A (Charging time can vary depending on vehicle climatization and other active electric loads in the vehicle. Charging time as well depends on e.g. ambient temperature)
   * @deprecated 8A does no longer exist in the Official data sheets
   */
  batteryChargingDuration8A?: Maybe<TechnicalDataComponentV2>;
  /** Charging time in hours when charging from:0% to:100% with 1-phase and 10A (Charging time can vary depending on vehicle climatization and other active electric loads in the vehicle. Charging time as well depends on e.g. ambient temperature) */
  batteryChargingDuration10A?: Maybe<TechnicalDataComponentV2>;
  /** Charging time in hours when charging from:0% to:100% with 1-phase and 16A (Charging time can vary depending on vehicle climatization and other active electric loads in the vehicle. Charging time as well depends on e.g. ambient temperature) */
  batteryChargingDuration16A?: Maybe<TechnicalDataComponentV2>;
  /** Charging time in hours when charging from:0% to:100% with 1-phase and 32A (Charging time can vary depending on vehicle climatization and other active electric loads in the vehicle. Charging time as well depends on e.g. ambient temperature) */
  batteryChargingDuration32A?: Maybe<TechnicalDataComponentV2>;
  /** Charging time in minutes when charging from: 10% to:80% with 50 kW DC (Charging time can vary depending on vehicle climatization and other active electric loads in the vehicle. Charging time as well depends on e.g. ambient temperature) */
  batteryChargingDurationDc50kw?: Maybe<TechnicalDataComponentV2>;
  /**
   * Charging time in minutes when charging from: 10% to:80% with 75 kW DC (Charging time can vary depending on vehicle climatization and other active electric loads in the vehicle. Charging time as well depends on e.g. ambient temperature)
   * @deprecated 75 kw does no longer exist in the Official data sheets
   */
  batteryChargingDurationDc75kw?: Maybe<TechnicalDataComponentV2>;
  /** Charging time in minutes when charging from: 10% to:80% with 100 kW DC (Charging time can vary depending on vehicle climatization and other active electric loads in the vehicle. Charging time as well depends on e.g. ambient temperature) */
  batteryChargingDurationDc100kw?: Maybe<TechnicalDataComponentV2>;
  /**
   * Charging time in minutes when charging from: 10% to:80% with 125 kW DC (Charging time can vary depending on vehicle climatization and other active electric loads in the vehicle. Charging time as well depends on e.g. ambient temperature)
   * @deprecated 125 kw does no longer exist in the Official data sheets
   */
  batteryChargingDurationDc125kw?: Maybe<TechnicalDataComponentV2>;
  /** Charging time in minutes when charging from: 10% to:80% with 150 kW DC (Charging time can vary depending on vehicle climatization and other active electric loads in the vehicle. Charging time as well depends on e.g. ambient temperature) */
  batteryChargingDurationDc150kw?: Maybe<TechnicalDataComponentV2>;
  /** Charging time in minutes when charging from: 10% to:80% with 200 kW DC (Charging time can vary depending on vehicle climatization and other active electric loads in the vehicle. Charging time as well depends on e.g. ambient temperature) */
  batteryChargingDurationDc200kw?: Maybe<TechnicalDataComponentV2>;
  /** Charging time in minutes when charging from: 10% to:80% with 250 kW DC (Charging time can vary depending on vehicle climatization and other active electric loads in the vehicle. Charging time as well depends on e.g. ambient temperature) */
  batteryChargingDurationDc250kw?: Maybe<TechnicalDataComponentV2>;
  /** Charging time in minutes when charging from: 10% to:80% with 300 kW DC (Charging time can vary depending on vehicle climatization and other active electric loads in the vehicle. Charging time as well depends on e.g. ambient temperature) */
  batteryChargingDurationDc300kw?: Maybe<TechnicalDataComponentV2>;
  /** Charging time in minutes when charging from: 10% to:80% with 350 kW DC (Charging time can vary depending on vehicle climatization and other active electric loads in the vehicle. Charging time as well depends on e.g. ambient temperature) */
  batteryChargingDurationDc350kw?: Maybe<TechnicalDataComponentV2>;
  /** Charging time in minutes when charging from: 10% to:80% with 400 kW DC (Charging time can vary depending on vehicle climatization and other active electric loads in the vehicle. Charging time as well depends on e.g. ambient temperature) */
  batteryChargingDurationDc400kw?: Maybe<TechnicalDataComponentV2>;
  batteryNominalEnergy?: Maybe<TechnicalDataComponentV2>;
  batteryUsableEnergy?: Maybe<TechnicalDataComponentV2>;
  /** Body width */
  bodyWidth?: Maybe<TechnicalDataComponentV2>;
  /** Open Luggage Compartment - Second | Second seat up. Load height limited to the upper edge of the second seatback or second window */
  cargoCapacity?: Maybe<TechnicalDataComponentV2>;
  co2ClassChargeSustain?: Maybe<TechnicalDataComponentV2>;
  co2ClassCombined?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of CO2 emission data from the 'total' cycle test on the exact configuration in charge sustain mode. */
  co2EmissionsChargeSustainWltpTotal?: Maybe<TechnicalDataComponentV2>;
  co2EmissionsNedcCombined?: Maybe<TechnicalDataComponentV2>;
  co2EmissionsNedcEudc?: Maybe<TechnicalDataComponentV2>;
  co2EmissionsNedcUdc?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of CO2 emissions rang where min (BEST) value is taken from 'co2EmissionsWltpTotal' on the exact configuration, and max (WORST) value is from 'wltpEmissionsCombinedRangeMax' on the base car. */
  co2EmissionsRangeBestWorstWltpTotal?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of CO2 emission data in the 'extra_high' cycle test on the exact configuration, BEV:s are always represented by a '0' value. */
  co2EmissionsWltpExtraHigh?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of CO2 emission data in the 'high' cycle test on the exact configuration, BEV:s are always represented by a '0' value. */
  co2EmissionsWltpHigh?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of CO2 emission data in the 'low' cycle test on the exact configuration, BEV:s are always represented by a '0' value. */
  co2EmissionsWltpLow?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of CO2 emission data in the 'medium' cycle test on the exact configuration, BEV:s are always represented by a '0' value. */
  co2EmissionsWltpMedium?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of CO2 emission data from the 'total' cycle test on the exact configuration, for PHEV it's representing the 'Weighted_Total' and BEV:s are always represented by a '0' value. */
  co2EmissionsWltpTotal?: Maybe<TechnicalDataComponentV2>;
  /** Max curb weight */
  curbWeightMax?: Maybe<TechnicalDataComponentV2>;
  /** Standard curb weight */
  curbWeightStandard?: Maybe<TechnicalDataComponentV2>;
  /** Status of data from REDA example ['production', 'Forecast] */
  dataStatus?: Maybe<TechnicalDataComponentV2>;
  electricEnergyConsumptionNedcCombined?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of electric energy consumption from the 'city' cycle test on the exact configuration. */
  electricEnergyConsumptionWltpCity?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of electric energy consumption from the 'extra high' cycle test on the exact configuration. */
  electricEnergyConsumptionWltpExtraHigh?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of electric energy consumption from the 'high' cycle test on the exact configuration. */
  electricEnergyConsumptionWltpHigh?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of electric energy consumption from the 'low' cycle test on the exact configuration. */
  electricEnergyConsumptionWltpLow?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of electric energy consumption from the 'medium' cycle test on the exact configuration. */
  electricEnergyConsumptionWltpMedium?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of electric energy consumption from the 'total' cycle test on the exact configuration. */
  electricEnergyConsumptionWltpTotal?: Maybe<TechnicalDataComponentV2>;
  electricEnergyConsumptionWltpTotalCd?: Maybe<TechnicalDataComponentV2>;
  /** Electric range from base car */
  electricRange?: Maybe<TechnicalDataComponentV2>;
  electricRangeNedcCombined?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of electric range from the 'city' cycle test on the exact configuration. */
  electricRangeWltpCity?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of electric range from the 'extra high' cycle test on the exact configuration. */
  electricRangeWltpExtraHigh?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of electric range from the 'high' cycle test on the exact configuration. */
  electricRangeWltpHigh?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of electric range from the 'low' cycle test on the exact configuration. */
  electricRangeWltpLow?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of electric range from the 'medium' cycle test on the exact configuration. */
  electricRangeWltpMedium?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of electric range from the 'total' cycle test on the exact configuration. */
  electricRangeWltpTotal?: Maybe<TechnicalDataComponentV2>;
  /** @deprecated  */
  emissions?: Maybe<TechnicalDataComponentV2>;
  engineBore?: Maybe<TechnicalDataComponentV2>;
  engineCylinders?: Maybe<TechnicalDataComponentV2>;
  engineDisplacement?: Maybe<TechnicalDataComponentV2>;
  /** @deprecated Use `engine.content.engineDisplayName` instead */
  engineDisplayName?: Maybe<TechnicalDataComponentV2>;
  /** @deprecated Use `engine.content.localName` instead */
  engineName?: Maybe<TechnicalDataComponentV2>;
  /** @deprecated Use `engine.content.shortName` instead */
  engineShortDisplayName?: Maybe<TechnicalDataComponentV2>;
  engineStroke?: Maybe<TechnicalDataComponentV2>;
  engineType: EngineTypeProperty;
  environmentalClassification?: Maybe<TechnicalDataComponentV2>;
  /** Front luggage volume */
  frontCargoCapacity?: Maybe<TechnicalDataComponentV2>;
  fuelCapacity?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of fuel consumption from the 'total' cycle test on the exact configuration in charge sustain mode. */
  fuelConsumptionChargeSustainWltpTotal?: Maybe<TechnicalDataComponentV2>;
  /** Fuel consumption city from base car */
  fuelConsumptionCity?: Maybe<TechnicalDataComponentV2>;
  /** Fuel consumption highway from base car */
  fuelConsumptionHighway?: Maybe<TechnicalDataComponentV2>;
  /** Fuel consumption mexied from base car */
  fuelConsumptionMixed?: Maybe<TechnicalDataComponentV2>;
  fuelConsumptionNedcCombined?: Maybe<TechnicalDataComponentV2>;
  fuelConsumptionNedcEudc?: Maybe<TechnicalDataComponentV2>;
  fuelConsumptionNedcUdc?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of fuel consumption rang where min (BEST) value is taken from 'fuelConsumptionWltpTotal' on the exact configuration, and max (WORST) value is from 'wltpFuelConsumptionCombinedRangeMax' on the base car. */
  fuelConsumptionRangeBestWorstWltpTotal?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of fuel consumption from the 'extra high' cycle test on the exact configuration, BEV:s are not represented with data. */
  fuelConsumptionWltpExtraHigh?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of fuel consumption from the 'high' cycle test on the exact configuration, BEV:s are not represented with data. */
  fuelConsumptionWltpHigh?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of fuel consumption from the 'low' cycle test on the exact configuration, BEV:s are not represented with data. */
  fuelConsumptionWltpLow?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of fuel consumption from the 'medium' cycle test on the exact configuration, BEV:s are not represented with data. */
  fuelConsumptionWltpMedium?: Maybe<TechnicalDataComponentV2>;
  /** Calculated value of fuel consumption from the 'total' cycle test on the exact configuration, for PHEV it's representing the 'Weighted_Total' and BEV:s are not represented with data. */
  fuelConsumptionWltpTotal?: Maybe<TechnicalDataComponentV2>;
  fuelType: FuelTypeProperty;
  /** Gross vehicle weight */
  grossVehicleWeight?: Maybe<TechnicalDataComponentV2>;
  headroomFront?: Maybe<TechnicalDataComponentV2>;
  headroomRear?: Maybe<TechnicalDataComponentV2>;
  headroomThirdRow?: Maybe<TechnicalDataComponentV2>;
  height?: Maybe<TechnicalDataComponentV2>;
  /** Height at curb weight */
  heightAtCurbWeight?: Maybe<TechnicalDataComponentV2>;
  highlights?: Maybe<Array<TechnicalDataComponentV2>>;
  hipRoomFront?: Maybe<TechnicalDataComponentV2>;
  hipRoomRear?: Maybe<TechnicalDataComponentV2>;
  hipRoomThirdRow?: Maybe<TechnicalDataComponentV2>;
  horsepowerElectric?: Maybe<TechnicalDataComponentV2>;
  horsepowerFuel?: Maybe<TechnicalDataComponentV2>;
  horsepowerRevMax?: Maybe<TechnicalDataComponentV2>;
  horsepowerRevMaxElectric?: Maybe<TechnicalDataComponentV2>;
  horsepowerTotal?: Maybe<TechnicalDataComponentV2>;
  interpolationFamilyName?: Maybe<TechnicalDataComponentV2>;
  interpolationFamilyVersion?: Maybe<TechnicalDataComponentV2>;
  /** Power of engines in KW that comes from electrical engines */
  kilowattsElectric?: Maybe<TechnicalDataComponentV2>;
  /** Power of engines in KW that comes from combustion engine */
  kilowattsFuel?: Maybe<TechnicalDataComponentV2>;
  /** Total power of engines in KW both from electric and combustion */
  kilowattsTotal?: Maybe<TechnicalDataComponentV2>;
  /** Leg room front row */
  legRoomFront?: Maybe<TechnicalDataComponentV2>;
  /** Leg room rear row */
  legRoomRear?: Maybe<TechnicalDataComponentV2>;
  /** Leg room third row */
  legRoomThirdRow?: Maybe<TechnicalDataComponentV2>;
  /** Vehicle length */
  length?: Maybe<TechnicalDataComponentV2>;
  maxSpeed?: Maybe<TechnicalDataComponentV2>;
  maxSpeedElectric?: Maybe<TechnicalDataComponentV2>;
  /** @deprecated  */
  name?: Maybe<TechnicalDataComponentV2>;
  nedcStatus?: Maybe<TechnicalDataComponentV2>;
  /** @deprecated Use `driveline.content.driveType` instead */
  powerTrainTypeDisplayName?: Maybe<TechnicalDataComponentV2>;
  propulsionType?: Maybe<TechnicalDataComponentV2>;
  /** @deprecated Use `engine.content.electricRangeType` instead */
  rangeType?: Maybe<TechnicalDataComponentV2>;
  roofWeight?: Maybe<TechnicalDataComponentV2>;
  shoulderRoomFront?: Maybe<TechnicalDataComponentV2>;
  shoulderRoomRear?: Maybe<TechnicalDataComponentV2>;
  shoulderRoomThirdRow?: Maybe<TechnicalDataComponentV2>;
  torqueElectric?: Maybe<TechnicalDataComponentV2>;
  torqueFuel?: Maybe<TechnicalDataComponentV2>;
  torqueRevMax?: Maybe<TechnicalDataComponentV2>;
  torqueRevMaxElectric?: Maybe<TechnicalDataComponentV2>;
  torqueRevMin?: Maybe<TechnicalDataComponentV2>;
  torqueTotal?: Maybe<TechnicalDataComponentV2>;
  towingCapacity?: Maybe<TechnicalDataComponentV2>;
  trackFront?: Maybe<TechnicalDataComponentV2>;
  trackRear?: Maybe<TechnicalDataComponentV2>;
  turningCircle?: Maybe<TechnicalDataComponentV2>;
  weightActualMass?: Maybe<TechnicalDataComponentV2>;
  weightHomologationCurbWeightTotal?: Maybe<TechnicalDataComponentV2>;
  weightMassInRunningOrderIPFHigh?: Maybe<TechnicalDataComponentV2>;
  weightMassInRunningOrderTotal?: Maybe<TechnicalDataComponentV2>;
  weightMassOfOptionalEquipmentTotal?: Maybe<TechnicalDataComponentV2>;
  /** Status of data from REDA example ['Official', 'Preliminary] */
  weightStatus?: Maybe<TechnicalDataComponentV2>;
  weightTestMassInd?: Maybe<TechnicalDataComponentV2>;
  weightTpMaxLadenMass?: Maybe<TechnicalDataComponentV2>;
  /** Wheel base of vehicle */
  wheelbase?: Maybe<TechnicalDataComponentV2>;
  /** Vehicle width (without mirrors) */
  width?: Maybe<TechnicalDataComponentV2>;
  /** Vehicle width with mirrors */
  widthMirrors?: Maybe<TechnicalDataComponentV2>;
  /** Vehicle width with mirrors folded */
  widthMirrorsFolded?: Maybe<TechnicalDataComponentV2>;
  wltpElectricEnergyConsumptionCombinedRangeMax?: Maybe<TechnicalDataComponentV2>;
  wltpElectricEnergyConsumptionCombinedRangeMin?: Maybe<TechnicalDataComponentV2>;
  wltpElectricRangeCityRangeMax?: Maybe<TechnicalDataComponentV2>;
  wltpElectricRangeCityRangeMin?: Maybe<TechnicalDataComponentV2>;
  wltpElectricRangeCombinedRangeMax?: Maybe<TechnicalDataComponentV2>;
  wltpElectricRangeCombinedRangeMin?: Maybe<TechnicalDataComponentV2>;
  wltpEmissionsCombinedRangeMax?: Maybe<TechnicalDataComponentV2>;
  wltpEmissionsCombinedRangeMin?: Maybe<TechnicalDataComponentV2>;
  wltpEnabled: Scalars['Boolean']['output'];
  wltpFuelConsumptionCombinedRangeMax?: Maybe<TechnicalDataComponentV2>;
  wltpFuelConsumptionCombinedRangeMin?: Maybe<TechnicalDataComponentV2>;
  /** @deprecated  */
  wltpServingWeightRangeMax?: Maybe<TechnicalDataComponentV2>;
  wltpServingWeightRangeMin?: Maybe<TechnicalDataComponentV2>;
  /** Status of data from REDA example ['Official', 'Preliminary] */
  wltpStatus?: Maybe<TechnicalDataComponentV2>;
  /** @deprecated  */
  wltpTotalWeightRangeMin?: Maybe<TechnicalDataComponentV2>;
};

export type TechnicalDataComponentV2 = {
  exactStringValue?: Maybe<TechnicalDataStringValue>;
  exactValue?: Maybe<TechnicalDataFloatValue>;
  formatted: Scalars['String']['output'];
  group?: Maybe<Scalars['String']['output']>;
  highlighted: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  legacyKey?: Maybe<Scalars['String']['output']>;
  maxFloatValue?: Maybe<TechnicalDataFloatValue>;
  meta?: Maybe<SystemMeta>;
  minFloatValue?: Maybe<TechnicalDataFloatValue>;
  unit?: Maybe<Scalars['String']['output']>;
  unitSystem?: Maybe<UnitSystem>;
};

export type TechnicalDataFloatValue = {
  formatted: Scalars['String']['output'];
  source: Scalars['String']['output'];
  /** The matching key from the source data, e.g. 'reda.electricRange.wltP_PHEV_ER.wltP_PHEV_EAER_Total' */
  sourceKey?: Maybe<Scalars['String']['output']>;
  sourceValue: Scalars['Float']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
};

export type TechnicalDataStringValue = {
  formatted: Scalars['String']['output'];
  source: Scalars['String']['output'];
  /** The matching key from the source data, e.g. 'reda.electricRange.wltP_PHEV_ER.wltP_PHEV_EAER_Total' */
  sourceKey?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Decides the structure week to use when configuring based on a token */
export enum TokenStructureWeekStrategy {
  /** Use the current structure week */
  CURRENT = 'CURRENT',
  /** Use the structure week on the passed in token */
  FROM_TOKEN = 'FROM_TOKEN'
}

/** The Top views for door states of a car */
export type TopViewCompleteDoorsViewGroup = {
  /** Top view with doors and trunk open */
  doorsAndTrunkOpen?: Maybe<ImageSizes>;
  /** Top view with doors open */
  doorsOpen?: Maybe<ImageSizes>;
  /** Top view with left door and trunk open */
  leftDoorAndTrunkOpen?: Maybe<ImageSizes>;
  /** Top view with left door open */
  leftDoorOpen?: Maybe<ImageSizes>;
  /** Top view with right door and trunk open */
  rightDoorAndTrunkOpen?: Maybe<ImageSizes>;
  /** Top view with right door open */
  rightDoorOpen?: Maybe<ImageSizes>;
};

/** Top view for the fueling/charging states of a car */
export type TopViewCompleteFuelingStateViewGroup = {
  /** Top view featuring the indicator for fueling/charging completed */
  fueled?: Maybe<ImageSizes>;
  /** Top view featuring the indicator for fueling/charging ongoing */
  fueling?: Maybe<ImageSizes>;
  /** Top view featuring the indicator for fueling/charging error */
  fuelingError?: Maybe<ImageSizes>;
  /** Top view featuring the indicator for fueling/charging paused */
  fuelingPaused?: Maybe<ImageSizes>;
  /** Top view featuring the indicator for fueling/charging scheduled */
  fuelingScheduled?: Maybe<ImageSizes>;
};

/** The complete Top views of a car */
export type TopViewCompleteViewGroup = {
  /** Top view with all doors open */
  allDoorsOpen?: Maybe<ImageSizes>;
  /** The Top views for front door states of a car */
  frontDoors?: Maybe<TopViewCompleteDoorsViewGroup>;
  /** Top views for the car's fueling states */
  fueling?: Maybe<TopViewCompleteFuelingStateViewGroup>;
  /** The Top views for rear door states of a car */
  rearDoors?: Maybe<TopViewCompleteDoorsViewGroup>;
  /** Top view with hidden roof */
  roofHidden?: Maybe<ImageSizes>;
  /** Standard Top view */
  standardView?: Maybe<ImageSizes>;
  /** Standard Top view with retracted side mirrors */
  standardViewRetractedMirrors?: Maybe<ImageSizes>;
  /** Top view with trunk open */
  trunkOpen?: Maybe<ImageSizes>;
  /** Top view with trunk open and retracted side mirrors */
  trunkOpenRetractedMirrors?: Maybe<ImageSizes>;
};

/** The Top view component layers for door states of a car */
export type TopViewComponentDoorStateViewGroup = {
  /** The component layers for the left door states */
  left?: Maybe<TopViewDoorStateViewGroup>;
  /** The component layers for the right door states */
  right?: Maybe<TopViewDoorStateViewGroup>;
  /** The component layers for the trunk door states */
  trunk?: Maybe<TopViewDoorState>;
};

/** The Top view component layers for the fueling/charging states of a car */
export type TopViewComponentFuelingStateViewGroup = {
  /** The component layer featuring the indicator for fueling/charging mechanism connected */
  fuelConnected?: Maybe<ImageSizes>;
  /** The component layer featuring the indicator for fueling/charging error */
  fuelIndicatorError?: Maybe<ImageSizes>;
  /** The component layer featuring the indicator for fueling/charging completed */
  fuelIndicatorFueled?: Maybe<ImageSizes>;
  /** The component layer featuring the indicator for fueling/charging ongoing */
  fuelIndicatorFueling?: Maybe<ImageSizes>;
  /** The component layer featuring the indicator for fueling/charging paused */
  fuelIndicatorPaused?: Maybe<ImageSizes>;
  /** The component layer featuring the indicator for fueling/charging scheduled */
  fuelIndicatorScheduled?: Maybe<ImageSizes>;
  /** The component layer featuring the closed fueling/charging port */
  fuelPortClosed?: Maybe<ImageSizes>;
  /** The component layer featuring the open fueling/charging port */
  fuelPortOpen?: Maybe<ImageSizes>;
};

/** The top view lighting view */
export type TopViewComponentLightingView = {
  /** Top view lighting dark mode for the current group */
  dark?: Maybe<ImageSizes>;
  /** Top view lighting light mode for the current group */
  light?: Maybe<ImageSizes>;
};

/** The Top view component layers for the side mirror states of a car */
export type TopViewComponentMirrorStateViewGroup = {
  /** The component layers for the left side mirrors */
  left?: Maybe<TopViewMirrorStateViewGroup>;
  /** The component layers for the right side mirrors */
  right?: Maybe<TopViewMirrorStateViewGroup>;
};

/** The top view component layers for the parts of a car */
export type TopViewComponentStateViewGroup = {
  /** The component layers for the car's air cleaning states */
  airCleaning?: Maybe<TopViewComponentViewGroup>;
  /** The component layers for the car's alarm indicator states */
  alarmIndicator?: Maybe<TopViewComponentViewGroup>;
  /** The component layer for the base of the car */
  baseCar?: Maybe<ImageSizes>;
  /** The component layers for the car's cooling states */
  cooling?: Maybe<TopViewComponentViewGroup>;
  /** The component layers for the car's doors */
  doors?: Maybe<TopViewComponentDoorStateViewGroup>;
  /** The component layers for the car's exterior lights states */
  exteriorLights?: Maybe<TopViewComponentViewGroup>;
  /** The component layers for the car's frunk states */
  frunk?: Maybe<TopViewComponentLightingView>;
  /** The component layers for the car's fueling states */
  fueling?: Maybe<TopViewComponentFuelingStateViewGroup>;
  /** The component layers for the car's heating states */
  heating?: Maybe<TopViewComponentViewGroup>;
  /** The component layers for the car's interior cabin states */
  interiorCabin?: Maybe<TopViewComponentLightingView>;
  /** The component layers for the car's interior front seat states */
  interiorFrontSeats?: Maybe<TopViewComponentLightingView>;
  /** The component layers for the car's interior IP states */
  interiorIP?: Maybe<TopViewComponentLightingView>;
  /** The component layers for the car's interior lights states */
  interiorLights?: Maybe<TopViewComponentViewGroup>;
  /** The component layers for the car's mirrors */
  mirrors?: Maybe<TopViewComponentMirrorStateViewGroup>;
  /** The component layer for the roof of the car */
  roof?: Maybe<ImageSizes>;
  /** The component layers for the car's window states */
  window?: Maybe<TopViewComponentWindowStateViewGroup>;
};

/** The top view component state groups */
export type TopViewComponentViewGroup = {
  /** Top view component states for the current group */
  images?: Maybe<Array<ImageSizes>>;
};

/** The component layers for the car's window states */
export type TopViewComponentWindowStateViewGroup = {
  /** The component layers for the car's window based on door states */
  doors?: Maybe<TopViewComponentDoorStateViewGroup>;
  /** The component layers for the car's roof window */
  roof?: Maybe<ImageSizes>;
};

/** The Top view component layers for door states */
export type TopViewDoorState = {
  /** The component layers for the closed door */
  closed?: Maybe<ImageSizes>;
  /** The component layers for the open door */
  open?: Maybe<ImageSizes>;
};

/** The Top view component layers for door states of a car */
export type TopViewDoorStateViewGroup = {
  /** The component layers for front door states */
  front?: Maybe<TopViewDoorState>;
  /** The component layers for rear door states */
  rear?: Maybe<TopViewDoorState>;
};

/** The Top view component layers for the side mirror states */
export type TopViewMirrorStateViewGroup = {
  /** The component layers for the extended side mirrors */
  extended?: Maybe<TopViewDoorState>;
  /** The component layers for the retracted side mirrors */
  retracted?: Maybe<TopViewDoorState>;
};

/** The Top views of a car */
export type TopViewViewGroup = {
  /** The complete Top views of a car */
  complete?: Maybe<TopViewCompleteViewGroup>;
  /** The top view component layers for the parts of a car */
  components?: Maybe<TopViewComponentStateViewGroup>;
};

export type TotalAggregation = {
  /** Aggregates totals payments */
  paymentPlan?: Maybe<PaymentPlanAggregation>;
};

export type TransactionPriceTax = {
  id?: Maybe<Scalars['String']['output']>;
  pretaxWithTaxes?: Maybe<PriceAmount>;
  pretaxWithTaxesExclVat?: Maybe<PriceAmount>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  taxId?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vatAmount?: Maybe<PriceAmount>;
  vatRate?: Maybe<Scalars['Float']['output']>;
};

export type TransferPriceSummary = {
  /** Price of the car */
  carPrice?: Maybe<MsrpCarPrice>;
};

export enum TransmissionType {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL = 'MANUAL'
}

/** Transmission Type Property */
export type TransmissionTypeProperty = {
  enumDescription?: Maybe<Scalars['String']['output']>;
  formatted?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<TransmissionType>;
  valueDescription?: Maybe<Scalars['String']['output']>;
};

/** Holds URl:s to tyre energy efficiency labels and metadata for compliance with the the EU energy labelling and ecodesign legislation */
export type TyreLabel = {
  /** Metadata for this tyre energy efficiency label */
  metadata: TyreLabelMetadata;
  /** The url to the tyre label image */
  url: Scalars['String']['output'];
};

/** Energy Efficiency Label metadata */
export type TyreLabelMetadata = {
  /** URL to the specific tyre on the EPREL website. */
  eprelUrl: Scalars['String']['output'];
  /** Tyre position, one of: all/front, rear, unknown */
  position: Scalars['String']['output'];
  /** Winter/snow tyre */
  winter: Scalars['Boolean']['output'];
};

export type TyreLabelResult = {
  content?: Maybe<Array<TyreLabel>>;
  delegationLog: Array<DelegationLogItem>;
  exception?: Maybe<DelegationException>;
  status: DelegationStatus;
};

export enum UnitSystem {
  IMPERIAL = 'IMPERIAL',
  METRIC = 'METRIC'
}

export type Upholstery = {
  alternativeCodes?: Maybe<Array<Scalars['String']['output']>>;
  carKey: Scalars['CarKey']['output'];
  co2Effect?: Maybe<Scalars['Boolean']['output']>;
  /** The unique (in this type) code for this component. */
  code: Scalars['String']['output'];
  componentBehavior?: Maybe<ComponentBehavior>;
  configurationStates?: Maybe<Array<Scalars['ConfigurationState']['output']>>;
  content?: Maybe<UpholsteryContent>;
  /** Features that belong to this upholstery */
  features: Array<Feature>;
  globalName?: Maybe<Scalars['String']['output']>;
  localName?: Maybe<Scalars['String']['output']>;
  packages: Array<Package>;
  previousCarKey?: Maybe<Scalars['CarKey']['output']>;
  rootState?: Maybe<Scalars['ConfigurationState']['output']>;
  state?: Maybe<Scalars['ConfigurationState']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type: CarComponentType;
  visible?: Maybe<Scalars['Boolean']['output']>;
};


export type UpholsterycontentArgs = {
  locale: Scalars['String']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum UpholsteryBaseColor {
  AMBER = 'AMBER',
  BLOND = 'BLOND',
  BLUE = 'BLUE',
  CARDAMOM = 'CARDAMOM',
  CHARCOAL = 'CHARCOAL',
  DAWN = 'DAWN',
  FOG = 'FOG',
  GREY_MELANGE = 'GREY_MELANGE',
  INDIGO = 'INDIGO',
  MAROON = 'MAROON',
  MIST = 'MIST',
  MULBERRY = 'MULBERRY',
  PINE = 'PINE',
  RED = 'RED',
  SLATE = 'SLATE',
  ZINC = 'ZINC'
}

/** Upholstery base color */
export type UpholsteryBaseColorProperty = {
  enumDescription?: Maybe<Scalars['String']['output']>;
  formatted?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<UpholsteryBaseColor>;
  valueDescription?: Maybe<Scalars['String']['output']>;
};

export type UpholsteryContent = CarComponentContent & {
  description?: Maybe<StringProperty>;
  displayName?: Maybe<StringProperty>;
  entityType?: Maybe<UpstreamEntityTypeProperty>;
  group?: Maybe<GroupProperty>;
  hex?: Maybe<StringProperty>;
  /** @deprecated Replaced by 'images' */
  image?: Maybe<ImageProperty>;
  /** Contains a collection of images. Replaces 'image' */
  images: Array<ImageProperty>;
  matchingCode?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<SystemMeta>;
  shortDescription?: Maybe<StringProperty>;
  upholsteryBaseColour?: Maybe<UpholsteryBaseColorProperty>;
  upholsteryCode: Scalars['String']['output'];
  upholsteryMaterial?: Maybe<UpholsteryMaterialProperty>;
  /** @deprecated Replaced by 'videos' */
  video?: Maybe<VideoProperty>;
  /** Contains a collection of videos. Replaces 'video' */
  videos: Array<VideoProperty>;
};

export enum UpholsteryMaterial {
  CONNECT_TEXTILE_MICROTECH = 'CONNECT_TEXTILE_MICROTECH',
  FUSION_MICROTECH_TEXTILE = 'FUSION_MICROTECH_TEXTILE',
  LEATHER = 'LEATHER',
  LEATHERETTE = 'LEATHERETTE',
  MICROTECH_TEXTILE = 'MICROTECH_TEXTILE',
  NAPPA_LEATHER = 'NAPPA_LEATHER',
  NAPPA_LEATHER_LEATHERETTE_TEXTILE = 'NAPPA_LEATHER_LEATHERETTE_TEXTILE',
  NAPPA_LEATHER_PERFORATED_NAPPA_LEATHER = 'NAPPA_LEATHER_PERFORATED_NAPPA_LEATHER',
  NAPPA_LEATHER_TEXTILE = 'NAPPA_LEATHER_TEXTILE',
  NORDICO = 'NORDICO',
  NUBUCK_TEXTILE_NAPPA_LEATHER = 'NUBUCK_TEXTILE_NAPPA_LEATHER',
  NUBUCK_TEXTILE_NAPPA_LEATHER_LEATHERETTE = 'NUBUCK_TEXTILE_NAPPA_LEATHER_LEATHERETTE',
  PIXEL_KNIT_NORDICO = 'PIXEL_KNIT_NORDICO',
  PREMIUM_TEXTILE = 'PREMIUM_TEXTILE',
  TEXTILE = 'TEXTILE',
  TEXTILE_BLEND = 'TEXTILE_BLEND',
  TEXTILE_NORDICO = 'TEXTILE_NORDICO',
  TEXTILE_VINYL = 'TEXTILE_VINYL',
  VENTILATED_NAPPA_LEATHER = 'VENTILATED_NAPPA_LEATHER',
  VENTILATED_NORDICO = 'VENTILATED_NORDICO',
  WOOL_BLEND = 'WOOL_BLEND',
  WOOL_BLEND_NORDICO = 'WOOL_BLEND_NORDICO'
}

/** Upholstery material */
export type UpholsteryMaterialProperty = {
  enumDescription?: Maybe<Scalars['String']['output']>;
  formatted?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<UpholsteryMaterial>;
  valueDescription?: Maybe<Scalars['String']['output']>;
};

export type UpholsteryResult = {
  content?: Maybe<UpholsteryContent>;
  delegationLog: Array<DelegationLogItem>;
  exception?: Maybe<DelegationException>;
  status: DelegationStatus;
};

export enum UpstreamEntityType {
  ACCESSORY = 'ACCESSORY',
  BODY = 'BODY',
  COLOUR = 'COLOUR',
  ENGINE = 'ENGINE',
  FEATURE = 'FEATURE',
  GEARBOX = 'GEARBOX',
  LOCAL_OPTION = 'LOCAL_OPTION',
  MARKETING_CODE = 'MARKETING_CODE',
  MODEL = 'MODEL',
  OPTION = 'OPTION',
  PACKAGE = 'PACKAGE',
  PNO12 = 'PNO12',
  SALES_VERSION = 'SALES_VERSION',
  SMESSAGE = 'SMESSAGE',
  STEERING = 'STEERING',
  UPHOLSTERY = 'UPHOLSTERY'
}

/** Upstream Entity Type Property */
export type UpstreamEntityTypeProperty = {
  enumDescription?: Maybe<Scalars['String']['output']>;
  formatted?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<UpstreamEntityType>;
  valueDescription?: Maybe<Scalars['String']['output']>;
};

export type ValueAndAmount = {
  amount: Scalars['Int']['output'];
  value: Scalars['StrOrFloat']['output'];
};

export type ValueProfile = {
  axleTrackFront: Scalars['Int']['output'];
  axleTrackRear: Scalars['Int']['output'];
  color: Scalars['String']['output'];
  electricRangeInKm: Scalars['Int']['output'];
  fuelType?: Maybe<Scalars['String']['output']>;
  gearboxType: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  length: Scalars['Int']['output'];
  massOfVehicleRunningOrder: Scalars['Int']['output'];
  modelYear: Scalars['Int']['output'];
  numberOfSeats: Scalars['Int']['output'];
  platformTypeDescription: Scalars['String']['output'];
  powerInKw: Scalars['Int']['output'];
  poweredAxles: Scalars['Int']['output'];
  salesVersionValue: Scalars['Float']['output'];
  wheelBase: Scalars['Int']['output'];
  wheelSize: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type VariableReference = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** A built or ordered car */
export type Vehicle = {
  /** The built or ordered car */
  car: Car;
  /** The car's factory order number */
  fyon?: Maybe<Scalars['String']['output']>;
  /** The market the car, once built, belongs to in CDB */
  market?: Maybe<Scalars['String']['output']>;
  /** The vehicle registration number assigned to the car */
  registration?: Maybe<Scalars['String']['output']>;
  /** The vehicle identification number assigned to the car */
  vin?: Maybe<Scalars['String']['output']>;
};

export type VehicleSpecification = {
  carKey: Scalars['GoxCarKey']['output'];
  carType?: Maybe<CarTypeResult>;
  certificates?: Maybe<CocCertificateResult>;
  colour?: Maybe<ColourResult>;
  comparedTo?: Maybe<ComparedToResult>;
  contentKey: Array<Scalars['ContentKey']['output']>;
  deliveryMetadata?: Maybe<DeliveryMetadataResult>;
  driveline?: Maybe<DrivelineResult>;
  engine?: Maybe<EngineResult>;
  featureCodes?: Maybe<FeatureCodeResult>;
  featureScores?: Maybe<FeatureScores>;
  features?: Maybe<FeatureResult>;
  gearbox?: Maybe<GearboxResult>;
  goxCar: Car;
  goxCarInterface?: Maybe<gox_Car>;
  gripVehicleData?: Maybe<GRIP_VehicleData>;
  /** @deprecated Use `inference` query instead. */
  infer?: Maybe<InferenceResult>;
  inference?: Maybe<Array<Maybe<Inference>>>;
  level?: Maybe<SalesLevelResult>;
  linearAnalytics?: Maybe<AnalyticsResult>;
  locale: Scalars['String']['output'];
  media?: Maybe<MediaResult>;
  model?: Maybe<SalesLevelResult>;
  modelFamily?: Maybe<SalesLevelResult>;
  options?: Maybe<OptionResult>;
  packages?: Maybe<PackageResult>;
  priceAdjustment?: Maybe<AdjustedPrice>;
  priceSummary?: Maybe<CarPriceSummaryResult>;
  productLine?: Maybe<SalesLevelResult>;
  safetyRating?: Maybe<SafetyRatingResult>;
  similarCarsCurrentlyPublished?: Maybe<SimilarCarsResult>;
  similarCarsRecentlySold?: Maybe<SimilarCarsResult>;
  similarity?: Maybe<SimilarityResult>;
  temporalAnalytics?: Maybe<AnalyticsResult>;
  trim?: Maybe<SalesLevelResult>;
  trimFamily?: Maybe<SalesLevelResult>;
  tyreLabels?: Maybe<TyreLabelResult>;
  upholstery?: Maybe<UpholsteryResult>;
  valueProfile?: Maybe<ValueProfile>;
  vid?: Maybe<Scalars['String']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
  withLocaleContext: VehicleSpecification;
};


export type VehicleSpecificationcarTypeArgs = {
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationcertificatesArgs = {
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationcolourArgs = {
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationcomparedToArgs = {
  cars: Array<CarKeyInput>;
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationdeliveryMetadataArgs = {
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationdrivelineArgs = {
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationengineArgs = {
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationfeatureCodesArgs = {
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationfeaturesArgs = {
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationgearboxArgs = {
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationinferArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  modelName?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Array<InferenceProperty>>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationinferenceArgs = {
  contexts?: InputMaybe<Array<InferenceContext>>;
  modelName?: InputMaybe<Scalars['String']['input']>;
};


export type VehicleSpecificationlevelArgs = {
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationlinearAnalyticsArgs = {
  coverageStrategy?: CoverageStrategy;
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  findByType?: LikenessLevel;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  memberCoverageTreshold?: Scalars['Int']['input'];
  mergeStrategy?: InputMaybe<MergeStrategy>;
  queryType: AnalyticsLinearQueryType;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
  windowGravity?: AnalyticsLinearWindowGravity;
  windowSize?: Scalars['Int']['input'];
};


export type VehicleSpecificationmediaArgs = {
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationmodelArgs = {
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationmodelFamilyArgs = {
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationoptionsArgs = {
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationpackagesArgs = {
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationpriceAdjustmentArgs = {
  retailerBranchcode?: InputMaybe<Scalars['String']['input']>;
};


export type VehicleSpecificationpriceSummaryArgs = {
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationproductLineArgs = {
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationsafetyRatingArgs = {
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationsimilarCarsCurrentlyPublishedArgs = {
  coverageStrategy?: CoverageStrategy;
  coverageTreshold?: InputMaybe<Scalars['Int']['input']>;
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  findByType?: LikenessLevel;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  priceSimilaritySort?: InputMaybe<Scalars['Int']['input']>;
  requireMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  resultsLimit?: InputMaybe<Scalars['Int']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationsimilarCarsRecentlySoldArgs = {
  coverageStrategy?: CoverageStrategy;
  coverageTreshold?: InputMaybe<Scalars['Int']['input']>;
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  findByType?: LikenessLevel;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  priceSimilaritySort?: InputMaybe<Scalars['Int']['input']>;
  requireMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  resultsLimit?: InputMaybe<Scalars['Int']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationsimilarityArgs = {
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  fltr?: InputMaybe<Array<Filter>>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationtemporalAnalyticsArgs = {
  coverageStrategy?: CoverageStrategy;
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  findByType?: LikenessLevel;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  memberCoverageTreshold?: Scalars['Int']['input'];
  mergeStrategy?: InputMaybe<MergeStrategy>;
  queryType: AnalyticsTemporalQueryType;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
  windowGravity?: AnalyticsTemporalWindowGravity;
  windowSize?: Scalars['Int']['input'];
};


export type VehicleSpecificationtrimArgs = {
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationtrimFamilyArgs = {
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationtyreLabelsArgs = {
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationupholsteryArgs = {
  delegationStrategy?: InputMaybe<DelegationStrategy>;
  keyPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  mergeStrategy?: InputMaybe<MergeStrategy>;
  requiredSelection?: InputMaybe<Scalars['String']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
  servicePriority?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type VehicleSpecificationwithLocaleContextArgs = {
  locale: Scalars['String']['input'];
};

/** Video Property */
export type VideoProperty = MediaProperty & {
  /** label describing value */
  label?: Maybe<Scalars['String']['output']>;
  mediaKey?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<MediaType>;
  url: Scalars['String']['output'];
};

/** The interior and exterior views of a car */
export type Views = {
  /** The views featuring a car's exterior */
  exterior: ExteriorViewGroup;
  /** The views featuring a car's interior */
  interior: InteriorViewGroup;
};

/** The visualization of a given configuration/specification */
export type Visualization = {
  /** The features visualized in this combination */
  features?: Maybe<VisualizedFeatures>;
  /** The image galleries available */
  galleries: GalleryGroup;
  /** The icons for the different types of visualized features */
  icons?: Maybe<Icons>;
  /** The different views available */
  views: Views;
};


/** The visualization of a given configuration/specification */
export type VisualizationgalleriesArgs = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
};


/** The visualization of a given configuration/specification */
export type VisualizationiconsArgs = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
};


/** The visualization of a given configuration/specification */
export type VisualizationviewsArgs = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
};

/** A mapping between a CAS feature type, and a feature code */
export type VisualizedFeature = {
  /** The type of feature, according to CAS, that is included in the visualization */
  casType?: Maybe<CASFeatureType>;
  /** The feature code being visualized */
  code: Scalars['String']['output'];
};

/** The features beings visualized in the current visualization set */
export type VisualizedFeatures = {
  /** The features included in this visualization set. */
  included: Array<VisualizedFeature>;
  /** The features visualized that only exist in this visualization set. */
  unique?: Maybe<Array<VisualizedFeature>>;
};

export type WholesalePriceSummary = {
  /** Price of the car */
  carPrice?: Maybe<MsrpCarPrice>;
};

export type errorMessage = {
  errorCode?: Maybe<Scalars['String']['output']>;
  errorEfficiencyClass?: Maybe<Scalars['String']['output']>;
  errorEfficiencyClassBest?: Maybe<Scalars['String']['output']>;
  errorEfficiencyClassWorst?: Maybe<Scalars['String']['output']>;
};

export type gox_Car = {
  carKey: Scalars['GoxCarKey']['output'];
};

export type CarSpecByLicensePlateQueryVariables = Exact<{
  licensePlate: Array<Scalars['String']['input']> | Scalars['String']['input'];
  noOfKilometers: Scalars['InferencePropertyValue']['input'];
  extraMonthsAhead?: InputMaybe<Scalars['InferencePropertyValue']['input']>;
  isInitialQuery: Scalars['Boolean']['input'];
}>;


export type CarSpecByLicensePlateQuery = { car: Array<{ vid?: string | null, carKey: any, vin?: string | null, deliveryMetadata?: { content?: { deliveryDate?: string | null } | null } | null, media?: { content?: Array<{ views: { exterior: { studio?: { left?: { sizes?: { large?: { url?: string | null } | null, small?: { url?: string | null } | null } | null } | null, right?: { sizes?: { default: { url?: string | null }, small?: { url?: string | null } | null } | null } | null } | null } } }> | null } | null, modelFamily?: { content?: { displayName?: { value?: string | null } | null } | null } | null, model?: { content?: { displayName?: { value?: string | null } | null } | null } | null, engine?: { content?: { displayName?: { value?: string | null } | null, engineType?: { value?: EngineType | null, formatted?: string | null } | null, fuelType?: { formatted?: string | null, value?: FuelType | null } | null } | null } | null, trim?: { content?: { displayName?: { value?: string | null } | null } | null } | null, colour?: { content?: { displayName?: { value?: string | null } | null } | null } | null, gearbox?: { content?: { displayName?: { value?: string | null } | null } | null } | null, driveline?: { content?: { driveType?: { formatted?: string | null } | null, transmissionType?: { formatted?: string | null } | null } | null } | null, upholstery?: { content?: { upholsteryCode: string, upholsteryMaterial?: { formatted?: string | null } | null } | null } | null, features?: { content?: Array<{ displayName?: { value?: string | null } | null }> | null } | null, options?: { content?: Array<{ matchingCode: string, displayName?: { value?: string | null } | null }> | null } | null, packages?: { content?: Array<{ packageCode: string, displayName?: { value?: string | null } | null }> | null } | null, inference?: Array<{ id?: string | null, model: string, outputs: Array<{ name: string, value: any }>, inputs: Array<{ name: string, value: any }>, reliability?: { isReliable: boolean, status: InferenceReliabilityStatus, resultBreakdown: Array<{ name: string, status?: InferenceReliabilityStatus | null }> } | null } | null> | null } | null> };

export type CarSpecByVinQueryVariables = Exact<{
  vin: Array<Scalars['String']['input']> | Scalars['String']['input'];
  noOfKilometers: Scalars['InferencePropertyValue']['input'];
  extraMonthsAhead?: InputMaybe<Scalars['InferencePropertyValue']['input']>;
  isInitialQuery: Scalars['Boolean']['input'];
}>;


export type CarSpecByVinQuery = { car: Array<{ vid?: string | null, carKey: any, vin?: string | null, deliveryMetadata?: { content?: { deliveryDate?: string | null } | null } | null, media?: { content?: Array<{ views: { exterior: { studio?: { left?: { sizes?: { large?: { url?: string | null } | null, small?: { url?: string | null } | null } | null } | null, right?: { sizes?: { default: { url?: string | null }, small?: { url?: string | null } | null } | null } | null } | null } } }> | null } | null, modelFamily?: { content?: { displayName?: { value?: string | null } | null } | null } | null, model?: { content?: { displayName?: { value?: string | null } | null } | null } | null, engine?: { content?: { displayName?: { value?: string | null } | null, engineType?: { value?: EngineType | null, formatted?: string | null } | null, fuelType?: { formatted?: string | null, value?: FuelType | null } | null } | null } | null, trim?: { content?: { displayName?: { value?: string | null } | null } | null } | null, colour?: { content?: { displayName?: { value?: string | null } | null } | null } | null, gearbox?: { content?: { displayName?: { value?: string | null } | null } | null } | null, driveline?: { content?: { driveType?: { formatted?: string | null } | null, transmissionType?: { formatted?: string | null } | null } | null } | null, upholstery?: { content?: { upholsteryCode: string, upholsteryMaterial?: { formatted?: string | null } | null } | null } | null, features?: { content?: Array<{ displayName?: { value?: string | null } | null }> | null } | null, options?: { content?: Array<{ matchingCode: string, displayName?: { value?: string | null } | null }> | null } | null, packages?: { content?: Array<{ packageCode: string, displayName?: { value?: string | null } | null }> | null } | null, inference?: Array<{ id?: string | null, model: string, outputs: Array<{ name: string, value: any }>, inputs: Array<{ name: string, value: any }>, reliability?: { isReliable: boolean, status: InferenceReliabilityStatus, resultBreakdown: Array<{ name: string, status?: InferenceReliabilityStatus | null }> } | null } | null> | null } | null> };

export type FutureValuationByLicensePlateQueryVariables = Exact<{
  licensePlate: Array<Scalars['String']['input']> | Scalars['String']['input'];
  noOfKilometers: Scalars['InferencePropertyValue']['input'];
  extraMonthsAhead: Scalars['InferencePropertyValue']['input'];
}>;


export type FutureValuationByLicensePlateQuery = { car: Array<{ vid?: string | null, vin?: string | null, deliveryMetadata?: { content?: { deliveryDate?: string | null } | null } | null, inference?: Array<{ id?: string | null, model: string, outputs: Array<{ name: string, value: any }>, inputs: Array<{ name: string, value: any }>, reliability?: { isReliable: boolean, status: InferenceReliabilityStatus, resultBreakdown: Array<{ name: string, status?: InferenceReliabilityStatus | null }> } | null } | null> | null } | null> };

export type FutureValuationByVinQueryVariables = Exact<{
  vin: Array<Scalars['String']['input']> | Scalars['String']['input'];
  noOfKilometers: Scalars['InferencePropertyValue']['input'];
  extraMonthsAhead: Scalars['InferencePropertyValue']['input'];
}>;


export type FutureValuationByVinQuery = { car: Array<{ vid?: string | null, vin?: string | null, deliveryMetadata?: { content?: { deliveryDate?: string | null } | null } | null, inference?: Array<{ id?: string | null, model: string, outputs: Array<{ name: string, value: any }>, inputs: Array<{ name: string, value: any }>, reliability?: { isReliable: boolean, status: InferenceReliabilityStatus, resultBreakdown: Array<{ name: string, status?: InferenceReliabilityStatus | null }> } | null } | null> | null } | null> };

export type MarketInsightsByLicensePlaceQueryVariables = Exact<{
  licensePlate: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type MarketInsightsByLicensePlaceQuery = { car: Array<{ vin?: string | null, similarCarsCurrentlyPublished?: { content?: { coverage: Coverage, likenessLevel: LikenessLevel, items: Array<{ vid: string, findBySimilarity?: number | null, classifiedPrice: number, modelYear: number, odometerStatusKm: number, classifiedPublishedDate: string, retailerName?: string | null, meta?: { displayName?: string | null, fetchedDate: string, thumbnailImage?: string | null } | null }> } | null } | null, similarCarsRecentlySold?: { content?: { coverage: Coverage, likenessLevel: LikenessLevel, items: Array<{ vid: string, findBySimilarity?: number | null, classifiedPrice: number, modelYear: number, odometerStatusKm: number, classifiedPublishedDate: string, retailerName?: string | null, salesInformation?: { daysBeforeSale?: number | null, salesDate: string } | null, meta?: { displayName?: string | null, fetchedDate: string, thumbnailImage?: string | null } | null }> } | null } | null, classifiedPricePerSalesQuarter?: { content?: { likenessLevel: LikenessLevel, likenessMatch: string, valueUnit: string, windowedDataset: { coverage: Coverage, datapoints: Array<{ label: string, value: number, warning: AnalyticsDatapointWarning, memberCount: number }> } } | null } | null, turnoverRatePerMonth?: { content?: { likenessLevel: LikenessLevel, likenessMatch: string, valueUnit: string, windowedDataset: { coverage: Coverage, datapoints: Array<{ label: string, value: number, warning: AnalyticsDatapointWarning, memberCount: number }> } } | null } | null } | null> };

export type MarketInsightsByVinQueryVariables = Exact<{
  vin: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type MarketInsightsByVinQuery = { car: Array<{ vin?: string | null, similarCarsCurrentlyPublished?: { content?: { coverage: Coverage, likenessLevel: LikenessLevel, items: Array<{ vid: string, findBySimilarity?: number | null, classifiedPrice: number, modelYear: number, odometerStatusKm: number, classifiedPublishedDate: string, retailerName?: string | null, meta?: { displayName?: string | null, fetchedDate: string, thumbnailImage?: string | null } | null }> } | null } | null, similarCarsRecentlySold?: { content?: { coverage: Coverage, likenessLevel: LikenessLevel, items: Array<{ vid: string, findBySimilarity?: number | null, classifiedPrice: number, modelYear: number, odometerStatusKm: number, classifiedPublishedDate: string, retailerName?: string | null, salesInformation?: { daysBeforeSale?: number | null, salesDate: string } | null, meta?: { displayName?: string | null, fetchedDate: string, thumbnailImage?: string | null } | null }> } | null } | null, classifiedPricePerSalesQuarter?: { content?: { likenessLevel: LikenessLevel, likenessMatch: string, valueUnit: string, windowedDataset: { coverage: Coverage, datapoints: Array<{ label: string, value: number, warning: AnalyticsDatapointWarning, memberCount: number }> } } | null } | null, turnoverRatePerMonth?: { content?: { likenessLevel: LikenessLevel, likenessMatch: string, valueUnit: string, windowedDataset: { coverage: Coverage, datapoints: Array<{ label: string, value: number, warning: AnalyticsDatapointWarning, memberCount: number }> } } | null } | null } | null> };

export type CarSpecByVidQueryVariables = Exact<{
  vid: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CarSpecByVidQuery = { specificationByVid: Array<{ vid?: string | null, carKey: any, vin?: string | null, deliveryMetadata?: { content?: { deliveryDate?: string | null } | null } | null, media?: { content?: Array<{ views: { exterior: { studio?: { left?: { sizes?: { large?: { url?: string | null } | null, small?: { url?: string | null } | null } | null } | null, right?: { sizes?: { default: { url?: string | null }, small?: { url?: string | null } | null } | null } | null } | null } } }> | null } | null, modelFamily?: { content?: { displayName?: { value?: string | null } | null } | null } | null, model?: { content?: { displayName?: { value?: string | null } | null } | null } | null, engine?: { content?: { displayName?: { value?: string | null } | null, engineType?: { value?: EngineType | null, formatted?: string | null } | null, fuelType?: { formatted?: string | null, value?: FuelType | null } | null } | null } | null, trim?: { content?: { displayName?: { value?: string | null } | null } | null } | null, colour?: { content?: { displayName?: { value?: string | null } | null } | null } | null, gearbox?: { content?: { displayName?: { value?: string | null } | null } | null } | null, driveline?: { content?: { driveType?: { formatted?: string | null } | null, transmissionType?: { formatted?: string | null } | null } | null } | null, upholstery?: { content?: { upholsteryCode: string, upholsteryMaterial?: { formatted?: string | null } | null } | null } | null, features?: { content?: Array<{ displayName?: { value?: string | null } | null }> | null } | null, options?: { content?: Array<{ matchingCode: string, displayName?: { value?: string | null } | null }> | null } | null, packages?: { content?: Array<{ packageCode: string, displayName?: { value?: string | null } | null }> | null } | null } | null> };

export type CarSpecFragment = { vid?: string | null, carKey: any, vin?: string | null, deliveryMetadata?: { content?: { deliveryDate?: string | null } | null } | null, media?: { content?: Array<{ views: { exterior: { studio?: { left?: { sizes?: { large?: { url?: string | null } | null, small?: { url?: string | null } | null } | null } | null, right?: { sizes?: { default: { url?: string | null }, small?: { url?: string | null } | null } | null } | null } | null } } }> | null } | null, modelFamily?: { content?: { displayName?: { value?: string | null } | null } | null } | null, model?: { content?: { displayName?: { value?: string | null } | null } | null } | null, engine?: { content?: { displayName?: { value?: string | null } | null, engineType?: { value?: EngineType | null, formatted?: string | null } | null, fuelType?: { formatted?: string | null, value?: FuelType | null } | null } | null } | null, trim?: { content?: { displayName?: { value?: string | null } | null } | null } | null, colour?: { content?: { displayName?: { value?: string | null } | null } | null } | null, gearbox?: { content?: { displayName?: { value?: string | null } | null } | null } | null, driveline?: { content?: { driveType?: { formatted?: string | null } | null, transmissionType?: { formatted?: string | null } | null } | null } | null, upholstery?: { content?: { upholsteryCode: string, upholsteryMaterial?: { formatted?: string | null } | null } | null } | null, features?: { content?: Array<{ displayName?: { value?: string | null } | null }> | null } | null, options?: { content?: Array<{ matchingCode: string, displayName?: { value?: string | null } | null }> | null } | null, packages?: { content?: Array<{ packageCode: string, displayName?: { value?: string | null } | null }> | null } | null };

export type SimilarCarFragment = { vid: string, findBySimilarity?: number | null, classifiedPrice: number, modelYear: number, odometerStatusKm: number, classifiedPublishedDate: string, retailerName?: string | null, meta?: { displayName?: string | null, fetchedDate: string, thumbnailImage?: string | null } | null };

export type SimilarCarSoldFragment = { vid: string, findBySimilarity?: number | null, classifiedPrice: number, modelYear: number, odometerStatusKm: number, classifiedPublishedDate: string, retailerName?: string | null, salesInformation?: { daysBeforeSale?: number | null, salesDate: string } | null, meta?: { displayName?: string | null, fetchedDate: string, thumbnailImage?: string | null } | null };

export type DataPointFragment = { label: string, value: number, warning: AnalyticsDatapointWarning, memberCount: number };

export type MarketInsightsFragment = { similarCarsCurrentlyPublished?: { content?: { coverage: Coverage, likenessLevel: LikenessLevel, items: Array<{ vid: string, findBySimilarity?: number | null, classifiedPrice: number, modelYear: number, odometerStatusKm: number, classifiedPublishedDate: string, retailerName?: string | null, meta?: { displayName?: string | null, fetchedDate: string, thumbnailImage?: string | null } | null }> } | null } | null, similarCarsRecentlySold?: { content?: { coverage: Coverage, likenessLevel: LikenessLevel, items: Array<{ vid: string, findBySimilarity?: number | null, classifiedPrice: number, modelYear: number, odometerStatusKm: number, classifiedPublishedDate: string, retailerName?: string | null, salesInformation?: { daysBeforeSale?: number | null, salesDate: string } | null, meta?: { displayName?: string | null, fetchedDate: string, thumbnailImage?: string | null } | null }> } | null } | null, classifiedPricePerSalesQuarter?: { content?: { likenessLevel: LikenessLevel, likenessMatch: string, valueUnit: string, windowedDataset: { coverage: Coverage, datapoints: Array<{ label: string, value: number, warning: AnalyticsDatapointWarning, memberCount: number }> } } | null } | null, turnoverRatePerMonth?: { content?: { likenessLevel: LikenessLevel, likenessMatch: string, valueUnit: string, windowedDataset: { coverage: Coverage, datapoints: Array<{ label: string, value: number, warning: AnalyticsDatapointWarning, memberCount: number }> } } | null } | null };

export type ValuationFragment = { vid?: string | null, vin?: string | null, deliveryMetadata?: { content?: { deliveryDate?: string | null } | null } | null, inference?: Array<{ id?: string | null, model: string, outputs: Array<{ name: string, value: any }>, inputs: Array<{ name: string, value: any }>, reliability?: { isReliable: boolean, status: InferenceReliabilityStatus, resultBreakdown: Array<{ name: string, status?: InferenceReliabilityStatus | null }> } | null } | null> | null };
